import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   * 
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
  /**
   * 
   *     Errors messages and codes mapped to
   *     fields or non fields errors.
   *     Example:
   *     {
   *         field_name: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         other_field: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         nonFieldErrors: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ]
   *     }
   *     
   */
  ExpectedErrorType: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
};

export type Query = {
  __typename?: 'Query';
  allPrograms?: Maybe<Array<Maybe<ProgramType>>>;
  healthCheckData?: Maybe<HealthCheckData>;
  configurationsJson?: Maybe<Scalars['JSONString']>;
  templateCsv?: Maybe<Scalars['String']>;
  listOfScheduledEvents?: Maybe<Array<Maybe<CalendlyEventType>>>;
  userAnswers?: Maybe<ProgramApplicationAnswerType>;
  ninjaWizardData?: Maybe<FaqNinjaWizardType>;
  scheduledEvent?: Maybe<CalendlyEventType>;
  potentialUserApplication?: Maybe<PotentialUserType>;
  addressDetails?: Maybe<AddressDetails>;
  addressAutocomplete?: Maybe<Array<Maybe<AddressAutocomplete>>>;
  adminLogs?: Maybe<Array<LogType>>;
  selectedBenefits?: Maybe<Array<Maybe<BenefitSelectedType>>>;
  benefitsAnswers?: Maybe<Array<Maybe<BenefitAnswerType>>>;
  countHouseholdMembers?: Maybe<Scalars['Float']>;
  adminNotes?: Maybe<Array<NoteType>>;
  listOfUploadedDocuments?: Maybe<Scalars['ID']>;
  listOfUploadedDocumentsIncludingName?: Maybe<Array<Maybe<DocumentType>>>;
  coordinates?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']>>>>>;
  userCoordinates?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']>>>>>;
  document?: Maybe<DocumentData>;
  cardBalance?: Maybe<Scalars['Float']>;
  program?: Maybe<ProgramType>;
  organization?: Maybe<OrganizationType>;
  organizationConfigs?: Maybe<OrganizationConfigsType>;
  documentRequirement?: Maybe<Array<Maybe<DocumentRequireType>>>;
  programs?: Maybe<Array<Maybe<ProgramType>>>;
  policyEngineData?: Maybe<PolicyEngineType>;
  onboardingLogos?: Maybe<Array<Maybe<OnboardingLogosType>>>;
  styles?: Maybe<StylesType>;
  translations?: Maybe<Scalars['JSONString']>;
  allUpcomingScheduledPayments?: Maybe<Array<Maybe<ScheduledPaymentType>>>;
  myUpcomingPayment?: Maybe<ScheduledPaymentType>;
  myRecentPayments?: Maybe<Array<Maybe<PaymentType>>>;
  notSignedUpPotentialUsers?: Maybe<PotentialUserTypeConnection>;
  potentialUserWithHashedId?: Maybe<PotentialUserType>;
  potentialUsers?: Maybe<PotentialUserTypeConnection>;
  potentialUsersForOnboardingNotifications?: Maybe<Array<Maybe<PotentialUserType>>>;
  applicationsByField?: Maybe<Array<Maybe<ApplicationSummaryItem>>>;
  applicationsLastDays?: Maybe<Array<Maybe<ApplicationsByDayResponse>>>;
  surveySummary?: Maybe<SurveySummary>;
  me?: Maybe<UserType>;
  user?: Maybe<UserType>;
  codeValidation?: Maybe<InviteCodeValidationQueryResponse>;
  userSearch?: Maybe<UserTypeConnection>;
  surveyAvailable?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<UserType>>>;
};


export type QueryHealthCheckDataArgs = {
  programId?: Maybe<Scalars['ID']>;
};


export type QueryListOfScheduledEventsArgs = {
  potentialUserIdList?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export type QueryUserAnswersArgs = {
  id?: Maybe<Scalars['ID']>;
  forType?: Maybe<Scalars['String']>;
};


export type QueryNinjaWizardDataArgs = {
  language?: Maybe<Scalars['String']>;
};


export type QueryScheduledEventArgs = {
  potentialUserId?: Maybe<Scalars['ID']>;
};


export type QueryPotentialUserApplicationArgs = {
  inviteCode?: Maybe<Scalars['String']>;
  verificationCode?: Maybe<Scalars['String']>;
};


export type QueryAddressDetailsArgs = {
  placeId?: Maybe<Scalars['String']>;
};


export type QueryAddressAutocompleteArgs = {
  value?: Maybe<Scalars['String']>;
};


export type QueryAdminLogsArgs = {
  potentialUser?: Maybe<Scalars['ID']>;
};


export type QuerySelectedBenefitsArgs = {
  potentialUserId?: Maybe<Scalars['ID']>;
};


export type QueryBenefitsAnswersArgs = {
  potentialUserId?: Maybe<Scalars['ID']>;
};


export type QueryCountHouseholdMembersArgs = {
  potentialUserId?: Maybe<Scalars['ID']>;
};


export type QueryAdminNotesArgs = {
  potentialUser?: Maybe<Scalars['ID']>;
};


export type QueryListOfUploadedDocumentsArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryListOfUploadedDocumentsIncludingNameArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryCoordinatesArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryUserCoordinatesArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryDocumentArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryCardBalanceArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryPolicyEngineDataArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryOnboardingLogosArgs = {
  id: Scalars['ID'];
};


export type QueryNotSignedUpPotentialUsersArgs = {
  id?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['JSONString']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  inviteCode_Isnull?: Maybe<Scalars['Boolean']>;
  selectedFor_Isnull?: Maybe<Scalars['Boolean']>;
  applicationStatus?: Maybe<Scalars['String']>;
  applicationStatus_Contains?: Maybe<Scalars['String']>;
  applicationStatus_Isnull?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  invitationSent?: Maybe<Scalars['DateTime']>;
  invitationSent_Isnull?: Maybe<Scalars['Boolean']>;
  assignedAdmin?: Maybe<Scalars['ID']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryPotentialUserWithHashedIdArgs = {
  hashedId?: Maybe<Scalars['String']>;
};


export type QueryPotentialUsersArgs = {
  id?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['JSONString']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  inviteCode_Isnull?: Maybe<Scalars['Boolean']>;
  selectedFor_Isnull?: Maybe<Scalars['Boolean']>;
  applicationStatus?: Maybe<Scalars['String']>;
  applicationStatus_Contains?: Maybe<Scalars['String']>;
  applicationStatus_Isnull?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  invitationSent?: Maybe<Scalars['DateTime']>;
  invitationSent_Isnull?: Maybe<Scalars['Boolean']>;
  assignedAdmin?: Maybe<Scalars['ID']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryPotentialUsersForOnboardingNotificationsArgs = {
  id?: Maybe<Scalars['ID']>;
  reminder?: Maybe<Scalars['Boolean']>;
};


export type QueryApplicationsByFieldArgs = {
  programId?: Maybe<Scalars['Int']>;
  fieldName?: Maybe<Scalars['String']>;
};


export type QueryApplicationsLastDaysArgs = {
  programId?: Maybe<Scalars['Int']>;
  days?: Maybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id?: Maybe<Scalars['ID']>;
  cacheType?: Maybe<Scalars['String']>;
};


export type QueryCodeValidationArgs = {
  inviteCode?: Maybe<Scalars['String']>;
  resetToken?: Maybe<Scalars['String']>;
  verificationCode?: Maybe<Scalars['String']>;
};


export type QueryUserSearchArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  firstName_Icontains?: Maybe<Scalars['String']>;
  lastName_Icontains?: Maybe<Scalars['String']>;
  email_Icontains?: Maybe<Scalars['String']>;
  phoneNumber_Icontains?: Maybe<Scalars['String']>;
};

export type ProgramType = Node & {
  __typename?: 'ProgramType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  paymentFrequency: ProgramPaymentFrequency;
  numberOfMonths?: Maybe<Scalars['Float']>;
  numberOfPayments?: Maybe<Scalars['Float']>;
  paymentAmount: Scalars['Float'];
  isActiveProgram: Scalars['Boolean'];
  urlFragment: Scalars['String'];
  applicationStartDate: Scalars['DateTime'];
  applicationEndDate: Scalars['DateTime'];
  reportEmail?: Maybe<Scalars['String']>;
  applicationHouseholdIncome?: Maybe<Scalars['Float']>;
  applicationHouseholdIncomeThreshold?: Maybe<Scalars['Float']>;
  programDuration: Scalars['JSONString'];
  organization: OrganizationType;
  ssiBenefitsWizardEnabled: Scalars['Boolean'];
  addressAutocompleteLocationRestriction?: Maybe<Scalars['String']>;
  potentialUsers: PotentialUserTypeConnection;
  users: UserTypeConnection;
  documentRequirement: DocumentRequireTypeConnection;
  onboardingLogos: OnboardingLogosTypeConnection;
  programStyles: StylesTypeConnection;
  payments: PaymentTypeConnection;
  scheduledPayments: ScheduledPaymentTypeConnection;
  pk?: Maybe<Scalars['Int']>;
};


export type ProgramTypePotentialUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProgramTypeUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  firstName_Icontains?: Maybe<Scalars['String']>;
  lastName_Icontains?: Maybe<Scalars['String']>;
  email_Icontains?: Maybe<Scalars['String']>;
  phoneNumber_Icontains?: Maybe<Scalars['String']>;
};


export type ProgramTypeDocumentRequirementArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProgramTypeOnboardingLogosArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProgramTypeProgramStylesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProgramTypePaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProgramTypeScheduledPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};


/** An enumeration. */
export enum ProgramPaymentFrequency {
  /** Bimonthly */
  Bimonthly = 'BIMONTHLY',
  /** Yearly */
  Yearly = 'YEARLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Other */
  Other = 'OTHER'
}


export type OrganizationType = Node & {
  __typename?: 'OrganizationType';
  name: Scalars['String'];
  webAppUrl: Scalars['String'];
  version: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type PotentialUserTypeConnection = {
  __typename?: 'PotentialUserTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PotentialUserTypeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
  edgeCount?: Maybe<Scalars['Int']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

/** A Relay edge containing a `PotentialUserType` and its cursor. */
export type PotentialUserTypeEdge = {
  __typename?: 'PotentialUserTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<PotentialUserType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type PotentialUserType = Node & {
  __typename?: 'PotentialUserType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  researchId?: Maybe<Scalars['String']>;
  cbo?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  inviteCode?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  paymentFrequencyType: PotentialUserPaymentFrequencyType;
  startDate: Scalars['DateTime'];
  paymentAmount: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  onboardingNotificationSent?: Maybe<Scalars['DateTime']>;
  onboardingReminderNotificationSent?: Maybe<Scalars['DateTime']>;
  addressLat?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  hyperwalletToken?: Maybe<Scalars['String']>;
  isTestUser: Scalars['Boolean'];
  isSuperuser: Scalars['Boolean'];
  resetUserOnLogout: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  numberOfMonths?: Maybe<Scalars['Float']>;
  numberOfPayments?: Maybe<Scalars['Float']>;
  organization?: Maybe<OrganizationType>;
  program?: Maybe<ProgramType>;
  medianHouseholdIncome?: Maybe<Scalars['Float']>;
  applicationStatus?: Maybe<PotentialUserApplicationStatus>;
  requestedBenefitsCounseling?: Maybe<Scalars['DateTime']>;
  ethnicity?: Maybe<Scalars['String']>;
  blindDisabled?: Maybe<Scalars['Boolean']>;
  tractCode?: Maybe<Scalars['String']>;
  isLocked: Scalars['Boolean'];
  gender?: Maybe<Scalars['String']>;
  selectedFor?: Maybe<Scalars['String']>;
  reachedVerifyScreen: Scalars['Boolean'];
  assignedAdmin?: Maybe<UserType>;
  verifyInvitationSent?: Maybe<Scalars['DateTime']>;
  verifyInvitationReminderSent?: Maybe<Scalars['DateTime']>;
  invitationSent?: Maybe<Scalars['DateTime']>;
  invitationReminderSent?: Maybe<Scalars['DateTime']>;
  intercomKey?: Maybe<Scalars['String']>;
  user: UserTypeConnection;
  householdMembers: Array<HouseholdMemberType>;
  flags: PotentialUserFlagTypeConnection;
  flagsPotentialUser: PotentialUserFlagTypeConnection;
  note: Array<NoteType>;
  answers: ProgramApplicationAnswerTypeConnection;
  documents: DocumentTypeConnection;
  ssiBenefitAnswers: BenefitAnswerTypeConnection;
  selectedBenefits: BenefitSelectedTypeConnection;
  policyEngine: Array<PolicyEngineType>;
  scheduledPayments: ScheduledPaymentTypeConnection;
  pk?: Maybe<Scalars['Int']>;
  filter?: Maybe<Scalars['String']>;
};


export type PotentialUserTypeUserArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  firstName_Icontains?: Maybe<Scalars['String']>;
  lastName_Icontains?: Maybe<Scalars['String']>;
  email_Icontains?: Maybe<Scalars['String']>;
  phoneNumber_Icontains?: Maybe<Scalars['String']>;
};


export type PotentialUserTypeFlagsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PotentialUserTypeFlagsPotentialUserArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PotentialUserTypeAnswersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PotentialUserTypeDocumentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PotentialUserTypeSsiBenefitAnswersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PotentialUserTypeSelectedBenefitsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PotentialUserTypeScheduledPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PotentialUserPaymentFrequencyType {
  /** Bimonthly */
  Bimonthly = 'BIMONTHLY',
  /** Yearly */
  Yearly = 'YEARLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Other */
  Other = 'OTHER'
}

/** An enumeration. */
export enum PotentialUserApplicationStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Rejected */
  Rejected = 'REJECTED'
}

export type UserType = Node & {
  __typename?: 'UserType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  inviteCode: Scalars['String'];
  password: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  language: UserLanguage;
  isSuperuser: Scalars['Boolean'];
  hyperwalletToken?: Maybe<Scalars['String']>;
  usioToken?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  emailNotificationsEnabled: Scalars['Boolean'];
  smsNotificationsEnabled: Scalars['Boolean'];
  paymentFrequencyType?: Maybe<UserPaymentFrequencyType>;
  paymentAmount?: Maybe<Scalars['Float']>;
  potentialUser?: Maybe<PotentialUserType>;
  addressLat?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  researchId?: Maybe<Scalars['String']>;
  cbo?: Maybe<Scalars['String']>;
  securityQuestionQuestion: Scalars['String'];
  securityQuestionAnswer: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  program: ProgramType;
  isTestUser: Scalars['Boolean'];
  resetUserOnLogout: Scalars['Boolean'];
  invalidLoginAttempts: Scalars['Int'];
  lastLoginAttempt?: Maybe<Scalars['DateTime']>;
  organization?: Maybe<OrganizationType>;
  optedForWhatsapp?: Maybe<Scalars['Boolean']>;
  isFrozen: Scalars['Boolean'];
  logs: Array<LogType>;
  potentialUsers: PotentialUserTypeConnection;
  note: Array<NoteType>;
  verifiedDocuments: DocumentTypeConnection;
  payments: PaymentTypeConnection;
  ranPayments: PaymentTypeConnection;
  scheduledPayments: ScheduledPaymentTypeConnection;
  ranScheduledPayments: ScheduledPaymentTypeConnection;
  transferMethods: TransferMethodObjectTypeConnection;
  pk?: Maybe<Scalars['Int']>;
};


export type UserTypePotentialUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserTypeVerifiedDocumentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserTypePaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserTypeRanPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserTypeScheduledPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserTypeRanScheduledPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserTypeTransferMethodsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum UserLanguage {
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** Tagalog */
  Tl = 'TL',
  /** Khmer */
  Km = 'KM'
}

/** An enumeration. */
export enum UserPaymentFrequencyType {
  /** Bimonthly */
  Bimonthly = 'BIMONTHLY',
  /** Yearly */
  Yearly = 'YEARLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Other */
  Other = 'OTHER'
}

export type LogType = {
  __typename?: 'LogType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  user?: Maybe<UserType>;
  entityType: LogsEntityType;
  action: LogsAction;
  modelName: LogsModelName;
  modelId: Scalars['Int'];
  originalValue?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum LogsEntityType {
  /** Application Status */
  ApplicationStatus = 'APPLICATION_STATUS',
  /** Automatic Reminder */
  AutomaticReminder = 'AUTOMATIC_REMINDER',
  /** Document */
  Document = 'DOCUMENT',
  /** Flag */
  Flag = 'FLAG',
  /** User Data */
  UserData = 'USER_DATA'
}

/** An enumeration. */
export enum LogsAction {
  /** Add */
  Add = 'ADD',
  /** Send */
  Send = 'SEND',
  /** Delete */
  Delete = 'DELETE',
  /** Update */
  Update = 'UPDATE',
  /** Approve */
  Approve = 'APPROVE',
  /** Request New Document */
  RequestNewDocument = 'REQUEST_NEW_DOCUMENT'
}

/** An enumeration. */
export enum LogsModelName {
  /** Potentialuserapplication */
  Potentialuserapplication = 'POTENTIALUSERAPPLICATION'
}

export type NoteType = {
  __typename?: 'NoteType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  potentialUser: PotentialUserApplicationType;
  admin: UserType;
  note?: Maybe<Scalars['String']>;
};

export type PotentialUserApplicationType = Node & {
  __typename?: 'PotentialUserApplicationType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  researchId?: Maybe<Scalars['String']>;
  cbo?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  inviteCode?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  paymentFrequencyType: PotentialUserPaymentFrequencyType;
  startDate: Scalars['DateTime'];
  paymentAmount: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  onboardingNotificationSent?: Maybe<Scalars['DateTime']>;
  onboardingReminderNotificationSent?: Maybe<Scalars['DateTime']>;
  addressLat?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  hyperwalletToken?: Maybe<Scalars['String']>;
  isTestUser: Scalars['Boolean'];
  isSuperuser: Scalars['Boolean'];
  resetUserOnLogout: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  numberOfMonths?: Maybe<Scalars['Float']>;
  numberOfPayments?: Maybe<Scalars['Float']>;
  organization?: Maybe<OrganizationType>;
  program?: Maybe<ProgramType>;
  medianHouseholdIncome?: Maybe<Scalars['Float']>;
  applicationStatus?: Maybe<PotentialUserApplicationStatus>;
  requestedBenefitsCounseling?: Maybe<Scalars['DateTime']>;
  ethnicity?: Maybe<Scalars['String']>;
  blindDisabled?: Maybe<Scalars['Boolean']>;
  tractCode?: Maybe<Scalars['String']>;
  isLocked: Scalars['Boolean'];
  gender?: Maybe<Scalars['String']>;
  selectedFor?: Maybe<Scalars['String']>;
  reachedVerifyScreen: Scalars['Boolean'];
  assignedAdmin?: Maybe<UserType>;
  verifyInvitationSent?: Maybe<Scalars['DateTime']>;
  verifyInvitationReminderSent?: Maybe<Scalars['DateTime']>;
  invitationSent?: Maybe<Scalars['DateTime']>;
  invitationReminderSent?: Maybe<Scalars['DateTime']>;
  intercomKey?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
};

export type DocumentTypeConnection = {
  __typename?: 'DocumentTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DocumentTypeEdge>>;
};

/** A Relay edge containing a `DocumentType` and its cursor. */
export type DocumentTypeEdge = {
  __typename?: 'DocumentTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<DocumentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type DocumentType = Node & {
  __typename?: 'DocumentType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  documentType?: Maybe<DocumentDocumentType>;
  potentialUser: PotentialUserType;
  requestedAs?: Maybe<Scalars['String']>;
  uploadedAt: Scalars['DateTime'];
  verifiedBy?: Maybe<UserType>;
  pk?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum DocumentDocumentType {
  /** Drivers License */
  DriversLicense = 'DRIVERS_LICENSE',
  /** Id Card */
  IdCard = 'ID_CARD',
  /** Other */
  Other = 'OTHER',
  /** Proof Of Income */
  ProofOfIncome = 'PROOF_OF_INCOME',
  /** Proof Of Residency */
  ProofOfResidency = 'PROOF_OF_RESIDENCY',
  /** Proof Of Pregnancy Parenting */
  ProofOfPregnancyParenting = 'PROOF_OF_PREGNANCY_PARENTING'
}

export type PaymentTypeConnection = {
  __typename?: 'PaymentTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentTypeEdge>>;
};

/** A Relay edge containing a `PaymentType` and its cursor. */
export type PaymentTypeEdge = {
  __typename?: 'PaymentTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<PaymentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type PaymentType = Node & {
  __typename?: 'PaymentType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  hyperwalletToken?: Maybe<Scalars['String']>;
  usioToken?: Maybe<Scalars['String']>;
  destination: TransferMethodObjectType;
  user: UserType;
  amount: Scalars['Float'];
  status: PaymentStatus;
  notes?: Maybe<Scalars['String']>;
  program: ProgramType;
  scheduledPayment?: Maybe<ScheduledPaymentType>;
  admin?: Maybe<UserType>;
};

export type TransferMethodObjectType = Node & {
  __typename?: 'TransferMethodObjectType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  hyperwalletToken?: Maybe<Scalars['String']>;
  usioToken?: Maybe<Scalars['String']>;
  type: TransferMethodType;
  user: UserType;
  oneLiner: Scalars['String'];
  halfLiner: Scalars['String'];
  isCurrentMethod: Scalars['Boolean'];
  isChirlaPickup: Scalars['Boolean'];
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  payments: PaymentTypeConnection;
};


export type TransferMethodObjectTypePaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum TransferMethodType {
  /** Bank Account */
  BankAccount = 'BANK_ACCOUNT',
  /** Paypal Account */
  PaypalAccount = 'PAYPAL_ACCOUNT',
  /** Venmo Account */
  VenmoAccount = 'VENMO_ACCOUNT',
  /** Prepaid Card */
  PrepaidCard = 'PREPAID_CARD'
}

/** An enumeration. */
export enum PaymentStatus {
  /** Created */
  Created = 'CREATED',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
  /** Pending Account Activation */
  PendingAccountActivation = 'PENDING_ACCOUNT_ACTIVATION',
  /** Pending Id Verification */
  PendingIdVerification = 'PENDING_ID_VERIFICATION',
  /** Pending Tax Verification */
  PendingTaxVerification = 'PENDING_TAX_VERIFICATION',
  /** Pending Transfer Method Action */
  PendingTransferMethodAction = 'PENDING_TRANSFER_METHOD_ACTION',
  /** Pending Transaction Verification */
  PendingTransactionVerification = 'PENDING_TRANSACTION_VERIFICATION',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Unclaimed */
  Unclaimed = 'UNCLAIMED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Failed */
  Failed = 'FAILED',
  /** Recalled */
  Recalled = 'RECALLED',
  /** Returned */
  Returned = 'RETURNED',
  /** Expired */
  Expired = 'EXPIRED',
  /** Pending */
  Pending = 'PENDING'
}

export type ScheduledPaymentType = Node & {
  __typename?: 'ScheduledPaymentType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  scheduledDate: Scalars['DateTime'];
  localScheduledDate: Scalars['String'];
  amount: Scalars['Float'];
  potentialUser?: Maybe<PotentialUserType>;
  user?: Maybe<UserType>;
  program: ProgramType;
  pending: Scalars['Boolean'];
  admin?: Maybe<UserType>;
  notes?: Maybe<Scalars['String']>;
  payments: PaymentTypeConnection;
  fulfillmentPayment?: Maybe<PaymentType>;
};


export type ScheduledPaymentTypePaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ScheduledPaymentTypeConnection = {
  __typename?: 'ScheduledPaymentTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduledPaymentTypeEdge>>;
};

/** A Relay edge containing a `ScheduledPaymentType` and its cursor. */
export type ScheduledPaymentTypeEdge = {
  __typename?: 'ScheduledPaymentTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<ScheduledPaymentType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TransferMethodObjectTypeConnection = {
  __typename?: 'TransferMethodObjectTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransferMethodObjectTypeEdge>>;
};

/** A Relay edge containing a `TransferMethodObjectType` and its cursor. */
export type TransferMethodObjectTypeEdge = {
  __typename?: 'TransferMethodObjectTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<TransferMethodObjectType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type UserTypeConnection = {
  __typename?: 'UserTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserTypeEdge>>;
};

/** A Relay edge containing a `UserType` and its cursor. */
export type UserTypeEdge = {
  __typename?: 'UserTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<UserType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type HouseholdMemberType = {
  __typename?: 'HouseholdMemberType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  potentialUser: PotentialUserType;
  name: Scalars['String'];
  dob: Scalars['Date'];
  relation: Scalars['String'];
  blindDisabled?: Maybe<Scalars['Boolean']>;
  ssiBenefitAnswer: BenefitAnswerTypeConnection;
};


export type HouseholdMemberTypeSsiBenefitAnswerArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type BenefitAnswerTypeConnection = {
  __typename?: 'BenefitAnswerTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BenefitAnswerTypeEdge>>;
};

/** A Relay edge containing a `BenefitAnswerType` and its cursor. */
export type BenefitAnswerTypeEdge = {
  __typename?: 'BenefitAnswerTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<BenefitAnswerType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type BenefitAnswerType = Node & {
  __typename?: 'BenefitAnswerType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  potentialUser: PotentialUserType;
  householdMember?: Maybe<HouseholdMemberType>;
  category: BenefitAnswerCategory;
  answer: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BenefitAnswerCategory {
  /** Earned Income */
  EarnedIncome = 'EARNED_INCOME',
  /** Unearned Income */
  UnearnedIncome = 'UNEARNED_INCOME',
  /** Housing Assistance */
  HousingAssistance = 'HOUSING_ASSISTANCE',
  /** Cal Fresh Amount */
  CalFreshAmount = 'CAL_FRESH_AMOUNT',
  /** Cal Works Amount */
  CalWorksAmount = 'CAL_WORKS_AMOUNT',
  /** Head Start Re Qualifying */
  HeadStartReQualifying = 'HEAD_START_RE_QUALIFYING',
  /** Acp How */
  AcpHow = 'ACP_HOW',
  /** Acp Program */
  AcpProgram = 'ACP_PROGRAM',
  /** Calendly Appointment */
  CalendlyAppointment = 'CALENDLY_APPOINTMENT',
  /** No Benefits */
  NoBenefits = 'NO_BENEFITS',
  /** Decline Speak Counselor */
  DeclineSpeakCounselor = 'DECLINE_SPEAK_COUNSELOR'
}

export type PotentialUserFlagTypeConnection = {
  __typename?: 'PotentialUserFlagTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PotentialUserFlagTypeEdge>>;
};

/** A Relay edge containing a `PotentialUserFlagType` and its cursor. */
export type PotentialUserFlagTypeEdge = {
  __typename?: 'PotentialUserFlagTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<PotentialUserFlagType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type PotentialUserFlagType = Node & {
  __typename?: 'PotentialUserFlagType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  potentialUser?: Maybe<PotentialUserType>;
  flagType: PotentialUserFlagFlagType;
  matchedPotentialUser?: Maybe<PotentialUserType>;
  inactive: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PotentialUserFlagFlagType {
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** Income */
  Income = 'INCOME',
  /** Geolocation */
  Geolocation = 'GEOLOCATION',
  /** Is Outside Us */
  IsOutsideUs = 'IS_OUTSIDE_US'
}

export type ProgramApplicationAnswerTypeConnection = {
  __typename?: 'ProgramApplicationAnswerTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProgramApplicationAnswerTypeEdge>>;
};

/** A Relay edge containing a `ProgramApplicationAnswerType` and its cursor. */
export type ProgramApplicationAnswerTypeEdge = {
  __typename?: 'ProgramApplicationAnswerTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<ProgramApplicationAnswerType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ProgramApplicationAnswerType = Node & {
  __typename?: 'ProgramApplicationAnswerType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  potentialUserApplication: PotentialUserApplicationType;
  answerCategory: ProgramApplicationAnswerAnswerCategory;
  response: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ProgramApplicationAnswerAnswerCategory {
  /** General */
  General = 'GENERAL',
  /** Children Pregnant */
  Pregnancy = 'PREGNANCY',
  /** Covid */
  Covid = 'COVID',
  /** Income Threshold */
  IncomeThreshold = 'INCOME_THRESHOLD',
  /** Assistance Orgs */
  AssistanceOrgs = 'ASSISTANCE_ORGS',
  /** Household Members */
  HouseholdMembers = 'HOUSEHOLD_MEMBERS',
  /** Taxable Income */
  TaxableIncome = 'TAXABLE_INCOME',
  /** Incarceration */
  Incarceration = 'INCARCERATION',
  /** Id */
  Id = 'ID',
  /** Bank Account */
  BankAccount = 'BANK_ACCOUNT',
  /** Heard About Program */
  HeardAboutProgram = 'HEARD_ABOUT_PROGRAM',
  /** Smartphone Access */
  SmartphoneAccess = 'SMARTPHONE_ACCESS',
  /** Income Earner */
  IncomeEarner = 'INCOME_EARNER',
  /** Household Members Under 18 */
  HouseholdMembersUnder_18 = 'HOUSEHOLD_MEMBERS_UNDER_18',
  /** Combined Household Income */
  CombinedHouseholdIncome = 'COMBINED_HOUSEHOLD_INCOME',
  /** Proof Of Residency Category */
  ProofOfResidencyCategory = 'PROOF_OF_RESIDENCY_CATEGORY',
  /** Proof Of Income Category */
  ProofOfIncomeCategory = 'PROOF_OF_INCOME_CATEGORY',
  /** Single Income Attestation */
  SingleIncomeAttestation = 'SINGLE_INCOME_ATTESTATION',
  /** Sign Verification */
  SignVerification = 'SIGN_VERIFICATION'
}

export type BenefitSelectedTypeConnection = {
  __typename?: 'BenefitSelectedTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BenefitSelectedTypeEdge>>;
};

/** A Relay edge containing a `BenefitSelectedType` and its cursor. */
export type BenefitSelectedTypeEdge = {
  __typename?: 'BenefitSelectedTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<BenefitSelectedType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type BenefitSelectedType = Node & {
  __typename?: 'BenefitSelectedType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  potentialUser: PotentialUserType;
  category: BenefitSelectedCategory;
  pk?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BenefitSelectedCategory {
  /** Ssi */
  Ssi = 'SSI',
  /** Cal Fresh */
  CalFresh = 'CAL_FRESH',
  /** Cal Works */
  CalWorks = 'CAL_WORKS',
  /** Head Start */
  HeadStart = 'HEAD_START',
  /** Affordable Connectivity */
  AffordableConnectivity = 'AFFORDABLE_CONNECTIVITY',
  /** Hud Housing */
  HudHousing = 'HUD_HOUSING',
  /** None */
  None = 'NONE'
}

export type PolicyEngineType = {
  __typename?: 'PolicyEngineType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  potentialUser: PotentialUserType;
  withGi: Scalars['JSONString'];
  withoutGi: Scalars['JSONString'];
  result?: Maybe<Scalars['Float']>;
};

export type DocumentRequireTypeConnection = {
  __typename?: 'DocumentRequireTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DocumentRequireTypeEdge>>;
};

/** A Relay edge containing a `DocumentRequireType` and its cursor. */
export type DocumentRequireTypeEdge = {
  __typename?: 'DocumentRequireTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<DocumentRequireType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type DocumentRequireType = Node & {
  __typename?: 'DocumentRequireType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  type?: Maybe<DocumentRequirementType>;
  required: Scalars['Boolean'];
  program: ProgramType;
};

/** An enumeration. */
export enum DocumentRequirementType {
  /** Drivers License */
  DriversLicense = 'DRIVERS_LICENSE',
  /** Id Card */
  IdCard = 'ID_CARD',
  /** Other */
  Other = 'OTHER',
  /** Proof Of Income */
  ProofOfIncome = 'PROOF_OF_INCOME',
  /** Proof Of Residency */
  ProofOfResidency = 'PROOF_OF_RESIDENCY',
  /** Proof Of Pregnancy Parenting */
  ProofOfPregnancyParenting = 'PROOF_OF_PREGNANCY_PARENTING'
}

export type OnboardingLogosTypeConnection = {
  __typename?: 'OnboardingLogosTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OnboardingLogosTypeEdge>>;
};

/** A Relay edge containing a `OnboardingLogosType` and its cursor. */
export type OnboardingLogosTypeEdge = {
  __typename?: 'OnboardingLogosTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<OnboardingLogosType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type OnboardingLogosType = Node & {
  __typename?: 'OnboardingLogosType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  image: Scalars['String'];
  organization?: Maybe<OrganizationType>;
  program?: Maybe<ProgramType>;
};

export type StylesTypeConnection = {
  __typename?: 'StylesTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StylesTypeEdge>>;
};

/** A Relay edge containing a `StylesType` and its cursor. */
export type StylesTypeEdge = {
  __typename?: 'StylesTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<StylesType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StylesType = Node & {
  __typename?: 'StylesType';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
  tertiaryColor: Scalars['String'];
  hoverColor: Scalars['String'];
  backgroundColor: Scalars['String'];
  textColor?: Maybe<Scalars['String']>;
  languageSwitcherInactiveColor?: Maybe<Scalars['String']>;
  languageSwitcherActiveColor?: Maybe<Scalars['String']>;
  sidebarLogo: Scalars['String'];
  sidebarImage: Scalars['String'];
  sidebarLogoMobile: Scalars['String'];
  organization?: Maybe<OrganizationType>;
  program?: Maybe<ProgramType>;
};

export type HealthCheckData = {
  __typename?: 'HealthCheckData';
  usioBalance?: Maybe<Scalars['Float']>;
  usioHealth?: Maybe<Scalars['Boolean']>;
  upcomingUsioPayments?: Maybe<Scalars['Float']>;
  moneyStatusUsio?: Maybe<Scalars['Boolean']>;
  upcomingHyperwalletPayments?: Maybe<Scalars['Float']>;
  hyperwalletHealth?: Maybe<Scalars['Boolean']>;
  moneyStatusHyperwallet?: Maybe<Scalars['Boolean']>;
  hyperwalletBalance?: Maybe<Scalars['Float']>;
  notSignedUpUsers?: Maybe<Scalars['Int']>;
  totalPotentialUsers?: Maybe<Scalars['Int']>;
  totalUsers?: Maybe<Scalars['Int']>;
  usersWithTransferMethod?: Maybe<Scalars['Int']>;
  usersPrepaidCardAndActiveStatus?: Maybe<Scalars['Int']>;
  usersPrepaidCard?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['String']>;
  programUrl?: Maybe<Scalars['String']>;
};

export type CalendlyEventType = {
  __typename?: 'CalendlyEventType';
  potentialUserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type FaqNinjaWizardType = {
  __typename?: 'FaqNinjaWizardType';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  org: OrganizationType;
  language: FaqNinjaWizardLanguage;
  ninjaCode: Scalars['String'];
};

/** An enumeration. */
export enum FaqNinjaWizardLanguage {
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** Tagalog */
  Tl = 'TL',
  /** Khmer */
  Km = 'KM'
}

export type AddressDetails = {
  __typename?: 'AddressDetails';
  address1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export type AddressAutocomplete = {
  __typename?: 'AddressAutocomplete';
  placeId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type DocumentData = {
  __typename?: 'DocumentData';
  document?: Maybe<Scalars['String']>;
  encoding?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OrganizationConfigsType = {
  __typename?: 'OrganizationConfigsType';
  replyToEmail?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  typeformId?: Maybe<Scalars['String']>;
  typeformSubdomain?: Maybe<Scalars['String']>;
  websiteLink?: Maybe<Scalars['String']>;
  twitterLink?: Maybe<Scalars['String']>;
  instagramLink?: Maybe<Scalars['String']>;
  facebookLink?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  whatsappPhoneNumber?: Maybe<Scalars['String']>;
  isTypeformBound?: Maybe<Scalars['Boolean']>;
};

export type ApplicationSummaryItem = {
  __typename?: 'ApplicationSummaryItem';
  key?: Maybe<Scalars['String']>;
  data?: Maybe<ApplicationSummarySubItem>;
};

export type ApplicationSummarySubItem = {
  __typename?: 'ApplicationSummarySubItem';
  total?: Maybe<Scalars['Int']>;
  approved?: Maybe<Scalars['Int']>;
  inReview?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
};

export type ApplicationsByDayResponse = {
  __typename?: 'ApplicationsByDayResponse';
  date?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
};

export type SurveySummary = {
  __typename?: 'SurveySummary';
  completed?: Maybe<Array<Maybe<UserType>>>;
  notCompleted?: Maybe<Array<Maybe<UserType>>>;
  submittedAt?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InviteCodeValidationQueryResponse = {
  __typename?: 'InviteCodeValidationQueryResponse';
  potentialUser?: Maybe<PotentialUserType>;
  alreadySignedUp?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  success?: Maybe<Scalars['Boolean']>;
  ok?: Maybe<Scalars['Boolean']>;
  addNote?: Maybe<CreateNote>;
  deleteDocument?: Maybe<DeleteDocument>;
  approveDocument?: Maybe<ApproveDocument>;
  requestSingleDocument?: Maybe<RequestSingleDocument>;
  sendDocumentReminder?: Maybe<SendDocumentReminder>;
  addBenefitAnswers?: Maybe<AddBenefitAnswers>;
  updateBlindDisabled?: Maybe<UpdateBlindDisabled>;
  selectBenefits?: Maybe<SelectBenefits>;
  speakBenefitsCounselor?: Maybe<SpeakBenefitsCounselor>;
  getPrograms?: Maybe<GetPrograms>;
  scheduledPayments?: Maybe<GetScheduledPaymentsById>;
  makepayments?: Maybe<MakePayments>;
  transferMethodAddBankAccount?: Maybe<TransferMethodAddBankAccount>;
  transferMethodAddPaypal?: Maybe<TransferMethodAddPaypal>;
  transferMethodAddVenmo?: Maybe<TransferMethodAddVenmo>;
  transferMethodAddPrepaidCard?: Maybe<TransferMethodAddPrepaidCard>;
  orderReplacementCard?: Maybe<OrderReplacementCard>;
  transferMethodRemove?: Maybe<TransferMethodRemove>;
  sendTextMessage?: Maybe<SendTextMessage>;
  sendResetPasswordEmail?: Maybe<SendResetPasswordEmail>;
  resetTranslationCache?: Maybe<ResetTranslationsCache>;
  updateConfigurations?: Maybe<UpdateConfigurations>;
  makeFlagInactive?: Maybe<MakeFlagInactive>;
  apply?: Maybe<Apply>;
  resolveApplication?: Maybe<ResolveApplication>;
  sendConfirmation?: Maybe<SendConfirmation>;
  documentUpload?: Maybe<DocumentUpload>;
  requestDocument?: Maybe<RequestDocument>;
  addApplicationAnswers?: Maybe<AddApplicationAnswers>;
  saveHouseholdMembers?: Maybe<SaveHouseholdMembers>;
  sendDocumentsUploadConfirmation?: Maybe<SendDocumentsUploadConfirmation>;
  resendOnboardingEmail?: Maybe<ResendOnboardingEmail>;
  getPotentialUser?: Maybe<GetPotentialUser>;
  sendOnboardingNotification?: Maybe<SendOnboardingNotification>;
  sendOnboardingNotificationReminder?: Maybe<SendOnboardingNotificationReminder>;
  sendSonomaOnboardingNotification?: Maybe<SendSonomaOnboardingNotification>;
  sendBenefitsInvitation?: Maybe<SendBenefitsInvitation>;
  saveSixDigitVerificationCodeForPotentialUser?: Maybe<SaveSixDigitVerificationCodeForPotentialUser>;
  checkSixDigitVerificationCodeForPotentialUser?: Maybe<CheckSixDigitVerificationCodeForPotentialUser>;
  checkReachedVerifyScreen?: Maybe<CheckReachedVerifyScreen>;
  editUserAndPotentialUser?: Maybe<EditUserAndPotentialUser>;
  updateSettings?: Maybe<UpdateSettings>;
  updateLanguage?: Maybe<UpdateLanguage>;
  updateDetails?: Maybe<UpdateDetails>;
  logout?: Maybe<Logout>;
  uploadMutation?: Maybe<UploadMutation>;
  register?: Maybe<RegisterExtended>;
  /**
   * Verify user account.
   * 
   * Receive the token that was sent by email.
   * If the token is valid, make the user verified
   * by making the `user.status.verified` field true.
   */
  verifyAccount?: Maybe<VerifyAccount>;
  /**
   * Sends activation email.
   * 
   * It is called resend because theoretically
   * the first activation email was sent when
   * the user registered.
   * 
   * If there is no user with the requested email,
   * a successful response is returned.
   */
  resendActivationEmail?: Maybe<ResendActivationEmail>;
  /**
   * Send password reset email.
   * 
   * For non verified users, send an activation
   * email instead.
   * 
   * Accepts both primary and secondary email.
   * 
   * If there is no user with the requested email,
   * a successful response is returned.
   */
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmail>;
  passwordReset?: Maybe<PasswordResetExtended>;
  passwordChange?: Maybe<PasswordChangeExtended>;
  /**
   * Update user model fields, defined on settings.
   * 
   * User must be verified.
   */
  updateAccount?: Maybe<UpdateAccount>;
  /**
   * Archive account and revoke refresh tokens.
   * 
   * User must be verified and confirm password.
   */
  archiveAccount?: Maybe<ArchiveAccount>;
  /**
   * Delete account permanently or make `user.is_active=False`.
   * 
   * The behavior is defined on settings.
   * Anyway user refresh tokens are revoked.
   * 
   * User must be verified and confirm password.
   */
  deleteAccount?: Maybe<DeleteAccount>;
  /**
   * Send activation to secondary email.
   * 
   * User must be verified and confirm password.
   */
  sendSecondaryEmailActivation?: Maybe<SendSecondaryEmailActivation>;
  /**
   * Verify user secondary email.
   * 
   * Receive the token that was sent by email.
   * User is already verified when using this mutation.
   * 
   * If the token is valid, add the secondary email
   * to `user.status.secondary_email` field.
   * 
   * Note that until the secondary email is verified,
   * it has not been saved anywhere beyond the token,
   * so it can still be used to create a new account.
   * After being verified, it will no longer be available.
   */
  verifySecondaryEmail?: Maybe<VerifySecondaryEmail>;
  /**
   * Swap between primary and secondary emails.
   * 
   * Require password confirmation.
   */
  swapEmails?: Maybe<SwapEmails>;
  /**
   * Remove user secondary email.
   * 
   * Require password confirmation.
   */
  removeSecondaryEmail?: Maybe<RemoveSecondaryEmail>;
  tokenAuth?: Maybe<ObtainJsonWebTokenExtended>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  verifyToken?: Maybe<VerifyToken>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  refreshToken?: Maybe<RefreshToken>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  revokeToken?: Maybe<RevokeToken>;
};


export type MutationAddNoteArgs = {
  note: Scalars['String'];
  potentialUser: Scalars['ID'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationApproveDocumentArgs = {
  adminId: Scalars['ID'];
  documentId: Scalars['ID'];
};


export type MutationRequestSingleDocumentArgs = {
  documentId: Scalars['ID'];
  potentialUserId: Scalars['ID'];
};


export type MutationSendDocumentReminderArgs = {
  potentialUserId: Scalars['ID'];
};


export type MutationAddBenefitAnswersArgs = {
  answers: Array<BenefitAnswerInputType>;
};


export type MutationUpdateBlindDisabledArgs = {
  blindDisabled: Scalars['Boolean'];
  inviteCode?: Maybe<Scalars['String']>;
  verificationCode?: Maybe<Scalars['String']>;
};


export type MutationSelectBenefitsArgs = {
  benefits: Array<BenefitSelectedInputType>;
};


export type MutationSpeakBenefitsCounselorArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Scalars['String'];
  phoneNumber: Scalars['String'];
  potentialUserId: Scalars['ID'];
};


export type MutationGetProgramsArgs = {
  includeClosedPeriod?: Maybe<Scalars['Boolean']>;
  programUrl?: Maybe<Scalars['String']>;
};


export type MutationScheduledPaymentsArgs = {
  upcomingIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export type MutationMakepaymentsArgs = {
  scheduledPaymentIds: Array<Maybe<Scalars['ID']>>;
};


export type MutationTransferMethodAddBankAccountArgs = {
  accountPurpose: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  bankAccountId: Scalars['String'];
  branchId: Scalars['String'];
  city: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
};


export type MutationTransferMethodAddPaypalArgs = {
  email: Scalars['String'];
};


export type MutationTransferMethodAddVenmoArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationTransferMethodAddPrepaidCardArgs = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  language: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
};


export type MutationOrderReplacementCardArgs = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  password: Scalars['String'];
  postalCode: Scalars['Int'];
  state: Scalars['String'];
  usioCardId: Scalars['Int'];
};


export type MutationTransferMethodRemoveArgs = {
  id: Scalars['ID'];
};


export type MutationSendTextMessageArgs = {
  organizationId?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  text: Scalars['String'];
};


export type MutationSendResetPasswordEmailArgs = {
  password: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateConfigurationsArgs = {
  configurations: Scalars['JSONString'];
};


export type MutationMakeFlagInactiveArgs = {
  pk: Scalars['ID'];
  potentialUserPk: Scalars['ID'];
  relatedPotentialPk?: Maybe<Scalars['ID']>;
};


export type MutationApplyArgs = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  dob?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  ethnicity?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  programUrl: Scalars['String'];
  state: Scalars['String'];
};


export type MutationResolveApplicationArgs = {
  email: Scalars['String'];
  status: Scalars['String'];
};


export type MutationSendConfirmationArgs = {
  potentialUserId: Scalars['ID'];
};


export type MutationDocumentUploadArgs = {
  documentType: Scalars['String'];
  file: Scalars['Upload'];
  potentialUserId: Scalars['ID'];
};


export type MutationRequestDocumentArgs = {
  potentialUserId: Scalars['ID'];
  requestedDocumentList: Array<Maybe<Scalars['String']>>;
};


export type MutationAddApplicationAnswersArgs = {
  answers: Array<ProgramApplicationAnswerInputType>;
};


export type MutationSaveHouseholdMembersArgs = {
  householdMembers: Array<HouseholdMemberInputType>;
  potentialUserId: Scalars['ID'];
};


export type MutationSendDocumentsUploadConfirmationArgs = {
  documentType?: Maybe<Scalars['String']>;
  potentialUserId: Scalars['ID'];
};


export type MutationResendOnboardingEmailArgs = {
  potentialUserId: Scalars['ID'];
};


export type MutationGetPotentialUserArgs = {
  id: Scalars['String'];
};


export type MutationSendOnboardingNotificationArgs = {
  email?: Maybe<Scalars['String']>;
};


export type MutationSendOnboardingNotificationReminderArgs = {
  email?: Maybe<Scalars['String']>;
};


export type MutationSendSonomaOnboardingNotificationArgs = {
  email?: Maybe<Scalars['String']>;
};


export type MutationSaveSixDigitVerificationCodeForPotentialUserArgs = {
  phoneNumber: Scalars['String'];
  potentialUserId: Scalars['String'];
};


export type MutationCheckSixDigitVerificationCodeForPotentialUserArgs = {
  potentialUserId: Scalars['String'];
  verificationCode: Scalars['String'];
};


export type MutationCheckReachedVerifyScreenArgs = {
  potentialUserId: Scalars['ID'];
};


export type MutationEditUserAndPotentialUserArgs = {
  addressLine1: Scalars['String'];
  city: Scalars['String'];
  dob: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  pk: Scalars['ID'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
};


export type MutationUpdateSettingsArgs = {
  email?: Maybe<Scalars['String']>;
  emailNotificationsEnabled: Scalars['Boolean'];
  optedForWhatsapp?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  smsNotificationsEnabled: Scalars['Boolean'];
  transferMethodId: Scalars['ID'];
};


export type MutationUpdateLanguageArgs = {
  language: Scalars['String'];
};


export type MutationUpdateDetailsArgs = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};


export type MutationUploadMutationArgs = {
  file: Scalars['Upload'];
};


export type MutationRegisterArgs = {
  email: Scalars['String'];
  inviteCode: Scalars['String'];
  phoneNumber: Scalars['String'];
  dob: Scalars['String'];
  language: Scalars['String'];
  program: Scalars['String'];
  securityQuestionQuestion: Scalars['String'];
  securityQuestionAnswer: Scalars['String'];
  password1: Scalars['String'];
  password2: Scalars['String'];
};


export type MutationVerifyAccountArgs = {
  token: Scalars['String'];
};


export type MutationResendActivationEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationPasswordResetArgs = {
  token: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
};


export type MutationPasswordChangeArgs = {
  oldPassword: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
};


export type MutationUpdateAccountArgs = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};


export type MutationArchiveAccountArgs = {
  password: Scalars['String'];
};


export type MutationDeleteAccountArgs = {
  password: Scalars['String'];
};


export type MutationSendSecondaryEmailActivationArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationVerifySecondaryEmailArgs = {
  token: Scalars['String'];
};


export type MutationSwapEmailsArgs = {
  password: Scalars['String'];
};


export type MutationRemoveSecondaryEmailArgs = {
  password: Scalars['String'];
};


export type MutationTokenAuthArgs = {
  password: Scalars['String'];
  email?: Maybe<Scalars['String']>;
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRevokeTokenArgs = {
  refreshToken: Scalars['String'];
};

export type CreateNote = {
  __typename?: 'CreateNote';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteDocument = {
  __typename?: 'DeleteDocument';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ApproveDocument = {
  __typename?: 'ApproveDocument';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RequestSingleDocument = {
  __typename?: 'RequestSingleDocument';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SendDocumentReminder = {
  __typename?: 'SendDocumentReminder';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddBenefitAnswers = {
  __typename?: 'AddBenefitAnswers';
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export type BenefitAnswerInputType = {
  potentialUserId?: Maybe<Scalars['ID']>;
  householdMemberId?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type UpdateBlindDisabled = {
  __typename?: 'UpdateBlindDisabled';
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export type SelectBenefits = {
  __typename?: 'SelectBenefits';
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export type BenefitSelectedInputType = {
  potentialUserId?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
};

export type SpeakBenefitsCounselor = {
  __typename?: 'SpeakBenefitsCounselor';
  ok?: Maybe<Scalars['Boolean']>;
};

export type GetPrograms = {
  __typename?: 'GetPrograms';
  success?: Maybe<Scalars['Boolean']>;
  programId?: Maybe<Scalars['ID']>;
};

export type GetScheduledPaymentsById = {
  __typename?: 'GetScheduledPaymentsById';
  allUpcomingScheduledPayments?: Maybe<Array<Maybe<ScheduledPaymentType>>>;
};

export type MakePayments = {
  __typename?: 'MakePayments';
  ok?: Maybe<Scalars['Boolean']>;
};

export type TransferMethodAddBankAccount = {
  __typename?: 'TransferMethodAddBankAccount';
  user?: Maybe<UserType>;
  error?: Maybe<FieldErrorType>;
  errorLabel?: Maybe<FieldErrorType>;
};

export type FieldErrorType = {
  __typename?: 'FieldErrorType';
  fieldName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type TransferMethodAddPaypal = {
  __typename?: 'TransferMethodAddPaypal';
  user?: Maybe<UserType>;
  error?: Maybe<FieldErrorType>;
};

export type TransferMethodAddVenmo = {
  __typename?: 'TransferMethodAddVenmo';
  user?: Maybe<UserType>;
  error?: Maybe<FieldErrorType>;
};

export type TransferMethodAddPrepaidCard = {
  __typename?: 'TransferMethodAddPrepaidCard';
  user?: Maybe<UserType>;
  error?: Maybe<FieldErrorType>;
};

export type OrderReplacementCard = {
  __typename?: 'OrderReplacementCard';
  transferMethod?: Maybe<TransferMethodObjectType>;
  error?: Maybe<FieldErrorType>;
};

export type TransferMethodRemove = {
  __typename?: 'TransferMethodRemove';
  user?: Maybe<UserType>;
  error?: Maybe<FieldErrorType>;
};

export type SendTextMessage = {
  __typename?: 'SendTextMessage';
  success?: Maybe<Scalars['Boolean']>;
};

export type SendResetPasswordEmail = {
  __typename?: 'SendResetPasswordEmail';
  success?: Maybe<Scalars['Boolean']>;
};

export type ResetTranslationsCache = {
  __typename?: 'ResetTranslationsCache';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateConfigurations = {
  __typename?: 'UpdateConfigurations';
  success?: Maybe<Scalars['Boolean']>;
};

export type MakeFlagInactive = {
  __typename?: 'MakeFlagInactive';
  success?: Maybe<Scalars['Boolean']>;
};

export type Apply = {
  __typename?: 'Apply';
  application?: Maybe<PotentialUserApplicationType>;
  error?: Maybe<Scalars['Boolean']>;
};

export type ResolveApplication = {
  __typename?: 'ResolveApplication';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SendConfirmation = {
  __typename?: 'SendConfirmation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DocumentUpload = {
  __typename?: 'DocumentUpload';
  documentUploadSuccess?: Maybe<Scalars['Boolean']>;
};


export type RequestDocument = {
  __typename?: 'RequestDocument';
  documentRequestSuccess?: Maybe<Scalars['Boolean']>;
};

export type AddApplicationAnswers = {
  __typename?: 'AddApplicationAnswers';
  success?: Maybe<Scalars['Boolean']>;
};

export type ProgramApplicationAnswerInputType = {
  potentialUserApplicationId?: Maybe<Scalars['ID']>;
  answerCategory?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
};

export type SaveHouseholdMembers = {
  __typename?: 'SaveHouseholdMembers';
  success?: Maybe<Scalars['Boolean']>;
};

export type HouseholdMemberInputType = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  relation?: Maybe<Scalars['String']>;
  blindDisabled?: Maybe<Scalars['Boolean']>;
};

export type SendDocumentsUploadConfirmation = {
  __typename?: 'SendDocumentsUploadConfirmation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ResendOnboardingEmail = {
  __typename?: 'ResendOnboardingEmail';
  success?: Maybe<Scalars['Boolean']>;
};

export type GetPotentialUser = {
  __typename?: 'GetPotentialUser';
  potentialUser?: Maybe<PotentialUserType>;
  flags?: Maybe<Array<Maybe<PotentialUserFlagType>>>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  applicationAnswers?: Maybe<Array<Maybe<ProgramApplicationAnswerType>>>;
  householdMembers?: Maybe<Array<Maybe<HouseholdMemberType>>>;
};

export type SendOnboardingNotification = {
  __typename?: 'SendOnboardingNotification';
  success?: Maybe<Scalars['Boolean']>;
};

export type SendOnboardingNotificationReminder = {
  __typename?: 'SendOnboardingNotificationReminder';
  success?: Maybe<Scalars['Boolean']>;
};

export type SendSonomaOnboardingNotification = {
  __typename?: 'SendSonomaOnboardingNotification';
  success?: Maybe<Scalars['Boolean']>;
};

export type SendBenefitsInvitation = {
  __typename?: 'SendBenefitsInvitation';
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveSixDigitVerificationCodeForPotentialUser = {
  __typename?: 'SaveSixDigitVerificationCodeForPotentialUser';
  success?: Maybe<Scalars['Boolean']>;
};

export type CheckSixDigitVerificationCodeForPotentialUser = {
  __typename?: 'CheckSixDigitVerificationCodeForPotentialUser';
  success?: Maybe<Scalars['Boolean']>;
};

export type CheckReachedVerifyScreen = {
  __typename?: 'CheckReachedVerifyScreen';
  success?: Maybe<Scalars['Boolean']>;
};

export type EditUserAndPotentialUser = {
  __typename?: 'EditUserAndPotentialUser';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateSettings = {
  __typename?: 'UpdateSettings';
  user?: Maybe<UserType>;
  error?: Maybe<FieldErrorType>;
};

export type UpdateLanguage = {
  __typename?: 'UpdateLanguage';
  user?: Maybe<UserType>;
};

export type UpdateDetails = {
  __typename?: 'UpdateDetails';
  success?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export type Logout = {
  __typename?: 'Logout';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UploadMutation = {
  __typename?: 'UploadMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type RegisterExtended = {
  __typename?: 'RegisterExtended';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};


/**
 * Verify user account.
 * 
 * Receive the token that was sent by email.
 * If the token is valid, make the user verified
 * by making the `user.status.verified` field true.
 */
export type VerifyAccount = {
  __typename?: 'VerifyAccount';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Sends activation email.
 * 
 * It is called resend because theoretically
 * the first activation email was sent when
 * the user registered.
 * 
 * If there is no user with the requested email,
 * a successful response is returned.
 */
export type ResendActivationEmail = {
  __typename?: 'ResendActivationEmail';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Send password reset email.
 * 
 * For non verified users, send an activation
 * email instead.
 * 
 * Accepts both primary and secondary email.
 * 
 * If there is no user with the requested email,
 * a successful response is returned.
 */
export type SendPasswordResetEmail = {
  __typename?: 'SendPasswordResetEmail';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type PasswordResetExtended = {
  __typename?: 'PasswordResetExtended';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type PasswordChangeExtended = {
  __typename?: 'PasswordChangeExtended';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/**
 * Update user model fields, defined on settings.
 * 
 * User must be verified.
 */
export type UpdateAccount = {
  __typename?: 'UpdateAccount';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Archive account and revoke refresh tokens.
 * 
 * User must be verified and confirm password.
 */
export type ArchiveAccount = {
  __typename?: 'ArchiveAccount';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Delete account permanently or make `user.is_active=False`.
 * 
 * The behavior is defined on settings.
 * Anyway user refresh tokens are revoked.
 * 
 * User must be verified and confirm password.
 */
export type DeleteAccount = {
  __typename?: 'DeleteAccount';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Send activation to secondary email.
 * 
 * User must be verified and confirm password.
 */
export type SendSecondaryEmailActivation = {
  __typename?: 'SendSecondaryEmailActivation';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Verify user secondary email.
 * 
 * Receive the token that was sent by email.
 * User is already verified when using this mutation.
 * 
 * If the token is valid, add the secondary email
 * to `user.status.secondary_email` field.
 * 
 * Note that until the secondary email is verified,
 * it has not been saved anywhere beyond the token,
 * so it can still be used to create a new account.
 * After being verified, it will no longer be available.
 */
export type VerifySecondaryEmail = {
  __typename?: 'VerifySecondaryEmail';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Swap between primary and secondary emails.
 * 
 * Require password confirmation.
 */
export type SwapEmails = {
  __typename?: 'SwapEmails';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

/**
 * Remove user secondary email.
 * 
 * Require password confirmation.
 */
export type RemoveSecondaryEmail = {
  __typename?: 'RemoveSecondaryEmail';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type ObtainJsonWebTokenExtended = {
  __typename?: 'ObtainJSONWebTokenExtended';
  token?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  user?: Maybe<UserNode>;
  unarchiving?: Maybe<Scalars['Boolean']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type UserNode = Node & {
  __typename?: 'UserNode';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  inviteCode: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  language: UserLanguage;
  hyperwalletToken?: Maybe<Scalars['String']>;
  usioToken?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  emailNotificationsEnabled: Scalars['Boolean'];
  smsNotificationsEnabled: Scalars['Boolean'];
  paymentFrequencyType?: Maybe<UserPaymentFrequencyType>;
  paymentAmount?: Maybe<Scalars['Float']>;
  potentialUser?: Maybe<PotentialUserType>;
  addressLat?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  researchId?: Maybe<Scalars['String']>;
  cbo?: Maybe<Scalars['String']>;
  securityQuestionQuestion: Scalars['String'];
  securityQuestionAnswer: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  program: ProgramType;
  isTestUser: Scalars['Boolean'];
  resetUserOnLogout: Scalars['Boolean'];
  invalidLoginAttempts: Scalars['Int'];
  lastLoginAttempt?: Maybe<Scalars['DateTime']>;
  organization?: Maybe<OrganizationType>;
  optedForWhatsapp?: Maybe<Scalars['Boolean']>;
  isFrozen: Scalars['Boolean'];
  logs: Array<LogType>;
  potentialUsers: PotentialUserTypeConnection;
  note: Array<NoteType>;
  verifiedDocuments: DocumentTypeConnection;
  payments: PaymentTypeConnection;
  ranPayments: PaymentTypeConnection;
  scheduledPayments: ScheduledPaymentTypeConnection;
  ranScheduledPayments: ScheduledPaymentTypeConnection;
  transferMethods: TransferMethodObjectTypeConnection;
  pk?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  verified?: Maybe<Scalars['Boolean']>;
  secondaryEmail?: Maybe<Scalars['String']>;
};


export type UserNodePotentialUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserNodeVerifiedDocumentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserNodePaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserNodeRanPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserNodeScheduledPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserNodeRanScheduledPaymentsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserNodeTransferMethodsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Same as `grapgql_jwt` implementation, with standard output. */
export type VerifyToken = {
  __typename?: 'VerifyToken';
  payload?: Maybe<Scalars['GenericScalar']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};


/** Same as `grapgql_jwt` implementation, with standard output. */
export type RefreshToken = {
  __typename?: 'RefreshToken';
  token?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['GenericScalar']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  refreshToken?: Maybe<Scalars['String']>;
};

/** Same as `grapgql_jwt` implementation, with standard output. */
export type RevokeToken = {
  __typename?: 'RevokeToken';
  revoked?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
};

export type TransferMethodAddBankAccountMutationVariables = Exact<{
  bankAccountId: Scalars['String'];
  branchId: Scalars['String'];
  accountPurpose: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
}>;


export type TransferMethodAddBankAccountMutation = { __typename?: 'Mutation', transferMethodAddBankAccount?: Maybe<{ __typename?: 'TransferMethodAddBankAccount', user?: Maybe<(
      { __typename?: 'UserType', id: string }
      & TransferMethodsFragment
    )>, error?: Maybe<(
      { __typename?: 'FieldErrorType' }
      & FieldErrorFragment
    )>, errorLabel?: Maybe<(
      { __typename?: 'FieldErrorType' }
      & FieldErrorFragment
    )> }> };

export type TransferMethodAddPaypalMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type TransferMethodAddPaypalMutation = { __typename?: 'Mutation', transferMethodAddPaypal?: Maybe<{ __typename?: 'TransferMethodAddPaypal', user?: Maybe<(
      { __typename?: 'UserType', id: string }
      & TransferMethodsFragment
    )>, error?: Maybe<(
      { __typename?: 'FieldErrorType' }
      & FieldErrorFragment
    )> }> };

export type TransferMethodAddPrepaidCardMutationVariables = Exact<{
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  language: Scalars['String'];
}>;


export type TransferMethodAddPrepaidCardMutation = { __typename?: 'Mutation', transferMethodAddPrepaidCard?: Maybe<{ __typename?: 'TransferMethodAddPrepaidCard', user?: Maybe<(
      { __typename?: 'UserType', id: string }
      & TransferMethodsFragment
    )>, error?: Maybe<(
      { __typename?: 'FieldErrorType' }
      & FieldErrorFragment
    )> }> };

export type TransferMethodAddVenmoMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type TransferMethodAddVenmoMutation = { __typename?: 'Mutation', transferMethodAddVenmo?: Maybe<{ __typename?: 'TransferMethodAddVenmo', user?: Maybe<(
      { __typename?: 'UserType', id: string }
      & TransferMethodsFragment
    )>, error?: Maybe<(
      { __typename?: 'FieldErrorType' }
      & FieldErrorFragment
    )> }> };

export type UpdateLanguageMutationVariables = Exact<{
  language: Scalars['String'];
}>;


export type UpdateLanguageMutation = { __typename?: 'Mutation', updateLanguage?: Maybe<{ __typename?: 'UpdateLanguage', user?: Maybe<{ __typename?: 'UserType', id: string }> }> };

export type ResetTranslationCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetTranslationCacheMutation = { __typename?: 'Mutation', resetTranslationCache?: Maybe<{ __typename?: 'ResetTranslationsCache', success?: Maybe<boolean> }> };

export type ApplicationsByFieldQueryVariables = Exact<{
  programId: Scalars['Int'];
  fieldName: Scalars['String'];
}>;


export type ApplicationsByFieldQuery = { __typename?: 'Query', applicationsByField?: Maybe<Array<Maybe<{ __typename?: 'ApplicationSummaryItem', key?: Maybe<string>, data?: Maybe<{ __typename?: 'ApplicationSummarySubItem', total?: Maybe<number>, approved?: Maybe<number>, inReview?: Maybe<number>, rejected?: Maybe<number> }> }>>> };

export type ApplicationsLastDaysQueryVariables = Exact<{
  programId: Scalars['Int'];
  days: Scalars['Int'];
}>;


export type ApplicationsLastDaysQuery = { __typename?: 'Query', applicationsLastDays?: Maybe<Array<Maybe<{ __typename?: 'ApplicationsByDayResponse', date?: Maybe<string>, number?: Maybe<number> }>>> };

export type LogsQueryVariables = Exact<{
  potentialUser: Scalars['ID'];
}>;


export type LogsQuery = { __typename?: 'Query', adminLogs?: Maybe<Array<{ __typename?: 'LogType', createdAt: any, id: string, entityType: LogsEntityType, action: LogsAction, originalValue?: Maybe<string>, newValue?: Maybe<string>, notes?: Maybe<string>, user?: Maybe<{ __typename?: 'UserType', email: string }> }>> };

export type ScheduledPaymentMutationMutationVariables = Exact<{
  upcomingIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
}>;


export type ScheduledPaymentMutationMutation = { __typename?: 'Mutation', scheduledPayments?: Maybe<{ __typename?: 'GetScheduledPaymentsById', allUpcomingScheduledPayments?: Maybe<Array<Maybe<{ __typename?: 'ScheduledPaymentType', id: string, amount: number, createdAt: any, scheduledDate: any, user?: Maybe<{ __typename?: 'UserType', firstName?: Maybe<string>, lastName?: Maybe<string>, email: string, transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<Maybe<{ __typename?: 'TransferMethodObjectTypeEdge', node?: Maybe<{ __typename?: 'TransferMethodObjectType', id: string, isCurrentMethod: boolean, statusCode?: Maybe<string>, type: TransferMethodType, halfLiner: string }> }>> } }>, fulfillmentPayment?: Maybe<{ __typename?: 'PaymentType', id: string, status: PaymentStatus, destination: { __typename?: 'TransferMethodObjectType', statusCode?: Maybe<string>, type: TransferMethodType, halfLiner: string } }> }>>> }> };

export type ResolveApplicationMutationVariables = Exact<{
  email: Scalars['String'];
  status: Scalars['String'];
}>;


export type ResolveApplicationMutation = { __typename?: 'Mutation', resolveApplication?: Maybe<{ __typename?: 'ResolveApplication', ok?: Maybe<boolean> }> };

export type SendOnboardingNotificationMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
}>;


export type SendOnboardingNotificationMutation = { __typename?: 'Mutation', sendOnboardingNotification?: Maybe<{ __typename?: 'SendOnboardingNotification', success?: Maybe<boolean> }> };

export type SendSonomaOnboardingNotificationMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
}>;


export type SendSonomaOnboardingNotificationMutation = { __typename?: 'Mutation', sendSonomaOnboardingNotification?: Maybe<{ __typename?: 'SendSonomaOnboardingNotification', success?: Maybe<boolean> }> };

export type SendOnboardingNotificationReminderMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
}>;


export type SendOnboardingNotificationReminderMutation = { __typename?: 'Mutation', sendOnboardingNotificationReminder?: Maybe<{ __typename?: 'SendOnboardingNotificationReminder', success?: Maybe<boolean> }> };

export type SurveySummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveySummaryQuery = { __typename?: 'Query', surveySummary?: Maybe<{ __typename?: 'SurveySummary', submittedAt?: Maybe<Array<Maybe<string>>>, completed?: Maybe<Array<Maybe<{ __typename?: 'UserType', id: string, email: string, firstName?: Maybe<string>, lastName?: Maybe<string>, phoneNumber: string }>>>, notCompleted?: Maybe<Array<Maybe<{ __typename?: 'UserType', id: string, email: string, firstName?: Maybe<string>, lastName?: Maybe<string>, phoneNumber: string }>>> }> };

export type AllUpcomingScheduledPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUpcomingScheduledPaymentsQuery = { __typename?: 'Query', allUpcomingScheduledPayments?: Maybe<Array<Maybe<{ __typename?: 'ScheduledPaymentType', id: string, amount: number, createdAt: any, scheduledDate: any, user?: Maybe<{ __typename?: 'UserType', isFrozen: boolean, firstName?: Maybe<string>, lastName?: Maybe<string>, email: string, transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<Maybe<{ __typename?: 'TransferMethodObjectTypeEdge', node?: Maybe<{ __typename?: 'TransferMethodObjectType', id: string, isCurrentMethod: boolean, statusCode?: Maybe<string>, type: TransferMethodType, halfLiner: string }> }>> } }>, fulfillmentPayment?: Maybe<{ __typename?: 'PaymentType', id: string, status: PaymentStatus, destination: { __typename?: 'TransferMethodObjectType', statusCode?: Maybe<string>, type: TransferMethodType, halfLiner: string } }> }>>> };

export type SendTextMessageMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
  text: Scalars['String'];
}>;


export type SendTextMessageMutation = { __typename?: 'Mutation', sendTextMessage?: Maybe<{ __typename?: 'SendTextMessage', success?: Maybe<boolean> }> };

export type PotentialUsersQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  inviteCode_Isnull?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  applicationStatus?: Maybe<Scalars['String']>;
  applicationStatus_Isnull?: Maybe<Scalars['Boolean']>;
  selectedFor_Isnull?: Maybe<Scalars['Boolean']>;
  invitationSent?: Maybe<Scalars['DateTime']>;
  invitationSent_Isnull?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['JSONString']>;
  assignedAdmin?: Maybe<Scalars['ID']>;
}>;


export type PotentialUsersQuery = { __typename?: 'Query', potentialUsers?: Maybe<{ __typename?: 'PotentialUserTypeConnection', totalCount?: Maybe<number>, edgeCount?: Maybe<number>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: Maybe<string>, startCursor?: Maybe<string> }, edges: Array<Maybe<{ __typename?: 'PotentialUserTypeEdge', node?: Maybe<{ __typename?: 'PotentialUserType', pk?: Maybe<number>, firstName: string, lastName: string, onboardingNotificationSent?: Maybe<any>, onboardingReminderNotificationSent?: Maybe<any>, email: string, phoneNumber?: Maybe<string>, startDate: any, createdAt: any, isLocked: boolean, selectedFor?: Maybe<string>, invitationSent?: Maybe<any>, inviteCode?: Maybe<string>, user: { __typename?: 'UserTypeConnection', edges: Array<Maybe<{ __typename?: 'UserTypeEdge', node?: Maybe<{ __typename?: 'UserType', pk?: Maybe<number> }> }>> }, program?: Maybe<{ __typename?: 'ProgramType', name: string }>, ssiBenefitAnswers: { __typename?: 'BenefitAnswerTypeConnection', edges: Array<Maybe<{ __typename?: 'BenefitAnswerTypeEdge', node?: Maybe<{ __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: Maybe<{ __typename?: 'HouseholdMemberType', id: string }> }> }>> }, selectedBenefits: { __typename?: 'BenefitSelectedTypeConnection', edges: Array<Maybe<{ __typename?: 'BenefitSelectedTypeEdge', node?: Maybe<{ __typename?: 'BenefitSelectedType', category: BenefitSelectedCategory }> }>> }, documents: { __typename?: 'DocumentTypeConnection', edges: Array<Maybe<{ __typename?: 'DocumentTypeEdge', node?: Maybe<{ __typename?: 'DocumentType', name?: Maybe<string>, verifiedBy?: Maybe<{ __typename?: 'UserType', id: string }> }> }>> }, flags: { __typename?: 'PotentialUserFlagTypeConnection', edges: Array<Maybe<{ __typename?: 'PotentialUserFlagTypeEdge', node?: Maybe<{ __typename?: 'PotentialUserFlagType', pk?: Maybe<number>, potentialUser?: Maybe<{ __typename?: 'PotentialUserType', firstName: string, lastName: string }> }> }>> } }> }>> }> };

export type NotSignedUpPotentialUsersQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  inviteCode_Isnull?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  applicationStatus?: Maybe<Scalars['String']>;
  applicationStatus_Isnull?: Maybe<Scalars['Boolean']>;
  selectedFor_Isnull?: Maybe<Scalars['Boolean']>;
  invitationSent?: Maybe<Scalars['DateTime']>;
  invitationSent_Isnull?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['JSONString']>;
  assignedAdmin?: Maybe<Scalars['ID']>;
}>;


export type NotSignedUpPotentialUsersQuery = { __typename?: 'Query', notSignedUpPotentialUsers?: Maybe<{ __typename?: 'PotentialUserTypeConnection', totalCount?: Maybe<number>, edgeCount?: Maybe<number>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: Maybe<string>, startCursor?: Maybe<string> }, edges: Array<Maybe<{ __typename?: 'PotentialUserTypeEdge', node?: Maybe<{ __typename?: 'PotentialUserType', pk?: Maybe<number>, firstName: string, lastName: string, onboardingNotificationSent?: Maybe<any>, onboardingReminderNotificationSent?: Maybe<any>, email: string, phoneNumber?: Maybe<string>, startDate: any, createdAt: any, isLocked: boolean, selectedFor?: Maybe<string>, invitationSent?: Maybe<any>, inviteCode?: Maybe<string>, program?: Maybe<{ __typename?: 'ProgramType', name: string }>, ssiBenefitAnswers: { __typename?: 'BenefitAnswerTypeConnection', edges: Array<Maybe<{ __typename?: 'BenefitAnswerTypeEdge', node?: Maybe<{ __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: Maybe<{ __typename?: 'HouseholdMemberType', id: string }> }> }>> }, documents: { __typename?: 'DocumentTypeConnection', edges: Array<Maybe<{ __typename?: 'DocumentTypeEdge', node?: Maybe<{ __typename?: 'DocumentType', name?: Maybe<string>, verifiedBy?: Maybe<{ __typename?: 'UserType', id: string }> }> }>> }, flags: { __typename?: 'PotentialUserFlagTypeConnection', edges: Array<Maybe<{ __typename?: 'PotentialUserFlagTypeEdge', node?: Maybe<{ __typename?: 'PotentialUserFlagType', pk?: Maybe<number>, potentialUser?: Maybe<{ __typename?: 'PotentialUserType', firstName: string, lastName: string }> }> }>> } }> }>> }> };

export type UserSearchQueryVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type UserSearchQuery = { __typename?: 'Query', userSearch?: Maybe<{ __typename?: 'UserTypeConnection', edges: Array<Maybe<{ __typename?: 'UserTypeEdge', node?: Maybe<{ __typename?: 'UserType', pk?: Maybe<number>, securityQuestionAnswer: string, securityQuestionQuestion: string, lastName?: Maybe<string>, firstName?: Maybe<string>, email: string, phoneNumber: string, isSuperuser: boolean, paymentAmount?: Maybe<number>, paymentFrequencyType?: Maybe<UserPaymentFrequencyType>, language: UserLanguage, startDate?: Maybe<any>, transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<Maybe<{ __typename?: 'TransferMethodObjectTypeEdge', node?: Maybe<{ __typename?: 'TransferMethodObjectType', oneLiner: string, isCurrentMethod: boolean, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, zipCode?: Maybe<string>, statusCode?: Maybe<string> }> }>> } }> }>> }> };

export type AdminUsersTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUsersTemplateQuery = { __typename?: 'Query', templateCsv?: Maybe<string> };

export type PotentialUsersForOnboardingNotificationsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  reminder?: Maybe<Scalars['Boolean']>;
}>;


export type PotentialUsersForOnboardingNotificationsQuery = { __typename?: 'Query', potentialUsersForOnboardingNotifications?: Maybe<Array<Maybe<{ __typename?: 'PotentialUserType', id: string, firstName: string, lastName: string }>>> };

export type SendBenefitsInvitationMutationVariables = Exact<{ [key: string]: never; }>;


export type SendBenefitsInvitationMutation = { __typename?: 'Mutation', sendBenefitsInvitation?: Maybe<{ __typename?: 'SendBenefitsInvitation', success?: Maybe<boolean> }> };

export type GetCalendlyArrayScheduledEventQueryVariables = Exact<{
  potentialUserIdList?: Maybe<Array<Maybe<Scalars['ID']>>>;
}>;


export type GetCalendlyArrayScheduledEventQuery = { __typename?: 'Query', listOfScheduledEvents?: Maybe<Array<Maybe<{ __typename?: 'CalendlyEventType', createdAt?: Maybe<string>, name?: Maybe<string>, status?: Maybe<string>, potentialUserId?: Maybe<number>, startTime?: Maybe<string>, endTime?: Maybe<string> }>>> };

export type UpdateConfigurationsMutationVariables = Exact<{
  configurations: Scalars['JSONString'];
}>;


export type UpdateConfigurationsMutation = { __typename?: 'Mutation', updateConfigurations?: Maybe<{ __typename?: 'UpdateConfigurations', success?: Maybe<boolean> }> };

export type AdminConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminConfigurationsQuery = { __typename?: 'Query', configurationsJson?: Maybe<any> };

export type ProgramHealthCheckQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type ProgramHealthCheckQuery = { __typename?: 'Query', healthCheckData?: Maybe<{ __typename?: 'HealthCheckData', usioBalance?: Maybe<number>, hyperwalletBalance?: Maybe<number>, upcomingUsioPayments?: Maybe<number>, upcomingHyperwalletPayments?: Maybe<number>, moneyStatusUsio?: Maybe<boolean>, moneyStatusHyperwallet?: Maybe<boolean>, hyperwalletHealth?: Maybe<boolean>, usioHealth?: Maybe<boolean>, notSignedUpUsers?: Maybe<number>, totalPotentialUsers?: Maybe<number>, totalUsers?: Maybe<number>, usersWithTransferMethod?: Maybe<number>, usersPrepaidCardAndActiveStatus?: Maybe<number>, usersPrepaidCard?: Maybe<number>, timestamp?: Maybe<string>, programUrl?: Maybe<string> }> };

export type AllProgramsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramsQueryQuery = { __typename?: 'Query', allPrograms?: Maybe<Array<Maybe<{ __typename?: 'ProgramType', id: string, name: string }>>> };

export type UploadMutationMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadMutationMutation = { __typename?: 'Mutation', uploadMutation?: Maybe<{ __typename?: 'UploadMutation', success?: Maybe<boolean> }> };

export type CoordinatesQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type CoordinatesQuery = { __typename?: 'Query', coordinates?: Maybe<Array<Maybe<Array<Maybe<number>>>>> };

export type UserCoordinatesQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type UserCoordinatesQuery = { __typename?: 'Query', userCoordinates?: Maybe<Array<Maybe<Array<Maybe<number>>>>> };

export type ProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramsQuery = { __typename?: 'Query', programs?: Maybe<Array<Maybe<{ __typename?: 'ProgramType', name: string, paymentFrequency: ProgramPaymentFrequency, urlFragment: string, paymentAmount: number, programDuration: any, pk?: Maybe<number> }>>> };

export type AddApplicationAnswersMutationVariables = Exact<{
  answers: Array<ProgramApplicationAnswerInputType>;
}>;


export type AddApplicationAnswersMutation = { __typename?: 'Mutation', addApplicationAnswers?: Maybe<{ __typename?: 'AddApplicationAnswers', success?: Maybe<boolean> }> };

export type ApplyMutationVariables = Exact<{
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  city: Scalars['String'];
  dob?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  postalCode: Scalars['String'];
  programUrl: Scalars['String'];
  language: Scalars['String'];
  ethnicity?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
}>;


export type ApplyMutation = { __typename?: 'Mutation', apply?: Maybe<{ __typename?: 'Apply', error?: Maybe<boolean>, application?: Maybe<{ __typename?: 'PotentialUserApplicationType', id: string, intercomKey?: Maybe<string> }> }> };

export type GetProgramsMutationVariables = Exact<{
  programUrl: Scalars['String'];
  includeClosedPeriod?: Maybe<Scalars['Boolean']>;
}>;


export type GetProgramsMutation = { __typename?: 'Mutation', getPrograms?: Maybe<{ __typename?: 'GetPrograms', success?: Maybe<boolean> }> };

export type GetPotentialUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPotentialUserMutation = { __typename?: 'Mutation', getPotentialUser?: Maybe<{ __typename?: 'GetPotentialUser', potentialUser?: Maybe<{ __typename?: 'PotentialUserType', firstName: string, lastName: string, phoneNumber?: Maybe<string>, paymentAmount: number, email: string, createdAt: any, updatedAt: any, isLocked: boolean, addressLine1: string, inviteCode?: Maybe<string>, dob?: Maybe<string>, invitationSent?: Maybe<any>, addressLine2?: Maybe<string>, city: string, state: string, country: string, applicationStatus?: Maybe<PotentialUserApplicationStatus>, postalCode: string, medianHouseholdIncome?: Maybe<number>, language?: Maybe<string>, tractCode?: Maybe<string>, pk?: Maybe<number>, selectedFor?: Maybe<string>, blindDisabled?: Maybe<boolean>, assignedAdmin?: Maybe<{ __typename?: 'UserType', firstName?: Maybe<string>, lastName?: Maybe<string> }>, ssiBenefitAnswers: { __typename?: 'BenefitAnswerTypeConnection', edges: Array<Maybe<{ __typename?: 'BenefitAnswerTypeEdge', node?: Maybe<{ __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: Maybe<{ __typename?: 'HouseholdMemberType', id: string }> }> }>> }, householdMembers: Array<{ __typename?: 'HouseholdMemberType', id: string, name: string, dob: any, relation: string, blindDisabled?: Maybe<boolean> }> }>, documents?: Maybe<Array<Maybe<{ __typename?: 'DocumentType', id: string, documentType?: Maybe<DocumentDocumentType>, name?: Maybe<string>, updatedAt: any, createdAt: any, uploadedAt: any, requestedAs?: Maybe<string>, verifiedBy?: Maybe<{ __typename?: 'UserType', firstName?: Maybe<string>, lastName?: Maybe<string>, email: string }> }>>>, flags?: Maybe<Array<Maybe<{ __typename?: 'PotentialUserFlagType', flagType: PotentialUserFlagFlagType, inactive: boolean, pk?: Maybe<number>, potentialUser?: Maybe<{ __typename?: 'PotentialUserType', pk?: Maybe<number> }>, matchedPotentialUser?: Maybe<{ __typename?: 'PotentialUserType', firstName: string, lastName: string, pk?: Maybe<number>, flagsPotentialUser: { __typename?: 'PotentialUserFlagTypeConnection', edges: Array<Maybe<{ __typename?: 'PotentialUserFlagTypeEdge', node?: Maybe<{ __typename?: 'PotentialUserFlagType', inactive: boolean, pk?: Maybe<number>, potentialUser?: Maybe<{ __typename?: 'PotentialUserType', pk?: Maybe<number> }> }> }>> } }> }>>>, householdMembers?: Maybe<Array<Maybe<{ __typename?: 'HouseholdMemberType', name: string, dob: any, relation: string }>>>, applicationAnswers?: Maybe<Array<Maybe<{ __typename?: 'ProgramApplicationAnswerType', answerCategory: ProgramApplicationAnswerAnswerCategory, response: string }>>> }> };

export type MakeFlagInactiveMutationVariables = Exact<{
  pk: Scalars['ID'];
  relatedPotentialPk?: Maybe<Scalars['ID']>;
  potentialUserPk: Scalars['ID'];
}>;


export type MakeFlagInactiveMutation = { __typename?: 'Mutation', makeFlagInactive?: Maybe<{ __typename?: 'MakeFlagInactive', success?: Maybe<boolean> }> };

export type DocumentUploadMutationVariables = Exact<{
  file: Scalars['Upload'];
  potentialUserId: Scalars['ID'];
  documentType: Scalars['String'];
}>;


export type DocumentUploadMutation = { __typename?: 'Mutation', documentUpload?: Maybe<{ __typename?: 'DocumentUpload', documentUploadSuccess?: Maybe<boolean> }> };

export type RequestDocumentMutationVariables = Exact<{
  requestedDocumentList: Array<Maybe<Scalars['String']>>;
  potentialUserId: Scalars['ID'];
}>;


export type RequestDocumentMutation = { __typename?: 'Mutation', requestDocument?: Maybe<{ __typename?: 'RequestDocument', documentRequestSuccess?: Maybe<boolean> }> };

export type SendConfirmationMutationVariables = Exact<{
  potentialUserId: Scalars['ID'];
}>;


export type SendConfirmationMutation = { __typename?: 'Mutation', sendConfirmation?: Maybe<{ __typename?: 'SendConfirmation', ok?: Maybe<boolean> }> };

export type SendDocumentsUploadConfirmationMutationVariables = Exact<{
  potentialUserId: Scalars['ID'];
  documentType?: Maybe<Scalars['String']>;
}>;


export type SendDocumentsUploadConfirmationMutation = { __typename?: 'Mutation', sendDocumentsUploadConfirmation?: Maybe<{ __typename?: 'SendDocumentsUploadConfirmation', ok?: Maybe<boolean> }> };

export type SaveHouseholdMembersMutationVariables = Exact<{
  potentialUserId: Scalars['ID'];
  householdMembers: Array<HouseholdMemberInputType>;
}>;


export type SaveHouseholdMembersMutation = { __typename?: 'Mutation', saveHouseholdMembers?: Maybe<{ __typename?: 'SaveHouseholdMembers', success?: Maybe<boolean> }> };

export type ListOfUploadedDocumentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListOfUploadedDocumentsQuery = { __typename?: 'Query', listOfUploadedDocuments?: Maybe<string> };

export type ListOfUploadedDocumentsIncludingNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListOfUploadedDocumentsIncludingNameQuery = { __typename?: 'Query', listOfUploadedDocumentsIncludingName?: Maybe<Array<Maybe<{ __typename?: 'DocumentType', name?: Maybe<string>, documentType?: Maybe<DocumentDocumentType> }>>> };

export type CountHouseholdMembersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CountHouseholdMembersQuery = { __typename?: 'Query', countHouseholdMembers?: Maybe<number> };

export type AddressAutocompleteQueryQueryVariables = Exact<{
  value?: Maybe<Scalars['String']>;
}>;


export type AddressAutocompleteQueryQuery = { __typename?: 'Query', addressAutocomplete?: Maybe<Array<Maybe<{ __typename?: 'AddressAutocomplete', placeId?: Maybe<string>, description?: Maybe<string> }>>> };

export type AddressDetailsQueryQueryVariables = Exact<{
  placeId?: Maybe<Scalars['String']>;
}>;


export type AddressDetailsQueryQuery = { __typename?: 'Query', addressDetails?: Maybe<{ __typename?: 'AddressDetails', address1?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, postalCode?: Maybe<string> }> };

export type PasswordChangeMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
}>;


export type PasswordChangeMutation = { __typename?: 'Mutation', passwordChange?: Maybe<{ __typename?: 'PasswordChangeExtended', success?: Maybe<boolean>, errors?: Maybe<any> }> };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: Maybe<{ __typename?: 'DeleteDocument', ok?: Maybe<boolean> }> };

export type ApproveDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
  adminId: Scalars['ID'];
}>;


export type ApproveDocumentMutation = { __typename?: 'Mutation', approveDocument?: Maybe<{ __typename?: 'ApproveDocument', ok?: Maybe<boolean> }> };

export type RequestSingleDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
  potentialUserId: Scalars['ID'];
}>;


export type RequestSingleDocumentMutation = { __typename?: 'Mutation', requestSingleDocument?: Maybe<{ __typename?: 'RequestSingleDocument', ok?: Maybe<boolean> }> };

export type SendDocumentReminderMutationVariables = Exact<{
  potentialUserId: Scalars['ID'];
}>;


export type SendDocumentReminderMutation = { __typename?: 'Mutation', sendDocumentReminder?: Maybe<{ __typename?: 'SendDocumentReminder', ok?: Maybe<boolean> }> };

export type NotesMutationVariables = Exact<{
  note: Scalars['String'];
  potentialUser: Scalars['ID'];
}>;


export type NotesMutation = { __typename?: 'Mutation', addNote?: Maybe<{ __typename?: 'CreateNote', ok?: Maybe<boolean> }> };

export type EditUserAndPotentialUserMutationVariables = Exact<{
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  dob: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  addressLine1: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  language: Scalars['String'];
  pk: Scalars['ID'];
}>;


export type EditUserAndPotentialUserMutation = { __typename?: 'Mutation', editUserAndPotentialUser?: Maybe<{ __typename?: 'EditUserAndPotentialUser', ok?: Maybe<boolean> }> };

export type DocumentQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type DocumentQuery = { __typename?: 'Query', document?: Maybe<{ __typename?: 'DocumentData', document?: Maybe<string>, encoding?: Maybe<string>, name?: Maybe<string> }> };

export type AdminNotesQueryVariables = Exact<{
  potentialUser?: Maybe<Scalars['ID']>;
}>;


export type AdminNotesQuery = { __typename?: 'Query', adminNotes?: Maybe<Array<{ __typename?: 'NoteType', id: string, createdAt: any, note?: Maybe<string>, admin: { __typename?: 'UserType', email: string } }>> };

export type PolicyEngineQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type PolicyEngineQuery = { __typename?: 'Query', policyEngineData?: Maybe<{ __typename?: 'PolicyEngineType', withGi: any, withoutGi: any, result?: Maybe<number> }> };

export type BenefitsAnswersMutationVariables = Exact<{
  answers: Array<BenefitAnswerInputType>;
}>;


export type BenefitsAnswersMutation = { __typename?: 'Mutation', addBenefitAnswers?: Maybe<{ __typename?: 'AddBenefitAnswers', ok?: Maybe<boolean>, error?: Maybe<string> }> };

export type BenefitsSelectionMutationVariables = Exact<{
  benefits: Array<BenefitSelectedInputType>;
}>;


export type BenefitsSelectionMutation = { __typename?: 'Mutation', selectBenefits?: Maybe<{ __typename?: 'SelectBenefits', ok?: Maybe<boolean>, error?: Maybe<string> }> };

export type UpdateBlindDisabledMutationVariables = Exact<{
  blindDisabled: Scalars['Boolean'];
  inviteCode?: Maybe<Scalars['String']>;
  verificationCode?: Maybe<Scalars['String']>;
}>;


export type UpdateBlindDisabledMutation = { __typename?: 'Mutation', updateBlindDisabled?: Maybe<{ __typename?: 'UpdateBlindDisabled', ok?: Maybe<boolean>, error?: Maybe<string> }> };

export type BenefitsAnswerQueryQueryVariables = Exact<{
  potentialUserId: Scalars['ID'];
}>;


export type BenefitsAnswerQueryQuery = { __typename?: 'Query', benefitsAnswers?: Maybe<Array<Maybe<{ __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: Maybe<{ __typename?: 'HouseholdMemberType', id: string, name: string, dob: any, relation: string, blindDisabled?: Maybe<boolean> }> }>>> };

export type SelectedBenefitsQueryQueryVariables = Exact<{
  potentialUserId: Scalars['ID'];
}>;


export type SelectedBenefitsQueryQuery = { __typename?: 'Query', selectedBenefits?: Maybe<Array<Maybe<{ __typename?: 'BenefitSelectedType', category: BenefitSelectedCategory }>>> };

export type GetApplicationDataQueryVariables = Exact<{
  inviteCode?: Maybe<Scalars['String']>;
  verificationCode?: Maybe<Scalars['String']>;
}>;


export type GetApplicationDataQuery = { __typename?: 'Query', potentialUserApplication?: Maybe<{ __typename?: 'PotentialUserType', firstName: string, lastName: string, dob?: Maybe<string>, blindDisabled?: Maybe<boolean>, householdMembers: Array<{ __typename?: 'HouseholdMemberType', id: string, name: string, dob: any, relation: string, blindDisabled?: Maybe<boolean> }> }> };

export type GetCalendlyScheduledEventQueryVariables = Exact<{
  potentialUserId: Scalars['ID'];
}>;


export type GetCalendlyScheduledEventQuery = { __typename?: 'Query', scheduledEvent?: Maybe<{ __typename?: 'CalendlyEventType', createdAt?: Maybe<string>, name?: Maybe<string>, status?: Maybe<string>, startTime?: Maybe<string>, endTime?: Maybe<string> }> };

export type RegisterMutationVariables = Exact<{
  email: Scalars['String'];
  password1: Scalars['String'];
  password2: Scalars['String'];
  inviteCode: Scalars['String'];
  phoneNumber: Scalars['String'];
  dob: Scalars['String'];
  language: Scalars['String'];
  securityQuestionQuestion: Scalars['String'];
  securityQuestionAnswer: Scalars['String'];
  program: Scalars['String'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: Maybe<{ __typename?: 'RegisterExtended', success?: Maybe<boolean>, errors?: Maybe<any>, token?: Maybe<string>, refreshToken?: Maybe<string> }> };

export type SaveSixDigitVerificationCodeForPotentialUserMutationVariables = Exact<{
  potentialUserId: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type SaveSixDigitVerificationCodeForPotentialUserMutation = { __typename?: 'Mutation', saveSixDigitVerificationCodeForPotentialUser?: Maybe<{ __typename?: 'SaveSixDigitVerificationCodeForPotentialUser', success?: Maybe<boolean> }> };

export type CheckSixDigitVerificationCodeForPotentialUserMutationVariables = Exact<{
  potentialUserId: Scalars['String'];
  verificationCode: Scalars['String'];
}>;


export type CheckSixDigitVerificationCodeForPotentialUserMutation = { __typename?: 'Mutation', checkSixDigitVerificationCodeForPotentialUser?: Maybe<{ __typename?: 'CheckSixDigitVerificationCodeForPotentialUser', success?: Maybe<boolean> }> };

export type OnboardingLogosQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OnboardingLogosQuery = { __typename?: 'Query', onboardingLogos?: Maybe<Array<Maybe<{ __typename?: 'OnboardingLogosType', position?: Maybe<number>, image: string, url: string }>>> };

export type SpeakBenefitsCounselorMutationVariables = Exact<{
  firstName: Scalars['String'];
  language: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
  potentialUserId: Scalars['ID'];
}>;


export type SpeakBenefitsCounselorMutation = { __typename?: 'Mutation', speakBenefitsCounselor?: Maybe<{ __typename?: 'SpeakBenefitsCounselor', ok?: Maybe<boolean> }> };

export type PotentialUserFragment = { __typename?: 'PotentialUserType', id: string, firstName: string, lastName: string, blindDisabled?: Maybe<boolean>, phoneNumber?: Maybe<string>, paymentAmount: number, numberOfMonths?: Maybe<number>, paymentFrequencyType: PotentialUserPaymentFrequencyType, email: string, dob?: Maybe<string>, inviteCode?: Maybe<string>, language?: Maybe<string>, program?: Maybe<{ __typename?: 'ProgramType', urlFragment: string }> };

export type CodeValidationQueryVariables = Exact<{
  inviteCode?: Maybe<Scalars['String']>;
  resetToken?: Maybe<Scalars['String']>;
  verificationCode?: Maybe<Scalars['String']>;
}>;


export type CodeValidationQuery = { __typename?: 'Query', codeValidation?: Maybe<{ __typename?: 'InviteCodeValidationQueryResponse', alreadySignedUp?: Maybe<boolean>, potentialUser?: Maybe<(
      { __typename?: 'PotentialUserType' }
      & PotentialUserFragment
    )> }> };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: Maybe<{ __typename?: 'SendPasswordResetEmail', success?: Maybe<boolean>, errors?: Maybe<any> }> };

export type MyRecentPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRecentPaymentsQuery = { __typename?: 'Query', myRecentPayments?: Maybe<Array<Maybe<{ __typename?: 'PaymentType', id: string, amount: number, createdAt: any, status: PaymentStatus, destination: { __typename?: 'TransferMethodObjectType', oneLiner: string, halfLiner: string, type: TransferMethodType } }>>> };

export type MyUpcomingPaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUpcomingPaymentQuery = { __typename?: 'Query', myUpcomingPayment?: Maybe<{ __typename?: 'ScheduledPaymentType', id: string, scheduledDate: any, amount: number }> };

export type StylesQueryVariables = Exact<{ [key: string]: never; }>;


export type StylesQuery = { __typename?: 'Query', styles?: Maybe<{ __typename?: 'StylesType', primaryColor: string, secondaryColor: string, tertiaryColor: string, hoverColor: string, backgroundColor: string, sidebarLogo: string, sidebarLogoMobile: string, sidebarImage: string }> };

export type CardBalanceQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type CardBalanceQuery = { __typename?: 'Query', cardBalance?: Maybe<number> };

export type GetInitialDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataQuery = { __typename?: 'Query', translations?: Maybe<any>, program?: Maybe<{ __typename?: 'ProgramType', name: string, paymentFrequency: ProgramPaymentFrequency, paymentAmount: number, programDuration: any, numberOfMonths?: Maybe<number>, ssiBenefitsWizardEnabled: boolean, id: string, urlFragment: string }>, organizationConfigs?: Maybe<{ __typename?: 'OrganizationConfigsType', facebookLink?: Maybe<string>, instagramLink?: Maybe<string>, phoneNumber?: Maybe<string>, replyToEmail?: Maybe<string>, timezone?: Maybe<string>, twitterLink?: Maybe<string>, typeformId?: Maybe<string>, typeformSubdomain?: Maybe<string>, websiteLink?: Maybe<string>, isTypeformBound?: Maybe<boolean>, whatsappPhoneNumber?: Maybe<string> }>, organization?: Maybe<{ __typename?: 'OrganizationType', version: number, webAppUrl: string, name: string, id: string }>, documentRequirement?: Maybe<Array<Maybe<{ __typename?: 'DocumentRequireType', type?: Maybe<DocumentRequirementType>, required: boolean }>>> };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', tokenAuth?: Maybe<{ __typename?: 'ObtainJSONWebTokenExtended', success?: Maybe<boolean>, token?: Maybe<string>, refreshToken?: Maybe<string>, errors?: Maybe<any> }> };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset?: Maybe<{ __typename?: 'PasswordResetExtended', success?: Maybe<boolean>, errors?: Maybe<any> }> };

export type UpdateSettingsMutationVariables = Exact<{
  transferMethodId: Scalars['ID'];
  emailNotificationsEnabled: Scalars['Boolean'];
  smsNotificationsEnabled: Scalars['Boolean'];
  optedForWhatsapp: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings?: Maybe<{ __typename?: 'UpdateSettings', user?: Maybe<(
      { __typename?: 'UserType' }
      & SettingsPageUserFragment
    )>, error?: Maybe<(
      { __typename?: 'FieldErrorType' }
      & FieldErrorFragment
    )> }> };

export type SettingsPageUserFragment = (
  { __typename?: 'UserType', id: string, emailNotificationsEnabled: boolean, smsNotificationsEnabled: boolean, optedForWhatsapp?: Maybe<boolean> }
  & TransferMethodsFragment
);

export type SettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageQuery = { __typename?: 'Query', me?: Maybe<(
    { __typename?: 'UserType' }
    & SettingsPageUserFragment
  )> };

export type CheckReachedVerifyScreenMutationVariables = Exact<{
  potentialUserId: Scalars['ID'];
}>;


export type CheckReachedVerifyScreenMutation = { __typename?: 'Mutation', checkReachedVerifyScreen?: Maybe<{ __typename?: 'CheckReachedVerifyScreen', success?: Maybe<boolean> }> };

export type GetPotentialUserWithHashedIdQueryVariables = Exact<{
  hashedId: Scalars['String'];
}>;


export type GetPotentialUserWithHashedIdQuery = { __typename?: 'Query', potentialUserWithHashedId?: Maybe<{ __typename?: 'PotentialUserType', id: string, firstName: string, lastName: string, phoneNumber?: Maybe<string>, paymentAmount: number, email: string, createdAt: any, updatedAt: any, isLocked: boolean, addressLine1: string, inviteCode?: Maybe<string>, dob?: Maybe<string>, addressLine2?: Maybe<string>, city: string, state: string, country: string, applicationStatus?: Maybe<PotentialUserApplicationStatus>, postalCode: string, medianHouseholdIncome?: Maybe<number>, language?: Maybe<string>, tractCode?: Maybe<string>, reachedVerifyScreen: boolean, pk?: Maybe<number>, selectedFor?: Maybe<string>, blindDisabled?: Maybe<boolean>, ssiBenefitAnswers: { __typename?: 'BenefitAnswerTypeConnection', edges: Array<Maybe<{ __typename?: 'BenefitAnswerTypeEdge', node?: Maybe<{ __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: Maybe<{ __typename?: 'HouseholdMemberType', id: string }> }> }>> }, documents: { __typename?: 'DocumentTypeConnection', edges: Array<Maybe<{ __typename?: 'DocumentTypeEdge', node?: Maybe<{ __typename?: 'DocumentType', id: string, documentType?: Maybe<DocumentDocumentType>, name?: Maybe<string>, updatedAt: any, createdAt: any, uploadedAt: any, requestedAs?: Maybe<string>, verifiedBy?: Maybe<{ __typename?: 'UserType', firstName?: Maybe<string>, lastName?: Maybe<string>, email: string }> }> }>> }, answers: { __typename?: 'ProgramApplicationAnswerTypeConnection', edges: Array<Maybe<{ __typename?: 'ProgramApplicationAnswerTypeEdge', node?: Maybe<{ __typename?: 'ProgramApplicationAnswerType', answerCategory: ProgramApplicationAnswerAnswerCategory, response: string }> }>> } }> };

export type GetUserAnswersQueryVariables = Exact<{
  id: Scalars['ID'];
  forType: Scalars['String'];
}>;


export type GetUserAnswersQuery = { __typename?: 'Query', userAnswers?: Maybe<{ __typename?: 'ProgramApplicationAnswerType', response: string }> };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: Maybe<{ __typename?: 'RefreshToken', token?: Maybe<string>, payload?: Maybe<any>, success?: Maybe<boolean>, errors?: Maybe<any>, refreshToken?: Maybe<string> }> };

export type TransferMethodsFragment = { __typename?: 'UserType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<Maybe<{ __typename?: 'TransferMethodObjectTypeEdge', node?: Maybe<{ __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, zipCode?: Maybe<string>, statusCode?: Maybe<string>, deleted: boolean }> }>> } };

export type UpdateDetailsMutationVariables = Exact<{
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
}>;


export type UpdateDetailsMutation = { __typename?: 'Mutation', updateDetails?: Maybe<{ __typename?: 'UpdateDetails', success?: Maybe<boolean> }> };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: Maybe<{ __typename?: 'Logout', ok?: Maybe<boolean> }> };

export type MakePaymentsMutationVariables = Exact<{
  scheduledPaymentIds: Array<Maybe<Scalars['ID']>>;
}>;


export type MakePaymentsMutation = { __typename?: 'Mutation', makepayments?: Maybe<{ __typename?: 'MakePayments', ok?: Maybe<boolean> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: Maybe<(
    { __typename?: 'UserType', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, usioToken?: Maybe<string>, hyperwalletToken?: Maybe<string>, phoneNumber: string, email: string, createdAt: any, pk?: Maybe<number>, isSuperuser: boolean, dob?: Maybe<string>, smsNotificationsEnabled: boolean, emailNotificationsEnabled: boolean, optedForWhatsapp?: Maybe<boolean>, paymentAmount?: Maybe<number>, language: UserLanguage, paymentFrequencyType?: Maybe<UserPaymentFrequencyType>, organization?: Maybe<{ __typename?: 'OrganizationType', id: string, name: string }>, potentialUser?: Maybe<{ __typename?: 'PotentialUserType', addressLine1: string, addressLine2?: Maybe<string>, city: string, postalCode: string, state: string, id: string, intercomKey?: Maybe<string>, numberOfMonths?: Maybe<number>, language?: Maybe<string>, program?: Maybe<{ __typename?: 'ProgramType', id: string, urlFragment: string }> }> }
    & TransferMethodsFragment
  )> };

export type SurveyAvailableQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveyAvailableQuery = { __typename?: 'Query', surveyAvailable?: Maybe<boolean> };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: Maybe<Array<Maybe<{ __typename?: 'UserType', firstName?: Maybe<string>, lastName?: Maybe<string>, pk?: Maybe<number>, phoneNumber: string, paymentAmount?: Maybe<number>, paymentFrequencyType?: Maybe<UserPaymentFrequencyType>, language: UserLanguage, startDate?: Maybe<any> }>>> };

export type FieldErrorFragment = { __typename?: 'FieldErrorType', fieldName?: Maybe<string>, code?: Maybe<string> };

export type OrganizationConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationConfigsQuery = { __typename?: 'Query', organizationConfigs?: Maybe<{ __typename?: 'OrganizationConfigsType', replyToEmail?: Maybe<string>, phoneNumber?: Maybe<string>, timezone?: Maybe<string>, isTypeformBound?: Maybe<boolean>, typeformId?: Maybe<string>, typeformSubdomain?: Maybe<string>, websiteLink?: Maybe<string>, instagramLink?: Maybe<string>, twitterLink?: Maybe<string>, facebookLink?: Maybe<string> }> };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', organization?: Maybe<{ __typename?: 'OrganizationType', version: number, name: string }> };

export type ProgramQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramQuery = { __typename?: 'Query', program?: Maybe<{ __typename?: 'ProgramType', name: string, paymentFrequency: ProgramPaymentFrequency, paymentAmount: number, urlFragment: string, programDuration: any }> };

export type TransferMethodRemoveMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TransferMethodRemoveMutation = { __typename?: 'Mutation', transferMethodRemove?: Maybe<{ __typename?: 'TransferMethodRemove', user?: Maybe<{ __typename?: 'UserType', id: string }> }> };

export type FaqNinjaWizardTypeQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type FaqNinjaWizardTypeQuery = { __typename?: 'Query', ninjaWizardData?: Maybe<{ __typename?: 'FaqNinjaWizardType', id: string, ninjaCode: string, language: FaqNinjaWizardLanguage, org: { __typename?: 'OrganizationType', name: string } }> };

export const PotentialUserFragmentDoc = gql`
    fragment PotentialUser on PotentialUserType {
  id
  firstName
  lastName
  blindDisabled
  phoneNumber
  paymentAmount
  numberOfMonths
  paymentFrequencyType
  email
  dob
  inviteCode
  language
  program {
    urlFragment
  }
}
    `;
export const TransferMethodsFragmentDoc = gql`
    fragment TransferMethods on UserType {
  transferMethods {
    edges {
      node {
        id
        type
        halfLiner
        oneLiner
        isCurrentMethod
        address1
        address2
        city
        zipCode
        statusCode
        deleted
      }
    }
  }
}
    `;
export const SettingsPageUserFragmentDoc = gql`
    fragment SettingsPageUser on UserType {
  id
  emailNotificationsEnabled
  smsNotificationsEnabled
  optedForWhatsapp
  ...TransferMethods
}
    ${TransferMethodsFragmentDoc}`;
export const FieldErrorFragmentDoc = gql`
    fragment FieldError on FieldErrorType {
  fieldName
  code
}
    `;
export const TransferMethodAddBankAccountDocument = gql`
    mutation TransferMethodAddBankAccount($bankAccountId: String!, $branchId: String!, $accountPurpose: String!, $firstName: String!, $lastName: String!, $addressLine1: String!, $addressLine2: String, $city: String!, $state: String!, $postalCode: String!) {
  transferMethodAddBankAccount(bankAccountId: $bankAccountId, branchId: $branchId, accountPurpose: $accountPurpose, firstName: $firstName, lastName: $lastName, addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, postalCode: $postalCode) {
    user {
      id
      ...TransferMethods
    }
    error {
      ...FieldError
    }
    errorLabel {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddBankAccountMutationFn = Apollo.MutationFunction<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>;

/**
 * __useTransferMethodAddBankAccountMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddBankAccountMutation, { data, loading, error }] = useTransferMethodAddBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      branchId: // value for 'branchId'
 *      accountPurpose: // value for 'accountPurpose'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useTransferMethodAddBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>) {
        return Apollo.useMutation<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>(TransferMethodAddBankAccountDocument, baseOptions);
      }
export type TransferMethodAddBankAccountMutationHookResult = ReturnType<typeof useTransferMethodAddBankAccountMutation>;
export type TransferMethodAddBankAccountMutationResult = Apollo.MutationResult<TransferMethodAddBankAccountMutation>;
export type TransferMethodAddBankAccountMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>;
export const TransferMethodAddPaypalDocument = gql`
    mutation TransferMethodAddPaypal($email: String!) {
  transferMethodAddPaypal(email: $email) {
    user {
      id
      ...TransferMethods
    }
    error {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddPaypalMutationFn = Apollo.MutationFunction<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>;

/**
 * __useTransferMethodAddPaypalMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddPaypalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddPaypalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddPaypalMutation, { data, loading, error }] = useTransferMethodAddPaypalMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useTransferMethodAddPaypalMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>) {
        return Apollo.useMutation<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>(TransferMethodAddPaypalDocument, baseOptions);
      }
export type TransferMethodAddPaypalMutationHookResult = ReturnType<typeof useTransferMethodAddPaypalMutation>;
export type TransferMethodAddPaypalMutationResult = Apollo.MutationResult<TransferMethodAddPaypalMutation>;
export type TransferMethodAddPaypalMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>;
export const TransferMethodAddPrepaidCardDocument = gql`
    mutation TransferMethodAddPrepaidCard($addressLine1: String!, $addressLine2: String, $city: String!, $state: String!, $postalCode: String!, $language: String!) {
  transferMethodAddPrepaidCard(addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, postalCode: $postalCode, language: $language) {
    user {
      id
      ...TransferMethods
    }
    error {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddPrepaidCardMutationFn = Apollo.MutationFunction<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>;

/**
 * __useTransferMethodAddPrepaidCardMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddPrepaidCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddPrepaidCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddPrepaidCardMutation, { data, loading, error }] = useTransferMethodAddPrepaidCardMutation({
 *   variables: {
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTransferMethodAddPrepaidCardMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>) {
        return Apollo.useMutation<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>(TransferMethodAddPrepaidCardDocument, baseOptions);
      }
export type TransferMethodAddPrepaidCardMutationHookResult = ReturnType<typeof useTransferMethodAddPrepaidCardMutation>;
export type TransferMethodAddPrepaidCardMutationResult = Apollo.MutationResult<TransferMethodAddPrepaidCardMutation>;
export type TransferMethodAddPrepaidCardMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>;
export const TransferMethodAddVenmoDocument = gql`
    mutation TransferMethodAddVenmo($phoneNumber: String!) {
  transferMethodAddVenmo(phoneNumber: $phoneNumber) {
    user {
      id
      ...TransferMethods
    }
    error {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddVenmoMutationFn = Apollo.MutationFunction<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>;

/**
 * __useTransferMethodAddVenmoMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddVenmoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddVenmoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddVenmoMutation, { data, loading, error }] = useTransferMethodAddVenmoMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useTransferMethodAddVenmoMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>) {
        return Apollo.useMutation<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>(TransferMethodAddVenmoDocument, baseOptions);
      }
export type TransferMethodAddVenmoMutationHookResult = ReturnType<typeof useTransferMethodAddVenmoMutation>;
export type TransferMethodAddVenmoMutationResult = Apollo.MutationResult<TransferMethodAddVenmoMutation>;
export type TransferMethodAddVenmoMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>;
export const UpdateLanguageDocument = gql`
    mutation UpdateLanguage($language: String!) {
  updateLanguage(language: $language) {
    user {
      id
    }
  }
}
    `;
export type UpdateLanguageMutationFn = Apollo.MutationFunction<UpdateLanguageMutation, UpdateLanguageMutationVariables>;

/**
 * __useUpdateLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLanguageMutation, { data, loading, error }] = useUpdateLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLanguageMutation, UpdateLanguageMutationVariables>) {
        return Apollo.useMutation<UpdateLanguageMutation, UpdateLanguageMutationVariables>(UpdateLanguageDocument, baseOptions);
      }
export type UpdateLanguageMutationHookResult = ReturnType<typeof useUpdateLanguageMutation>;
export type UpdateLanguageMutationResult = Apollo.MutationResult<UpdateLanguageMutation>;
export type UpdateLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateLanguageMutation, UpdateLanguageMutationVariables>;
export const ResetTranslationCacheDocument = gql`
    mutation ResetTranslationCache {
  resetTranslationCache {
    success
  }
}
    `;
export type ResetTranslationCacheMutationFn = Apollo.MutationFunction<ResetTranslationCacheMutation, ResetTranslationCacheMutationVariables>;

/**
 * __useResetTranslationCacheMutation__
 *
 * To run a mutation, you first call `useResetTranslationCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetTranslationCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetTranslationCacheMutation, { data, loading, error }] = useResetTranslationCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetTranslationCacheMutation(baseOptions?: Apollo.MutationHookOptions<ResetTranslationCacheMutation, ResetTranslationCacheMutationVariables>) {
        return Apollo.useMutation<ResetTranslationCacheMutation, ResetTranslationCacheMutationVariables>(ResetTranslationCacheDocument, baseOptions);
      }
export type ResetTranslationCacheMutationHookResult = ReturnType<typeof useResetTranslationCacheMutation>;
export type ResetTranslationCacheMutationResult = Apollo.MutationResult<ResetTranslationCacheMutation>;
export type ResetTranslationCacheMutationOptions = Apollo.BaseMutationOptions<ResetTranslationCacheMutation, ResetTranslationCacheMutationVariables>;
export const ApplicationsByFieldDocument = gql`
    query ApplicationsByField($programId: Int!, $fieldName: String!) {
  applicationsByField(programId: $programId, fieldName: $fieldName) {
    key
    data {
      total
      approved
      inReview
      rejected
    }
  }
}
    `;

/**
 * __useApplicationsByFieldQuery__
 *
 * To run a query within a React component, call `useApplicationsByFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsByFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsByFieldQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      fieldName: // value for 'fieldName'
 *   },
 * });
 */
export function useApplicationsByFieldQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationsByFieldQuery, ApplicationsByFieldQueryVariables>) {
        return Apollo.useQuery<ApplicationsByFieldQuery, ApplicationsByFieldQueryVariables>(ApplicationsByFieldDocument, baseOptions);
      }
export function useApplicationsByFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsByFieldQuery, ApplicationsByFieldQueryVariables>) {
          return Apollo.useLazyQuery<ApplicationsByFieldQuery, ApplicationsByFieldQueryVariables>(ApplicationsByFieldDocument, baseOptions);
        }
export type ApplicationsByFieldQueryHookResult = ReturnType<typeof useApplicationsByFieldQuery>;
export type ApplicationsByFieldLazyQueryHookResult = ReturnType<typeof useApplicationsByFieldLazyQuery>;
export type ApplicationsByFieldQueryResult = Apollo.QueryResult<ApplicationsByFieldQuery, ApplicationsByFieldQueryVariables>;
export const ApplicationsLastDaysDocument = gql`
    query ApplicationsLastDays($programId: Int!, $days: Int!) {
  applicationsLastDays(programId: $programId, days: $days) {
    date
    number
  }
}
    `;

/**
 * __useApplicationsLastDaysQuery__
 *
 * To run a query within a React component, call `useApplicationsLastDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsLastDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsLastDaysQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useApplicationsLastDaysQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationsLastDaysQuery, ApplicationsLastDaysQueryVariables>) {
        return Apollo.useQuery<ApplicationsLastDaysQuery, ApplicationsLastDaysQueryVariables>(ApplicationsLastDaysDocument, baseOptions);
      }
export function useApplicationsLastDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsLastDaysQuery, ApplicationsLastDaysQueryVariables>) {
          return Apollo.useLazyQuery<ApplicationsLastDaysQuery, ApplicationsLastDaysQueryVariables>(ApplicationsLastDaysDocument, baseOptions);
        }
export type ApplicationsLastDaysQueryHookResult = ReturnType<typeof useApplicationsLastDaysQuery>;
export type ApplicationsLastDaysLazyQueryHookResult = ReturnType<typeof useApplicationsLastDaysLazyQuery>;
export type ApplicationsLastDaysQueryResult = Apollo.QueryResult<ApplicationsLastDaysQuery, ApplicationsLastDaysQueryVariables>;
export const LogsDocument = gql`
    query Logs($potentialUser: ID!) {
  adminLogs(potentialUser: $potentialUser) {
    createdAt
    id
    entityType
    action
    originalValue
    newValue
    notes
    user {
      email
    }
  }
}
    `;

/**
 * __useLogsQuery__
 *
 * To run a query within a React component, call `useLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsQuery({
 *   variables: {
 *      potentialUser: // value for 'potentialUser'
 *   },
 * });
 */
export function useLogsQuery(baseOptions?: Apollo.QueryHookOptions<LogsQuery, LogsQueryVariables>) {
        return Apollo.useQuery<LogsQuery, LogsQueryVariables>(LogsDocument, baseOptions);
      }
export function useLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogsQuery, LogsQueryVariables>) {
          return Apollo.useLazyQuery<LogsQuery, LogsQueryVariables>(LogsDocument, baseOptions);
        }
export type LogsQueryHookResult = ReturnType<typeof useLogsQuery>;
export type LogsLazyQueryHookResult = ReturnType<typeof useLogsLazyQuery>;
export type LogsQueryResult = Apollo.QueryResult<LogsQuery, LogsQueryVariables>;
export const ScheduledPaymentMutationDocument = gql`
    mutation ScheduledPaymentMutation($upcomingIds: [ID]) {
  scheduledPayments(upcomingIds: $upcomingIds) {
    allUpcomingScheduledPayments {
      id
      amount
      user {
        firstName
        lastName
        email
        transferMethods(first: 1) {
          edges {
            node {
              id
              isCurrentMethod
              statusCode
              type
              halfLiner
            }
          }
        }
      }
      fulfillmentPayment {
        id
        status
        destination {
          statusCode
          type
          halfLiner
        }
      }
      createdAt
      scheduledDate
    }
  }
}
    `;
export type ScheduledPaymentMutationMutationFn = Apollo.MutationFunction<ScheduledPaymentMutationMutation, ScheduledPaymentMutationMutationVariables>;

/**
 * __useScheduledPaymentMutationMutation__
 *
 * To run a mutation, you first call `useScheduledPaymentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduledPaymentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduledPaymentMutationMutation, { data, loading, error }] = useScheduledPaymentMutationMutation({
 *   variables: {
 *      upcomingIds: // value for 'upcomingIds'
 *   },
 * });
 */
export function useScheduledPaymentMutationMutation(baseOptions?: Apollo.MutationHookOptions<ScheduledPaymentMutationMutation, ScheduledPaymentMutationMutationVariables>) {
        return Apollo.useMutation<ScheduledPaymentMutationMutation, ScheduledPaymentMutationMutationVariables>(ScheduledPaymentMutationDocument, baseOptions);
      }
export type ScheduledPaymentMutationMutationHookResult = ReturnType<typeof useScheduledPaymentMutationMutation>;
export type ScheduledPaymentMutationMutationResult = Apollo.MutationResult<ScheduledPaymentMutationMutation>;
export type ScheduledPaymentMutationMutationOptions = Apollo.BaseMutationOptions<ScheduledPaymentMutationMutation, ScheduledPaymentMutationMutationVariables>;
export const ResolveApplicationDocument = gql`
    mutation resolveApplication($email: String!, $status: String!) {
  resolveApplication(email: $email, status: $status) {
    ok
  }
}
    `;
export type ResolveApplicationMutationFn = Apollo.MutationFunction<ResolveApplicationMutation, ResolveApplicationMutationVariables>;

/**
 * __useResolveApplicationMutation__
 *
 * To run a mutation, you first call `useResolveApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveApplicationMutation, { data, loading, error }] = useResolveApplicationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useResolveApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ResolveApplicationMutation, ResolveApplicationMutationVariables>) {
        return Apollo.useMutation<ResolveApplicationMutation, ResolveApplicationMutationVariables>(ResolveApplicationDocument, baseOptions);
      }
export type ResolveApplicationMutationHookResult = ReturnType<typeof useResolveApplicationMutation>;
export type ResolveApplicationMutationResult = Apollo.MutationResult<ResolveApplicationMutation>;
export type ResolveApplicationMutationOptions = Apollo.BaseMutationOptions<ResolveApplicationMutation, ResolveApplicationMutationVariables>;
export const SendOnboardingNotificationDocument = gql`
    mutation SendOnboardingNotification($email: String) {
  sendOnboardingNotification(email: $email) {
    success
  }
}
    `;
export type SendOnboardingNotificationMutationFn = Apollo.MutationFunction<SendOnboardingNotificationMutation, SendOnboardingNotificationMutationVariables>;

/**
 * __useSendOnboardingNotificationMutation__
 *
 * To run a mutation, you first call `useSendOnboardingNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOnboardingNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOnboardingNotificationMutation, { data, loading, error }] = useSendOnboardingNotificationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendOnboardingNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendOnboardingNotificationMutation, SendOnboardingNotificationMutationVariables>) {
        return Apollo.useMutation<SendOnboardingNotificationMutation, SendOnboardingNotificationMutationVariables>(SendOnboardingNotificationDocument, baseOptions);
      }
export type SendOnboardingNotificationMutationHookResult = ReturnType<typeof useSendOnboardingNotificationMutation>;
export type SendOnboardingNotificationMutationResult = Apollo.MutationResult<SendOnboardingNotificationMutation>;
export type SendOnboardingNotificationMutationOptions = Apollo.BaseMutationOptions<SendOnboardingNotificationMutation, SendOnboardingNotificationMutationVariables>;
export const SendSonomaOnboardingNotificationDocument = gql`
    mutation SendSonomaOnboardingNotification($email: String) {
  sendSonomaOnboardingNotification(email: $email) {
    success
  }
}
    `;
export type SendSonomaOnboardingNotificationMutationFn = Apollo.MutationFunction<SendSonomaOnboardingNotificationMutation, SendSonomaOnboardingNotificationMutationVariables>;

/**
 * __useSendSonomaOnboardingNotificationMutation__
 *
 * To run a mutation, you first call `useSendSonomaOnboardingNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSonomaOnboardingNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSonomaOnboardingNotificationMutation, { data, loading, error }] = useSendSonomaOnboardingNotificationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendSonomaOnboardingNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendSonomaOnboardingNotificationMutation, SendSonomaOnboardingNotificationMutationVariables>) {
        return Apollo.useMutation<SendSonomaOnboardingNotificationMutation, SendSonomaOnboardingNotificationMutationVariables>(SendSonomaOnboardingNotificationDocument, baseOptions);
      }
export type SendSonomaOnboardingNotificationMutationHookResult = ReturnType<typeof useSendSonomaOnboardingNotificationMutation>;
export type SendSonomaOnboardingNotificationMutationResult = Apollo.MutationResult<SendSonomaOnboardingNotificationMutation>;
export type SendSonomaOnboardingNotificationMutationOptions = Apollo.BaseMutationOptions<SendSonomaOnboardingNotificationMutation, SendSonomaOnboardingNotificationMutationVariables>;
export const SendOnboardingNotificationReminderDocument = gql`
    mutation SendOnboardingNotificationReminder($email: String) {
  sendOnboardingNotificationReminder(email: $email) {
    success
  }
}
    `;
export type SendOnboardingNotificationReminderMutationFn = Apollo.MutationFunction<SendOnboardingNotificationReminderMutation, SendOnboardingNotificationReminderMutationVariables>;

/**
 * __useSendOnboardingNotificationReminderMutation__
 *
 * To run a mutation, you first call `useSendOnboardingNotificationReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOnboardingNotificationReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOnboardingNotificationReminderMutation, { data, loading, error }] = useSendOnboardingNotificationReminderMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendOnboardingNotificationReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendOnboardingNotificationReminderMutation, SendOnboardingNotificationReminderMutationVariables>) {
        return Apollo.useMutation<SendOnboardingNotificationReminderMutation, SendOnboardingNotificationReminderMutationVariables>(SendOnboardingNotificationReminderDocument, baseOptions);
      }
export type SendOnboardingNotificationReminderMutationHookResult = ReturnType<typeof useSendOnboardingNotificationReminderMutation>;
export type SendOnboardingNotificationReminderMutationResult = Apollo.MutationResult<SendOnboardingNotificationReminderMutation>;
export type SendOnboardingNotificationReminderMutationOptions = Apollo.BaseMutationOptions<SendOnboardingNotificationReminderMutation, SendOnboardingNotificationReminderMutationVariables>;
export const SurveySummaryDocument = gql`
    query SurveySummary {
  surveySummary {
    completed {
      id
      email
      firstName
      lastName
      phoneNumber
    }
    notCompleted {
      id
      email
      firstName
      lastName
      phoneNumber
    }
    submittedAt
  }
}
    `;

/**
 * __useSurveySummaryQuery__
 *
 * To run a query within a React component, call `useSurveySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveySummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSurveySummaryQuery(baseOptions?: Apollo.QueryHookOptions<SurveySummaryQuery, SurveySummaryQueryVariables>) {
        return Apollo.useQuery<SurveySummaryQuery, SurveySummaryQueryVariables>(SurveySummaryDocument, baseOptions);
      }
export function useSurveySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveySummaryQuery, SurveySummaryQueryVariables>) {
          return Apollo.useLazyQuery<SurveySummaryQuery, SurveySummaryQueryVariables>(SurveySummaryDocument, baseOptions);
        }
export type SurveySummaryQueryHookResult = ReturnType<typeof useSurveySummaryQuery>;
export type SurveySummaryLazyQueryHookResult = ReturnType<typeof useSurveySummaryLazyQuery>;
export type SurveySummaryQueryResult = Apollo.QueryResult<SurveySummaryQuery, SurveySummaryQueryVariables>;
export const AllUpcomingScheduledPaymentsDocument = gql`
    query AllUpcomingScheduledPayments {
  allUpcomingScheduledPayments {
    id
    amount
    user {
      isFrozen
      firstName
      lastName
      email
      transferMethods(first: 1) {
        edges {
          node {
            id
            isCurrentMethod
            statusCode
            type
            halfLiner
          }
        }
      }
    }
    fulfillmentPayment {
      id
      status
      destination {
        statusCode
        type
        halfLiner
      }
    }
    createdAt
    scheduledDate
  }
}
    `;

/**
 * __useAllUpcomingScheduledPaymentsQuery__
 *
 * To run a query within a React component, call `useAllUpcomingScheduledPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUpcomingScheduledPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUpcomingScheduledPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUpcomingScheduledPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<AllUpcomingScheduledPaymentsQuery, AllUpcomingScheduledPaymentsQueryVariables>) {
        return Apollo.useQuery<AllUpcomingScheduledPaymentsQuery, AllUpcomingScheduledPaymentsQueryVariables>(AllUpcomingScheduledPaymentsDocument, baseOptions);
      }
export function useAllUpcomingScheduledPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUpcomingScheduledPaymentsQuery, AllUpcomingScheduledPaymentsQueryVariables>) {
          return Apollo.useLazyQuery<AllUpcomingScheduledPaymentsQuery, AllUpcomingScheduledPaymentsQueryVariables>(AllUpcomingScheduledPaymentsDocument, baseOptions);
        }
export type AllUpcomingScheduledPaymentsQueryHookResult = ReturnType<typeof useAllUpcomingScheduledPaymentsQuery>;
export type AllUpcomingScheduledPaymentsLazyQueryHookResult = ReturnType<typeof useAllUpcomingScheduledPaymentsLazyQuery>;
export type AllUpcomingScheduledPaymentsQueryResult = Apollo.QueryResult<AllUpcomingScheduledPaymentsQuery, AllUpcomingScheduledPaymentsQueryVariables>;
export const SendTextMessageDocument = gql`
    mutation SendTextMessage($phoneNumber: String!, $text: String!) {
  sendTextMessage(phoneNumber: $phoneNumber, text: $text) {
    success
  }
}
    `;
export type SendTextMessageMutationFn = Apollo.MutationFunction<SendTextMessageMutation, SendTextMessageMutationVariables>;

/**
 * __useSendTextMessageMutation__
 *
 * To run a mutation, you first call `useSendTextMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTextMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTextMessageMutation, { data, loading, error }] = useSendTextMessageMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSendTextMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTextMessageMutation, SendTextMessageMutationVariables>) {
        return Apollo.useMutation<SendTextMessageMutation, SendTextMessageMutationVariables>(SendTextMessageDocument, baseOptions);
      }
export type SendTextMessageMutationHookResult = ReturnType<typeof useSendTextMessageMutation>;
export type SendTextMessageMutationResult = Apollo.MutationResult<SendTextMessageMutation>;
export type SendTextMessageMutationOptions = Apollo.BaseMutationOptions<SendTextMessageMutation, SendTextMessageMutationVariables>;
export const PotentialUsersDocument = gql`
    query PotentialUsers($first: Int, $last: Int, $after: String, $before: String, $id: ID, $inviteCode_Isnull: Boolean, $isLocked: Boolean, $applicationStatus: String, $applicationStatus_Isnull: Boolean, $selectedFor_Isnull: Boolean, $invitationSent: DateTime, $invitationSent_Isnull: Boolean, $orderBy: String, $search: JSONString, $assignedAdmin: ID) {
  potentialUsers(first: $first, last: $last, after: $after, before: $before, isLocked: $isLocked, id: $id, orderBy: $orderBy, invitationSent: $invitationSent, invitationSent_Isnull: $invitationSent_Isnull, inviteCode_Isnull: $inviteCode_Isnull, applicationStatus_Isnull: $applicationStatus_Isnull, selectedFor_Isnull: $selectedFor_Isnull, applicationStatus: $applicationStatus, search: $search, assignedAdmin: $assignedAdmin) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      endCursor
      startCursor
    }
    totalCount
    edgeCount
    edges {
      node {
        pk
        firstName
        lastName
        onboardingNotificationSent
        onboardingReminderNotificationSent
        email
        user {
          edges {
            node {
              pk
            }
          }
        }
        phoneNumber
        program {
          name
        }
        startDate
        createdAt
        isLocked
        selectedFor
        invitationSent
        ssiBenefitAnswers {
          edges {
            node {
              answer
              category
              householdMember {
                id
              }
            }
          }
        }
        selectedBenefits {
          edges {
            node {
              category
            }
          }
        }
        inviteCode
        documents {
          edges {
            node {
              name
              verifiedBy {
                id
              }
            }
          }
        }
        flags {
          edges {
            node {
              potentialUser {
                firstName
                lastName
              }
              pk
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePotentialUsersQuery__
 *
 * To run a query within a React component, call `usePotentialUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      id: // value for 'id'
 *      inviteCode_Isnull: // value for 'inviteCode_Isnull'
 *      isLocked: // value for 'isLocked'
 *      applicationStatus: // value for 'applicationStatus'
 *      applicationStatus_Isnull: // value for 'applicationStatus_Isnull'
 *      selectedFor_Isnull: // value for 'selectedFor_Isnull'
 *      invitationSent: // value for 'invitationSent'
 *      invitationSent_Isnull: // value for 'invitationSent_Isnull'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      assignedAdmin: // value for 'assignedAdmin'
 *   },
 * });
 */
export function usePotentialUsersQuery(baseOptions?: Apollo.QueryHookOptions<PotentialUsersQuery, PotentialUsersQueryVariables>) {
        return Apollo.useQuery<PotentialUsersQuery, PotentialUsersQueryVariables>(PotentialUsersDocument, baseOptions);
      }
export function usePotentialUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialUsersQuery, PotentialUsersQueryVariables>) {
          return Apollo.useLazyQuery<PotentialUsersQuery, PotentialUsersQueryVariables>(PotentialUsersDocument, baseOptions);
        }
export type PotentialUsersQueryHookResult = ReturnType<typeof usePotentialUsersQuery>;
export type PotentialUsersLazyQueryHookResult = ReturnType<typeof usePotentialUsersLazyQuery>;
export type PotentialUsersQueryResult = Apollo.QueryResult<PotentialUsersQuery, PotentialUsersQueryVariables>;
export const NotSignedUpPotentialUsersDocument = gql`
    query NotSignedUpPotentialUsers($first: Int, $last: Int, $after: String, $before: String, $id: ID, $inviteCode_Isnull: Boolean, $isLocked: Boolean, $applicationStatus: String, $applicationStatus_Isnull: Boolean, $selectedFor_Isnull: Boolean, $invitationSent: DateTime, $invitationSent_Isnull: Boolean, $orderBy: String, $search: JSONString, $assignedAdmin: ID) {
  notSignedUpPotentialUsers(first: $first, last: $last, after: $after, before: $before, isLocked: $isLocked, id: $id, orderBy: $orderBy, invitationSent: $invitationSent, invitationSent_Isnull: $invitationSent_Isnull, inviteCode_Isnull: $inviteCode_Isnull, applicationStatus_Isnull: $applicationStatus_Isnull, selectedFor_Isnull: $selectedFor_Isnull, applicationStatus: $applicationStatus, search: $search, assignedAdmin: $assignedAdmin) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      endCursor
      startCursor
    }
    totalCount
    edgeCount
    edges {
      node {
        pk
        firstName
        lastName
        onboardingNotificationSent
        onboardingReminderNotificationSent
        email
        phoneNumber
        program {
          name
        }
        startDate
        createdAt
        isLocked
        selectedFor
        invitationSent
        ssiBenefitAnswers {
          edges {
            node {
              answer
              category
              householdMember {
                id
              }
            }
          }
        }
        inviteCode
        documents {
          edges {
            node {
              name
              verifiedBy {
                id
              }
            }
          }
        }
        flags {
          edges {
            node {
              potentialUser {
                firstName
                lastName
              }
              pk
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotSignedUpPotentialUsersQuery__
 *
 * To run a query within a React component, call `useNotSignedUpPotentialUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotSignedUpPotentialUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotSignedUpPotentialUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      id: // value for 'id'
 *      inviteCode_Isnull: // value for 'inviteCode_Isnull'
 *      isLocked: // value for 'isLocked'
 *      applicationStatus: // value for 'applicationStatus'
 *      applicationStatus_Isnull: // value for 'applicationStatus_Isnull'
 *      selectedFor_Isnull: // value for 'selectedFor_Isnull'
 *      invitationSent: // value for 'invitationSent'
 *      invitationSent_Isnull: // value for 'invitationSent_Isnull'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      assignedAdmin: // value for 'assignedAdmin'
 *   },
 * });
 */
export function useNotSignedUpPotentialUsersQuery(baseOptions?: Apollo.QueryHookOptions<NotSignedUpPotentialUsersQuery, NotSignedUpPotentialUsersQueryVariables>) {
        return Apollo.useQuery<NotSignedUpPotentialUsersQuery, NotSignedUpPotentialUsersQueryVariables>(NotSignedUpPotentialUsersDocument, baseOptions);
      }
export function useNotSignedUpPotentialUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotSignedUpPotentialUsersQuery, NotSignedUpPotentialUsersQueryVariables>) {
          return Apollo.useLazyQuery<NotSignedUpPotentialUsersQuery, NotSignedUpPotentialUsersQueryVariables>(NotSignedUpPotentialUsersDocument, baseOptions);
        }
export type NotSignedUpPotentialUsersQueryHookResult = ReturnType<typeof useNotSignedUpPotentialUsersQuery>;
export type NotSignedUpPotentialUsersLazyQueryHookResult = ReturnType<typeof useNotSignedUpPotentialUsersLazyQuery>;
export type NotSignedUpPotentialUsersQueryResult = Apollo.QueryResult<NotSignedUpPotentialUsersQuery, NotSignedUpPotentialUsersQueryVariables>;
export const UserSearchDocument = gql`
    query UserSearch($firstName: String!, $lastName: String!, $email: String!, $phoneNumber: String!) {
  userSearch(firstName_Icontains: $firstName, lastName_Icontains: $lastName, email_Icontains: $email, phoneNumber_Icontains: $phoneNumber) {
    edges {
      node {
        pk
        securityQuestionAnswer
        securityQuestionQuestion
        lastName
        firstName
        email
        phoneNumber
        isSuperuser
        paymentAmount
        paymentFrequencyType
        language
        startDate
        transferMethods {
          edges {
            node {
              oneLiner
              isCurrentMethod
              address1
              address2
              city
              zipCode
              statusCode
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserSearchQuery__
 *
 * To run a query within a React component, call `useUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchQuery({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUserSearchQuery(baseOptions?: Apollo.QueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
        return Apollo.useQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, baseOptions);
      }
export function useUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
          return Apollo.useLazyQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, baseOptions);
        }
export type UserSearchQueryHookResult = ReturnType<typeof useUserSearchQuery>;
export type UserSearchLazyQueryHookResult = ReturnType<typeof useUserSearchLazyQuery>;
export type UserSearchQueryResult = Apollo.QueryResult<UserSearchQuery, UserSearchQueryVariables>;
export const AdminUsersTemplateDocument = gql`
    query AdminUsersTemplate {
  templateCsv
}
    `;

/**
 * __useAdminUsersTemplateQuery__
 *
 * To run a query within a React component, call `useAdminUsersTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminUsersTemplateQuery(baseOptions?: Apollo.QueryHookOptions<AdminUsersTemplateQuery, AdminUsersTemplateQueryVariables>) {
        return Apollo.useQuery<AdminUsersTemplateQuery, AdminUsersTemplateQueryVariables>(AdminUsersTemplateDocument, baseOptions);
      }
export function useAdminUsersTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersTemplateQuery, AdminUsersTemplateQueryVariables>) {
          return Apollo.useLazyQuery<AdminUsersTemplateQuery, AdminUsersTemplateQueryVariables>(AdminUsersTemplateDocument, baseOptions);
        }
export type AdminUsersTemplateQueryHookResult = ReturnType<typeof useAdminUsersTemplateQuery>;
export type AdminUsersTemplateLazyQueryHookResult = ReturnType<typeof useAdminUsersTemplateLazyQuery>;
export type AdminUsersTemplateQueryResult = Apollo.QueryResult<AdminUsersTemplateQuery, AdminUsersTemplateQueryVariables>;
export const PotentialUsersForOnboardingNotificationsDocument = gql`
    query PotentialUsersForOnboardingNotifications($id: ID, $reminder: Boolean) {
  potentialUsersForOnboardingNotifications(id: $id, reminder: $reminder) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __usePotentialUsersForOnboardingNotificationsQuery__
 *
 * To run a query within a React component, call `usePotentialUsersForOnboardingNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialUsersForOnboardingNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialUsersForOnboardingNotificationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reminder: // value for 'reminder'
 *   },
 * });
 */
export function usePotentialUsersForOnboardingNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<PotentialUsersForOnboardingNotificationsQuery, PotentialUsersForOnboardingNotificationsQueryVariables>) {
        return Apollo.useQuery<PotentialUsersForOnboardingNotificationsQuery, PotentialUsersForOnboardingNotificationsQueryVariables>(PotentialUsersForOnboardingNotificationsDocument, baseOptions);
      }
export function usePotentialUsersForOnboardingNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialUsersForOnboardingNotificationsQuery, PotentialUsersForOnboardingNotificationsQueryVariables>) {
          return Apollo.useLazyQuery<PotentialUsersForOnboardingNotificationsQuery, PotentialUsersForOnboardingNotificationsQueryVariables>(PotentialUsersForOnboardingNotificationsDocument, baseOptions);
        }
export type PotentialUsersForOnboardingNotificationsQueryHookResult = ReturnType<typeof usePotentialUsersForOnboardingNotificationsQuery>;
export type PotentialUsersForOnboardingNotificationsLazyQueryHookResult = ReturnType<typeof usePotentialUsersForOnboardingNotificationsLazyQuery>;
export type PotentialUsersForOnboardingNotificationsQueryResult = Apollo.QueryResult<PotentialUsersForOnboardingNotificationsQuery, PotentialUsersForOnboardingNotificationsQueryVariables>;
export const SendBenefitsInvitationDocument = gql`
    mutation SendBenefitsInvitation {
  sendBenefitsInvitation {
    success
  }
}
    `;
export type SendBenefitsInvitationMutationFn = Apollo.MutationFunction<SendBenefitsInvitationMutation, SendBenefitsInvitationMutationVariables>;

/**
 * __useSendBenefitsInvitationMutation__
 *
 * To run a mutation, you first call `useSendBenefitsInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBenefitsInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBenefitsInvitationMutation, { data, loading, error }] = useSendBenefitsInvitationMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendBenefitsInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendBenefitsInvitationMutation, SendBenefitsInvitationMutationVariables>) {
        return Apollo.useMutation<SendBenefitsInvitationMutation, SendBenefitsInvitationMutationVariables>(SendBenefitsInvitationDocument, baseOptions);
      }
export type SendBenefitsInvitationMutationHookResult = ReturnType<typeof useSendBenefitsInvitationMutation>;
export type SendBenefitsInvitationMutationResult = Apollo.MutationResult<SendBenefitsInvitationMutation>;
export type SendBenefitsInvitationMutationOptions = Apollo.BaseMutationOptions<SendBenefitsInvitationMutation, SendBenefitsInvitationMutationVariables>;
export const GetCalendlyArrayScheduledEventDocument = gql`
    query GetCalendlyArrayScheduledEvent($potentialUserIdList: [ID]) {
  listOfScheduledEvents(potentialUserIdList: $potentialUserIdList) {
    createdAt
    name
    status
    potentialUserId
    startTime
    endTime
  }
}
    `;

/**
 * __useGetCalendlyArrayScheduledEventQuery__
 *
 * To run a query within a React component, call `useGetCalendlyArrayScheduledEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendlyArrayScheduledEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendlyArrayScheduledEventQuery({
 *   variables: {
 *      potentialUserIdList: // value for 'potentialUserIdList'
 *   },
 * });
 */
export function useGetCalendlyArrayScheduledEventQuery(baseOptions?: Apollo.QueryHookOptions<GetCalendlyArrayScheduledEventQuery, GetCalendlyArrayScheduledEventQueryVariables>) {
        return Apollo.useQuery<GetCalendlyArrayScheduledEventQuery, GetCalendlyArrayScheduledEventQueryVariables>(GetCalendlyArrayScheduledEventDocument, baseOptions);
      }
export function useGetCalendlyArrayScheduledEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendlyArrayScheduledEventQuery, GetCalendlyArrayScheduledEventQueryVariables>) {
          return Apollo.useLazyQuery<GetCalendlyArrayScheduledEventQuery, GetCalendlyArrayScheduledEventQueryVariables>(GetCalendlyArrayScheduledEventDocument, baseOptions);
        }
export type GetCalendlyArrayScheduledEventQueryHookResult = ReturnType<typeof useGetCalendlyArrayScheduledEventQuery>;
export type GetCalendlyArrayScheduledEventLazyQueryHookResult = ReturnType<typeof useGetCalendlyArrayScheduledEventLazyQuery>;
export type GetCalendlyArrayScheduledEventQueryResult = Apollo.QueryResult<GetCalendlyArrayScheduledEventQuery, GetCalendlyArrayScheduledEventQueryVariables>;
export const UpdateConfigurationsDocument = gql`
    mutation UpdateConfigurations($configurations: JSONString!) {
  updateConfigurations(configurations: $configurations) {
    success
  }
}
    `;
export type UpdateConfigurationsMutationFn = Apollo.MutationFunction<UpdateConfigurationsMutation, UpdateConfigurationsMutationVariables>;

/**
 * __useUpdateConfigurationsMutation__
 *
 * To run a mutation, you first call `useUpdateConfigurationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigurationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigurationsMutation, { data, loading, error }] = useUpdateConfigurationsMutation({
 *   variables: {
 *      configurations: // value for 'configurations'
 *   },
 * });
 */
export function useUpdateConfigurationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConfigurationsMutation, UpdateConfigurationsMutationVariables>) {
        return Apollo.useMutation<UpdateConfigurationsMutation, UpdateConfigurationsMutationVariables>(UpdateConfigurationsDocument, baseOptions);
      }
export type UpdateConfigurationsMutationHookResult = ReturnType<typeof useUpdateConfigurationsMutation>;
export type UpdateConfigurationsMutationResult = Apollo.MutationResult<UpdateConfigurationsMutation>;
export type UpdateConfigurationsMutationOptions = Apollo.BaseMutationOptions<UpdateConfigurationsMutation, UpdateConfigurationsMutationVariables>;
export const AdminConfigurationsDocument = gql`
    query AdminConfigurations {
  configurationsJson
}
    `;

/**
 * __useAdminConfigurationsQuery__
 *
 * To run a query within a React component, call `useAdminConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<AdminConfigurationsQuery, AdminConfigurationsQueryVariables>) {
        return Apollo.useQuery<AdminConfigurationsQuery, AdminConfigurationsQueryVariables>(AdminConfigurationsDocument, baseOptions);
      }
export function useAdminConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminConfigurationsQuery, AdminConfigurationsQueryVariables>) {
          return Apollo.useLazyQuery<AdminConfigurationsQuery, AdminConfigurationsQueryVariables>(AdminConfigurationsDocument, baseOptions);
        }
export type AdminConfigurationsQueryHookResult = ReturnType<typeof useAdminConfigurationsQuery>;
export type AdminConfigurationsLazyQueryHookResult = ReturnType<typeof useAdminConfigurationsLazyQuery>;
export type AdminConfigurationsQueryResult = Apollo.QueryResult<AdminConfigurationsQuery, AdminConfigurationsQueryVariables>;
export const ProgramHealthCheckDocument = gql`
    query ProgramHealthCheck($programId: ID!) {
  healthCheckData(programId: $programId) {
    usioBalance
    hyperwalletBalance
    upcomingUsioPayments
    upcomingHyperwalletPayments
    moneyStatusUsio
    moneyStatusHyperwallet
    hyperwalletHealth
    usioHealth
    notSignedUpUsers
    totalPotentialUsers
    totalUsers
    usersWithTransferMethod
    usersPrepaidCardAndActiveStatus
    usersPrepaidCard
    timestamp
    programUrl
  }
}
    `;

/**
 * __useProgramHealthCheckQuery__
 *
 * To run a query within a React component, call `useProgramHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramHealthCheckQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<ProgramHealthCheckQuery, ProgramHealthCheckQueryVariables>) {
        return Apollo.useQuery<ProgramHealthCheckQuery, ProgramHealthCheckQueryVariables>(ProgramHealthCheckDocument, baseOptions);
      }
export function useProgramHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramHealthCheckQuery, ProgramHealthCheckQueryVariables>) {
          return Apollo.useLazyQuery<ProgramHealthCheckQuery, ProgramHealthCheckQueryVariables>(ProgramHealthCheckDocument, baseOptions);
        }
export type ProgramHealthCheckQueryHookResult = ReturnType<typeof useProgramHealthCheckQuery>;
export type ProgramHealthCheckLazyQueryHookResult = ReturnType<typeof useProgramHealthCheckLazyQuery>;
export type ProgramHealthCheckQueryResult = Apollo.QueryResult<ProgramHealthCheckQuery, ProgramHealthCheckQueryVariables>;
export const AllProgramsQueryDocument = gql`
    query AllProgramsQuery {
  allPrograms {
    id
    name
  }
}
    `;

/**
 * __useAllProgramsQueryQuery__
 *
 * To run a query within a React component, call `useAllProgramsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProgramsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProgramsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProgramsQueryQuery(baseOptions?: Apollo.QueryHookOptions<AllProgramsQueryQuery, AllProgramsQueryQueryVariables>) {
        return Apollo.useQuery<AllProgramsQueryQuery, AllProgramsQueryQueryVariables>(AllProgramsQueryDocument, baseOptions);
      }
export function useAllProgramsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProgramsQueryQuery, AllProgramsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AllProgramsQueryQuery, AllProgramsQueryQueryVariables>(AllProgramsQueryDocument, baseOptions);
        }
export type AllProgramsQueryQueryHookResult = ReturnType<typeof useAllProgramsQueryQuery>;
export type AllProgramsQueryLazyQueryHookResult = ReturnType<typeof useAllProgramsQueryLazyQuery>;
export type AllProgramsQueryQueryResult = Apollo.QueryResult<AllProgramsQueryQuery, AllProgramsQueryQueryVariables>;
export const UploadMutationDocument = gql`
    mutation UploadMutation($file: Upload!) {
  uploadMutation(file: $file) {
    success
  }
}
    `;
export type UploadMutationMutationFn = Apollo.MutationFunction<UploadMutationMutation, UploadMutationMutationVariables>;

/**
 * __useUploadMutationMutation__
 *
 * To run a mutation, you first call `useUploadMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMutationMutation, { data, loading, error }] = useUploadMutationMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMutationMutation(baseOptions?: Apollo.MutationHookOptions<UploadMutationMutation, UploadMutationMutationVariables>) {
        return Apollo.useMutation<UploadMutationMutation, UploadMutationMutationVariables>(UploadMutationDocument, baseOptions);
      }
export type UploadMutationMutationHookResult = ReturnType<typeof useUploadMutationMutation>;
export type UploadMutationMutationResult = Apollo.MutationResult<UploadMutationMutation>;
export type UploadMutationMutationOptions = Apollo.BaseMutationOptions<UploadMutationMutation, UploadMutationMutationVariables>;
export const CoordinatesDocument = gql`
    query Coordinates($id: ID) {
  coordinates(id: $id)
}
    `;

/**
 * __useCoordinatesQuery__
 *
 * To run a query within a React component, call `useCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoordinatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCoordinatesQuery(baseOptions?: Apollo.QueryHookOptions<CoordinatesQuery, CoordinatesQueryVariables>) {
        return Apollo.useQuery<CoordinatesQuery, CoordinatesQueryVariables>(CoordinatesDocument, baseOptions);
      }
export function useCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoordinatesQuery, CoordinatesQueryVariables>) {
          return Apollo.useLazyQuery<CoordinatesQuery, CoordinatesQueryVariables>(CoordinatesDocument, baseOptions);
        }
export type CoordinatesQueryHookResult = ReturnType<typeof useCoordinatesQuery>;
export type CoordinatesLazyQueryHookResult = ReturnType<typeof useCoordinatesLazyQuery>;
export type CoordinatesQueryResult = Apollo.QueryResult<CoordinatesQuery, CoordinatesQueryVariables>;
export const UserCoordinatesDocument = gql`
    query UserCoordinates($id: ID) {
  userCoordinates(id: $id)
}
    `;

/**
 * __useUserCoordinatesQuery__
 *
 * To run a query within a React component, call `useUserCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCoordinatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCoordinatesQuery(baseOptions?: Apollo.QueryHookOptions<UserCoordinatesQuery, UserCoordinatesQueryVariables>) {
        return Apollo.useQuery<UserCoordinatesQuery, UserCoordinatesQueryVariables>(UserCoordinatesDocument, baseOptions);
      }
export function useUserCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCoordinatesQuery, UserCoordinatesQueryVariables>) {
          return Apollo.useLazyQuery<UserCoordinatesQuery, UserCoordinatesQueryVariables>(UserCoordinatesDocument, baseOptions);
        }
export type UserCoordinatesQueryHookResult = ReturnType<typeof useUserCoordinatesQuery>;
export type UserCoordinatesLazyQueryHookResult = ReturnType<typeof useUserCoordinatesLazyQuery>;
export type UserCoordinatesQueryResult = Apollo.QueryResult<UserCoordinatesQuery, UserCoordinatesQueryVariables>;
export const ProgramsDocument = gql`
    query Programs {
  programs {
    name
    paymentFrequency
    urlFragment
    paymentAmount
    programDuration
    urlFragment
    pk
  }
}
    `;

/**
 * __useProgramsQuery__
 *
 * To run a query within a React component, call `useProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
        return Apollo.useQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, baseOptions);
      }
export function useProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          return Apollo.useLazyQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, baseOptions);
        }
export type ProgramsQueryHookResult = ReturnType<typeof useProgramsQuery>;
export type ProgramsLazyQueryHookResult = ReturnType<typeof useProgramsLazyQuery>;
export type ProgramsQueryResult = Apollo.QueryResult<ProgramsQuery, ProgramsQueryVariables>;
export const AddApplicationAnswersDocument = gql`
    mutation AddApplicationAnswers($answers: [ProgramApplicationAnswerInputType!]!) {
  addApplicationAnswers(answers: $answers) {
    success
  }
}
    `;
export type AddApplicationAnswersMutationFn = Apollo.MutationFunction<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>;

/**
 * __useAddApplicationAnswersMutation__
 *
 * To run a mutation, you first call `useAddApplicationAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApplicationAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApplicationAnswersMutation, { data, loading, error }] = useAddApplicationAnswersMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAddApplicationAnswersMutation(baseOptions?: Apollo.MutationHookOptions<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>) {
        return Apollo.useMutation<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>(AddApplicationAnswersDocument, baseOptions);
      }
export type AddApplicationAnswersMutationHookResult = ReturnType<typeof useAddApplicationAnswersMutation>;
export type AddApplicationAnswersMutationResult = Apollo.MutationResult<AddApplicationAnswersMutation>;
export type AddApplicationAnswersMutationOptions = Apollo.BaseMutationOptions<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>;
export const ApplyDocument = gql`
    mutation Apply($email: String!, $phoneNumber: String!, $firstName: String!, $lastName: String!, $addressLine1: String!, $addressLine2: String, $country: String!, $city: String!, $dob: String, $state: String!, $postalCode: String!, $programUrl: String!, $language: String!, $ethnicity: String, $gender: String) {
  apply(email: $email, phoneNumber: $phoneNumber, firstName: $firstName, lastName: $lastName, dob: $dob, addressLine1: $addressLine1, addressLine2: $addressLine2, country: $country, city: $city, state: $state, postalCode: $postalCode, programUrl: $programUrl, language: $language, ethnicity: $ethnicity, gender: $gender) {
    application {
      id
      intercomKey
    }
    error
  }
}
    `;
export type ApplyMutationFn = Apollo.MutationFunction<ApplyMutation, ApplyMutationVariables>;

/**
 * __useApplyMutation__
 *
 * To run a mutation, you first call `useApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyMutation, { data, loading, error }] = useApplyMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      dob: // value for 'dob'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *      programUrl: // value for 'programUrl'
 *      language: // value for 'language'
 *      ethnicity: // value for 'ethnicity'
 *      gender: // value for 'gender'
 *   },
 * });
 */
export function useApplyMutation(baseOptions?: Apollo.MutationHookOptions<ApplyMutation, ApplyMutationVariables>) {
        return Apollo.useMutation<ApplyMutation, ApplyMutationVariables>(ApplyDocument, baseOptions);
      }
export type ApplyMutationHookResult = ReturnType<typeof useApplyMutation>;
export type ApplyMutationResult = Apollo.MutationResult<ApplyMutation>;
export type ApplyMutationOptions = Apollo.BaseMutationOptions<ApplyMutation, ApplyMutationVariables>;
export const GetProgramsDocument = gql`
    mutation GetPrograms($programUrl: String!, $includeClosedPeriod: Boolean) {
  getPrograms(programUrl: $programUrl, includeClosedPeriod: $includeClosedPeriod) {
    success
  }
}
    `;
export type GetProgramsMutationFn = Apollo.MutationFunction<GetProgramsMutation, GetProgramsMutationVariables>;

/**
 * __useGetProgramsMutation__
 *
 * To run a mutation, you first call `useGetProgramsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getProgramsMutation, { data, loading, error }] = useGetProgramsMutation({
 *   variables: {
 *      programUrl: // value for 'programUrl'
 *      includeClosedPeriod: // value for 'includeClosedPeriod'
 *   },
 * });
 */
export function useGetProgramsMutation(baseOptions?: Apollo.MutationHookOptions<GetProgramsMutation, GetProgramsMutationVariables>) {
        return Apollo.useMutation<GetProgramsMutation, GetProgramsMutationVariables>(GetProgramsDocument, baseOptions);
      }
export type GetProgramsMutationHookResult = ReturnType<typeof useGetProgramsMutation>;
export type GetProgramsMutationResult = Apollo.MutationResult<GetProgramsMutation>;
export type GetProgramsMutationOptions = Apollo.BaseMutationOptions<GetProgramsMutation, GetProgramsMutationVariables>;
export const GetPotentialUserDocument = gql`
    mutation GetPotentialUser($id: String!) {
  getPotentialUser(id: $id) {
    potentialUser {
      firstName
      lastName
      phoneNumber
      paymentAmount
      email
      createdAt
      updatedAt
      isLocked
      addressLine1
      inviteCode
      dob
      invitationSent
      addressLine2
      city
      state
      country
      applicationStatus
      postalCode
      medianHouseholdIncome
      language
      tractCode
      pk
      selectedFor
      assignedAdmin {
        firstName
        lastName
      }
      ssiBenefitAnswers {
        edges {
          node {
            answer
            category
            householdMember {
              id
            }
          }
        }
      }
      blindDisabled
      householdMembers {
        id
        name
        dob
        relation
        blindDisabled
      }
    }
    documents {
      id
      documentType
      name
      updatedAt
      createdAt
      verifiedBy {
        firstName
        lastName
        email
      }
      uploadedAt
      requestedAs
    }
    flags {
      flagType
      inactive
      pk
      potentialUser {
        pk
      }
      matchedPotentialUser {
        firstName
        lastName
        pk
        flagsPotentialUser {
          edges {
            node {
              inactive
              pk
              potentialUser {
                pk
              }
            }
          }
        }
      }
    }
    householdMembers {
      name
      dob
      relation
    }
    applicationAnswers {
      answerCategory
      response
    }
  }
}
    `;
export type GetPotentialUserMutationFn = Apollo.MutationFunction<GetPotentialUserMutation, GetPotentialUserMutationVariables>;

/**
 * __useGetPotentialUserMutation__
 *
 * To run a mutation, you first call `useGetPotentialUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPotentialUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPotentialUserMutation, { data, loading, error }] = useGetPotentialUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPotentialUserMutation(baseOptions?: Apollo.MutationHookOptions<GetPotentialUserMutation, GetPotentialUserMutationVariables>) {
        return Apollo.useMutation<GetPotentialUserMutation, GetPotentialUserMutationVariables>(GetPotentialUserDocument, baseOptions);
      }
export type GetPotentialUserMutationHookResult = ReturnType<typeof useGetPotentialUserMutation>;
export type GetPotentialUserMutationResult = Apollo.MutationResult<GetPotentialUserMutation>;
export type GetPotentialUserMutationOptions = Apollo.BaseMutationOptions<GetPotentialUserMutation, GetPotentialUserMutationVariables>;
export const MakeFlagInactiveDocument = gql`
    mutation MakeFlagInactive($pk: ID!, $relatedPotentialPk: ID, $potentialUserPk: ID!) {
  makeFlagInactive(pk: $pk, relatedPotentialPk: $relatedPotentialPk, potentialUserPk: $potentialUserPk) {
    success
  }
}
    `;
export type MakeFlagInactiveMutationFn = Apollo.MutationFunction<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>;

/**
 * __useMakeFlagInactiveMutation__
 *
 * To run a mutation, you first call `useMakeFlagInactiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFlagInactiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFlagInactiveMutation, { data, loading, error }] = useMakeFlagInactiveMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *      relatedPotentialPk: // value for 'relatedPotentialPk'
 *      potentialUserPk: // value for 'potentialUserPk'
 *   },
 * });
 */
export function useMakeFlagInactiveMutation(baseOptions?: Apollo.MutationHookOptions<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>) {
        return Apollo.useMutation<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>(MakeFlagInactiveDocument, baseOptions);
      }
export type MakeFlagInactiveMutationHookResult = ReturnType<typeof useMakeFlagInactiveMutation>;
export type MakeFlagInactiveMutationResult = Apollo.MutationResult<MakeFlagInactiveMutation>;
export type MakeFlagInactiveMutationOptions = Apollo.BaseMutationOptions<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>;
export const DocumentUploadDocument = gql`
    mutation DocumentUpload($file: Upload!, $potentialUserId: ID!, $documentType: String!) {
  documentUpload(file: $file, potentialUserId: $potentialUserId, documentType: $documentType) {
    documentUploadSuccess
  }
}
    `;
export type DocumentUploadMutationFn = Apollo.MutationFunction<DocumentUploadMutation, DocumentUploadMutationVariables>;

/**
 * __useDocumentUploadMutation__
 *
 * To run a mutation, you first call `useDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentUploadMutation, { data, loading, error }] = useDocumentUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      potentialUserId: // value for 'potentialUserId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<DocumentUploadMutation, DocumentUploadMutationVariables>) {
        return Apollo.useMutation<DocumentUploadMutation, DocumentUploadMutationVariables>(DocumentUploadDocument, baseOptions);
      }
export type DocumentUploadMutationHookResult = ReturnType<typeof useDocumentUploadMutation>;
export type DocumentUploadMutationResult = Apollo.MutationResult<DocumentUploadMutation>;
export type DocumentUploadMutationOptions = Apollo.BaseMutationOptions<DocumentUploadMutation, DocumentUploadMutationVariables>;
export const RequestDocumentDocument = gql`
    mutation RequestDocument($requestedDocumentList: [String]!, $potentialUserId: ID!) {
  requestDocument(requestedDocumentList: $requestedDocumentList, potentialUserId: $potentialUserId) {
    documentRequestSuccess
  }
}
    `;
export type RequestDocumentMutationFn = Apollo.MutationFunction<RequestDocumentMutation, RequestDocumentMutationVariables>;

/**
 * __useRequestDocumentMutation__
 *
 * To run a mutation, you first call `useRequestDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDocumentMutation, { data, loading, error }] = useRequestDocumentMutation({
 *   variables: {
 *      requestedDocumentList: // value for 'requestedDocumentList'
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useRequestDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RequestDocumentMutation, RequestDocumentMutationVariables>) {
        return Apollo.useMutation<RequestDocumentMutation, RequestDocumentMutationVariables>(RequestDocumentDocument, baseOptions);
      }
export type RequestDocumentMutationHookResult = ReturnType<typeof useRequestDocumentMutation>;
export type RequestDocumentMutationResult = Apollo.MutationResult<RequestDocumentMutation>;
export type RequestDocumentMutationOptions = Apollo.BaseMutationOptions<RequestDocumentMutation, RequestDocumentMutationVariables>;
export const SendConfirmationDocument = gql`
    mutation SendConfirmation($potentialUserId: ID!) {
  sendConfirmation(potentialUserId: $potentialUserId) {
    ok
  }
}
    `;
export type SendConfirmationMutationFn = Apollo.MutationFunction<SendConfirmationMutation, SendConfirmationMutationVariables>;

/**
 * __useSendConfirmationMutation__
 *
 * To run a mutation, you first call `useSendConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConfirmationMutation, { data, loading, error }] = useSendConfirmationMutation({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useSendConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SendConfirmationMutation, SendConfirmationMutationVariables>) {
        return Apollo.useMutation<SendConfirmationMutation, SendConfirmationMutationVariables>(SendConfirmationDocument, baseOptions);
      }
export type SendConfirmationMutationHookResult = ReturnType<typeof useSendConfirmationMutation>;
export type SendConfirmationMutationResult = Apollo.MutationResult<SendConfirmationMutation>;
export type SendConfirmationMutationOptions = Apollo.BaseMutationOptions<SendConfirmationMutation, SendConfirmationMutationVariables>;
export const SendDocumentsUploadConfirmationDocument = gql`
    mutation SendDocumentsUploadConfirmation($potentialUserId: ID!, $documentType: String) {
  sendDocumentsUploadConfirmation(potentialUserId: $potentialUserId, documentType: $documentType) {
    ok
  }
}
    `;
export type SendDocumentsUploadConfirmationMutationFn = Apollo.MutationFunction<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>;

/**
 * __useSendDocumentsUploadConfirmationMutation__
 *
 * To run a mutation, you first call `useSendDocumentsUploadConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentsUploadConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentsUploadConfirmationMutation, { data, loading, error }] = useSendDocumentsUploadConfirmationMutation({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useSendDocumentsUploadConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>) {
        return Apollo.useMutation<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>(SendDocumentsUploadConfirmationDocument, baseOptions);
      }
export type SendDocumentsUploadConfirmationMutationHookResult = ReturnType<typeof useSendDocumentsUploadConfirmationMutation>;
export type SendDocumentsUploadConfirmationMutationResult = Apollo.MutationResult<SendDocumentsUploadConfirmationMutation>;
export type SendDocumentsUploadConfirmationMutationOptions = Apollo.BaseMutationOptions<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>;
export const SaveHouseholdMembersDocument = gql`
    mutation SaveHouseholdMembers($potentialUserId: ID!, $householdMembers: [HouseholdMemberInputType!]!) {
  saveHouseholdMembers(potentialUserId: $potentialUserId, householdMembers: $householdMembers) {
    success
  }
}
    `;
export type SaveHouseholdMembersMutationFn = Apollo.MutationFunction<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>;

/**
 * __useSaveHouseholdMembersMutation__
 *
 * To run a mutation, you first call `useSaveHouseholdMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHouseholdMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHouseholdMembersMutation, { data, loading, error }] = useSaveHouseholdMembersMutation({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *      householdMembers: // value for 'householdMembers'
 *   },
 * });
 */
export function useSaveHouseholdMembersMutation(baseOptions?: Apollo.MutationHookOptions<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>) {
        return Apollo.useMutation<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>(SaveHouseholdMembersDocument, baseOptions);
      }
export type SaveHouseholdMembersMutationHookResult = ReturnType<typeof useSaveHouseholdMembersMutation>;
export type SaveHouseholdMembersMutationResult = Apollo.MutationResult<SaveHouseholdMembersMutation>;
export type SaveHouseholdMembersMutationOptions = Apollo.BaseMutationOptions<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>;
export const ListOfUploadedDocumentsDocument = gql`
    query listOfUploadedDocuments($id: ID!) {
  listOfUploadedDocuments(id: $id)
}
    `;

/**
 * __useListOfUploadedDocumentsQuery__
 *
 * To run a query within a React component, call `useListOfUploadedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfUploadedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfUploadedDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOfUploadedDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>) {
        return Apollo.useQuery<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>(ListOfUploadedDocumentsDocument, baseOptions);
      }
export function useListOfUploadedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>(ListOfUploadedDocumentsDocument, baseOptions);
        }
export type ListOfUploadedDocumentsQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsQuery>;
export type ListOfUploadedDocumentsLazyQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsLazyQuery>;
export type ListOfUploadedDocumentsQueryResult = Apollo.QueryResult<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>;
export const ListOfUploadedDocumentsIncludingNameDocument = gql`
    query listOfUploadedDocumentsIncludingName($id: ID!) {
  listOfUploadedDocumentsIncludingName(id: $id) {
    name
    documentType
  }
}
    `;

/**
 * __useListOfUploadedDocumentsIncludingNameQuery__
 *
 * To run a query within a React component, call `useListOfUploadedDocumentsIncludingNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfUploadedDocumentsIncludingNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfUploadedDocumentsIncludingNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOfUploadedDocumentsIncludingNameQuery(baseOptions?: Apollo.QueryHookOptions<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>) {
        return Apollo.useQuery<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>(ListOfUploadedDocumentsIncludingNameDocument, baseOptions);
      }
export function useListOfUploadedDocumentsIncludingNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>) {
          return Apollo.useLazyQuery<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>(ListOfUploadedDocumentsIncludingNameDocument, baseOptions);
        }
export type ListOfUploadedDocumentsIncludingNameQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsIncludingNameQuery>;
export type ListOfUploadedDocumentsIncludingNameLazyQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsIncludingNameLazyQuery>;
export type ListOfUploadedDocumentsIncludingNameQueryResult = Apollo.QueryResult<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>;
export const CountHouseholdMembersDocument = gql`
    query countHouseholdMembers($id: ID!) {
  countHouseholdMembers(potentialUserId: $id)
}
    `;

/**
 * __useCountHouseholdMembersQuery__
 *
 * To run a query within a React component, call `useCountHouseholdMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountHouseholdMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountHouseholdMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountHouseholdMembersQuery(baseOptions?: Apollo.QueryHookOptions<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>) {
        return Apollo.useQuery<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>(CountHouseholdMembersDocument, baseOptions);
      }
export function useCountHouseholdMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>) {
          return Apollo.useLazyQuery<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>(CountHouseholdMembersDocument, baseOptions);
        }
export type CountHouseholdMembersQueryHookResult = ReturnType<typeof useCountHouseholdMembersQuery>;
export type CountHouseholdMembersLazyQueryHookResult = ReturnType<typeof useCountHouseholdMembersLazyQuery>;
export type CountHouseholdMembersQueryResult = Apollo.QueryResult<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>;
export const AddressAutocompleteQueryDocument = gql`
    query AddressAutocompleteQuery($value: String) {
  addressAutocomplete(value: $value) {
    placeId
    description
  }
}
    `;

/**
 * __useAddressAutocompleteQueryQuery__
 *
 * To run a query within a React component, call `useAddressAutocompleteQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressAutocompleteQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressAutocompleteQueryQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAddressAutocompleteQueryQuery(baseOptions?: Apollo.QueryHookOptions<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>) {
        return Apollo.useQuery<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>(AddressAutocompleteQueryDocument, baseOptions);
      }
export function useAddressAutocompleteQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>) {
          return Apollo.useLazyQuery<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>(AddressAutocompleteQueryDocument, baseOptions);
        }
export type AddressAutocompleteQueryQueryHookResult = ReturnType<typeof useAddressAutocompleteQueryQuery>;
export type AddressAutocompleteQueryLazyQueryHookResult = ReturnType<typeof useAddressAutocompleteQueryLazyQuery>;
export type AddressAutocompleteQueryQueryResult = Apollo.QueryResult<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>;
export const AddressDetailsQueryDocument = gql`
    query AddressDetailsQuery($placeId: String) {
  addressDetails(placeId: $placeId) {
    address1
    city
    state
    postalCode
  }
}
    `;

/**
 * __useAddressDetailsQueryQuery__
 *
 * To run a query within a React component, call `useAddressDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressDetailsQueryQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useAddressDetailsQueryQuery(baseOptions?: Apollo.QueryHookOptions<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>) {
        return Apollo.useQuery<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>(AddressDetailsQueryDocument, baseOptions);
      }
export function useAddressDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>(AddressDetailsQueryDocument, baseOptions);
        }
export type AddressDetailsQueryQueryHookResult = ReturnType<typeof useAddressDetailsQueryQuery>;
export type AddressDetailsQueryLazyQueryHookResult = ReturnType<typeof useAddressDetailsQueryLazyQuery>;
export type AddressDetailsQueryQueryResult = Apollo.QueryResult<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>;
export const PasswordChangeDocument = gql`
    mutation PasswordChange($oldPassword: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordChange(oldPassword: $oldPassword, newPassword1: $newPassword1, newPassword2: $newPassword2) {
    success
    errors
  }
}
    `;
export type PasswordChangeMutationFn = Apollo.MutationFunction<PasswordChangeMutation, PasswordChangeMutationVariables>;

/**
 * __usePasswordChangeMutation__
 *
 * To run a mutation, you first call `usePasswordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordChangeMutation, { data, loading, error }] = usePasswordChangeMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function usePasswordChangeMutation(baseOptions?: Apollo.MutationHookOptions<PasswordChangeMutation, PasswordChangeMutationVariables>) {
        return Apollo.useMutation<PasswordChangeMutation, PasswordChangeMutationVariables>(PasswordChangeDocument, baseOptions);
      }
export type PasswordChangeMutationHookResult = ReturnType<typeof usePasswordChangeMutation>;
export type PasswordChangeMutationResult = Apollo.MutationResult<PasswordChangeMutation>;
export type PasswordChangeMutationOptions = Apollo.BaseMutationOptions<PasswordChangeMutation, PasswordChangeMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($documentId: ID!) {
  deleteDocument(documentId: $documentId) {
    ok
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, baseOptions);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const ApproveDocumentDocument = gql`
    mutation ApproveDocument($documentId: ID!, $adminId: ID!) {
  approveDocument(documentId: $documentId, adminId: $adminId) {
    ok
  }
}
    `;
export type ApproveDocumentMutationFn = Apollo.MutationFunction<ApproveDocumentMutation, ApproveDocumentMutationVariables>;

/**
 * __useApproveDocumentMutation__
 *
 * To run a mutation, you first call `useApproveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDocumentMutation, { data, loading, error }] = useApproveDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useApproveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDocumentMutation, ApproveDocumentMutationVariables>) {
        return Apollo.useMutation<ApproveDocumentMutation, ApproveDocumentMutationVariables>(ApproveDocumentDocument, baseOptions);
      }
export type ApproveDocumentMutationHookResult = ReturnType<typeof useApproveDocumentMutation>;
export type ApproveDocumentMutationResult = Apollo.MutationResult<ApproveDocumentMutation>;
export type ApproveDocumentMutationOptions = Apollo.BaseMutationOptions<ApproveDocumentMutation, ApproveDocumentMutationVariables>;
export const RequestSingleDocumentDocument = gql`
    mutation RequestSingleDocument($documentId: ID!, $potentialUserId: ID!) {
  requestSingleDocument(documentId: $documentId, potentialUserId: $potentialUserId) {
    ok
  }
}
    `;
export type RequestSingleDocumentMutationFn = Apollo.MutationFunction<RequestSingleDocumentMutation, RequestSingleDocumentMutationVariables>;

/**
 * __useRequestSingleDocumentMutation__
 *
 * To run a mutation, you first call `useRequestSingleDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSingleDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSingleDocumentMutation, { data, loading, error }] = useRequestSingleDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useRequestSingleDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RequestSingleDocumentMutation, RequestSingleDocumentMutationVariables>) {
        return Apollo.useMutation<RequestSingleDocumentMutation, RequestSingleDocumentMutationVariables>(RequestSingleDocumentDocument, baseOptions);
      }
export type RequestSingleDocumentMutationHookResult = ReturnType<typeof useRequestSingleDocumentMutation>;
export type RequestSingleDocumentMutationResult = Apollo.MutationResult<RequestSingleDocumentMutation>;
export type RequestSingleDocumentMutationOptions = Apollo.BaseMutationOptions<RequestSingleDocumentMutation, RequestSingleDocumentMutationVariables>;
export const SendDocumentReminderDocument = gql`
    mutation SendDocumentReminder($potentialUserId: ID!) {
  sendDocumentReminder(potentialUserId: $potentialUserId) {
    ok
  }
}
    `;
export type SendDocumentReminderMutationFn = Apollo.MutationFunction<SendDocumentReminderMutation, SendDocumentReminderMutationVariables>;

/**
 * __useSendDocumentReminderMutation__
 *
 * To run a mutation, you first call `useSendDocumentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentReminderMutation, { data, loading, error }] = useSendDocumentReminderMutation({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useSendDocumentReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendDocumentReminderMutation, SendDocumentReminderMutationVariables>) {
        return Apollo.useMutation<SendDocumentReminderMutation, SendDocumentReminderMutationVariables>(SendDocumentReminderDocument, baseOptions);
      }
export type SendDocumentReminderMutationHookResult = ReturnType<typeof useSendDocumentReminderMutation>;
export type SendDocumentReminderMutationResult = Apollo.MutationResult<SendDocumentReminderMutation>;
export type SendDocumentReminderMutationOptions = Apollo.BaseMutationOptions<SendDocumentReminderMutation, SendDocumentReminderMutationVariables>;
export const NotesDocument = gql`
    mutation Notes($note: String!, $potentialUser: ID!) {
  addNote(note: $note, potentialUser: $potentialUser) {
    ok
  }
}
    `;
export type NotesMutationFn = Apollo.MutationFunction<NotesMutation, NotesMutationVariables>;

/**
 * __useNotesMutation__
 *
 * To run a mutation, you first call `useNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesMutation, { data, loading, error }] = useNotesMutation({
 *   variables: {
 *      note: // value for 'note'
 *      potentialUser: // value for 'potentialUser'
 *   },
 * });
 */
export function useNotesMutation(baseOptions?: Apollo.MutationHookOptions<NotesMutation, NotesMutationVariables>) {
        return Apollo.useMutation<NotesMutation, NotesMutationVariables>(NotesDocument, baseOptions);
      }
export type NotesMutationHookResult = ReturnType<typeof useNotesMutation>;
export type NotesMutationResult = Apollo.MutationResult<NotesMutation>;
export type NotesMutationOptions = Apollo.BaseMutationOptions<NotesMutation, NotesMutationVariables>;
export const EditUserAndPotentialUserDocument = gql`
    mutation EditUserAndPotentialUser($email: String!, $phoneNumber: String!, $dob: String!, $firstName: String!, $lastName: String!, $addressLine1: String!, $city: String!, $state: String!, $postalCode: String!, $language: String!, $pk: ID!) {
  editUserAndPotentialUser(email: $email, phoneNumber: $phoneNumber, dob: $dob, firstName: $firstName, lastName: $lastName, addressLine1: $addressLine1, city: $city, state: $state, postalCode: $postalCode, language: $language, pk: $pk) {
    ok
  }
}
    `;
export type EditUserAndPotentialUserMutationFn = Apollo.MutationFunction<EditUserAndPotentialUserMutation, EditUserAndPotentialUserMutationVariables>;

/**
 * __useEditUserAndPotentialUserMutation__
 *
 * To run a mutation, you first call `useEditUserAndPotentialUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserAndPotentialUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserAndPotentialUserMutation, { data, loading, error }] = useEditUserAndPotentialUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      dob: // value for 'dob'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      addressLine1: // value for 'addressLine1'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *      language: // value for 'language'
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useEditUserAndPotentialUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserAndPotentialUserMutation, EditUserAndPotentialUserMutationVariables>) {
        return Apollo.useMutation<EditUserAndPotentialUserMutation, EditUserAndPotentialUserMutationVariables>(EditUserAndPotentialUserDocument, baseOptions);
      }
export type EditUserAndPotentialUserMutationHookResult = ReturnType<typeof useEditUserAndPotentialUserMutation>;
export type EditUserAndPotentialUserMutationResult = Apollo.MutationResult<EditUserAndPotentialUserMutation>;
export type EditUserAndPotentialUserMutationOptions = Apollo.BaseMutationOptions<EditUserAndPotentialUserMutation, EditUserAndPotentialUserMutationVariables>;
export const DocumentDocument = gql`
    query Document($id: ID) {
  document(id: $id) {
    document
    encoding
    name
  }
}
    `;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions?: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, baseOptions);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, baseOptions);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const AdminNotesDocument = gql`
    query AdminNotes($potentialUser: ID) {
  adminNotes(potentialUser: $potentialUser) {
    id
    createdAt
    note
    admin {
      email
    }
  }
}
    `;

/**
 * __useAdminNotesQuery__
 *
 * To run a query within a React component, call `useAdminNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNotesQuery({
 *   variables: {
 *      potentialUser: // value for 'potentialUser'
 *   },
 * });
 */
export function useAdminNotesQuery(baseOptions?: Apollo.QueryHookOptions<AdminNotesQuery, AdminNotesQueryVariables>) {
        return Apollo.useQuery<AdminNotesQuery, AdminNotesQueryVariables>(AdminNotesDocument, baseOptions);
      }
export function useAdminNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNotesQuery, AdminNotesQueryVariables>) {
          return Apollo.useLazyQuery<AdminNotesQuery, AdminNotesQueryVariables>(AdminNotesDocument, baseOptions);
        }
export type AdminNotesQueryHookResult = ReturnType<typeof useAdminNotesQuery>;
export type AdminNotesLazyQueryHookResult = ReturnType<typeof useAdminNotesLazyQuery>;
export type AdminNotesQueryResult = Apollo.QueryResult<AdminNotesQuery, AdminNotesQueryVariables>;
export const PolicyEngineDocument = gql`
    query PolicyEngine($id: ID) {
  policyEngineData(id: $id) {
    withGi
    withoutGi
    result
  }
}
    `;

/**
 * __usePolicyEngineQuery__
 *
 * To run a query within a React component, call `usePolicyEngineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyEngineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyEngineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePolicyEngineQuery(baseOptions?: Apollo.QueryHookOptions<PolicyEngineQuery, PolicyEngineQueryVariables>) {
        return Apollo.useQuery<PolicyEngineQuery, PolicyEngineQueryVariables>(PolicyEngineDocument, baseOptions);
      }
export function usePolicyEngineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyEngineQuery, PolicyEngineQueryVariables>) {
          return Apollo.useLazyQuery<PolicyEngineQuery, PolicyEngineQueryVariables>(PolicyEngineDocument, baseOptions);
        }
export type PolicyEngineQueryHookResult = ReturnType<typeof usePolicyEngineQuery>;
export type PolicyEngineLazyQueryHookResult = ReturnType<typeof usePolicyEngineLazyQuery>;
export type PolicyEngineQueryResult = Apollo.QueryResult<PolicyEngineQuery, PolicyEngineQueryVariables>;
export const BenefitsAnswersDocument = gql`
    mutation BenefitsAnswers($answers: [BenefitAnswerInputType!]!) {
  addBenefitAnswers(answers: $answers) {
    ok
    error
  }
}
    `;
export type BenefitsAnswersMutationFn = Apollo.MutationFunction<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>;

/**
 * __useBenefitsAnswersMutation__
 *
 * To run a mutation, you first call `useBenefitsAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitsAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitsAnswersMutation, { data, loading, error }] = useBenefitsAnswersMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useBenefitsAnswersMutation(baseOptions?: Apollo.MutationHookOptions<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>) {
        return Apollo.useMutation<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>(BenefitsAnswersDocument, baseOptions);
      }
export type BenefitsAnswersMutationHookResult = ReturnType<typeof useBenefitsAnswersMutation>;
export type BenefitsAnswersMutationResult = Apollo.MutationResult<BenefitsAnswersMutation>;
export type BenefitsAnswersMutationOptions = Apollo.BaseMutationOptions<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>;
export const BenefitsSelectionDocument = gql`
    mutation BenefitsSelection($benefits: [BenefitSelectedInputType!]!) {
  selectBenefits(benefits: $benefits) {
    ok
    error
  }
}
    `;
export type BenefitsSelectionMutationFn = Apollo.MutationFunction<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>;

/**
 * __useBenefitsSelectionMutation__
 *
 * To run a mutation, you first call `useBenefitsSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitsSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitsSelectionMutation, { data, loading, error }] = useBenefitsSelectionMutation({
 *   variables: {
 *      benefits: // value for 'benefits'
 *   },
 * });
 */
export function useBenefitsSelectionMutation(baseOptions?: Apollo.MutationHookOptions<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>) {
        return Apollo.useMutation<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>(BenefitsSelectionDocument, baseOptions);
      }
export type BenefitsSelectionMutationHookResult = ReturnType<typeof useBenefitsSelectionMutation>;
export type BenefitsSelectionMutationResult = Apollo.MutationResult<BenefitsSelectionMutation>;
export type BenefitsSelectionMutationOptions = Apollo.BaseMutationOptions<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>;
export const UpdateBlindDisabledDocument = gql`
    mutation UpdateBlindDisabled($blindDisabled: Boolean!, $inviteCode: String, $verificationCode: String) {
  updateBlindDisabled(inviteCode: $inviteCode, blindDisabled: $blindDisabled, verificationCode: $verificationCode) {
    ok
    error
  }
}
    `;
export type UpdateBlindDisabledMutationFn = Apollo.MutationFunction<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>;

/**
 * __useUpdateBlindDisabledMutation__
 *
 * To run a mutation, you first call `useUpdateBlindDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlindDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlindDisabledMutation, { data, loading, error }] = useUpdateBlindDisabledMutation({
 *   variables: {
 *      blindDisabled: // value for 'blindDisabled'
 *      inviteCode: // value for 'inviteCode'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useUpdateBlindDisabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>) {
        return Apollo.useMutation<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>(UpdateBlindDisabledDocument, baseOptions);
      }
export type UpdateBlindDisabledMutationHookResult = ReturnType<typeof useUpdateBlindDisabledMutation>;
export type UpdateBlindDisabledMutationResult = Apollo.MutationResult<UpdateBlindDisabledMutation>;
export type UpdateBlindDisabledMutationOptions = Apollo.BaseMutationOptions<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>;
export const BenefitsAnswerQueryDocument = gql`
    query BenefitsAnswerQuery($potentialUserId: ID!) {
  benefitsAnswers(potentialUserId: $potentialUserId) {
    answer
    householdMember {
      id
      name
      dob
      relation
      blindDisabled
    }
    category
  }
}
    `;

/**
 * __useBenefitsAnswerQueryQuery__
 *
 * To run a query within a React component, call `useBenefitsAnswerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsAnswerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsAnswerQueryQuery({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useBenefitsAnswerQueryQuery(baseOptions?: Apollo.QueryHookOptions<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>) {
        return Apollo.useQuery<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>(BenefitsAnswerQueryDocument, baseOptions);
      }
export function useBenefitsAnswerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>) {
          return Apollo.useLazyQuery<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>(BenefitsAnswerQueryDocument, baseOptions);
        }
export type BenefitsAnswerQueryQueryHookResult = ReturnType<typeof useBenefitsAnswerQueryQuery>;
export type BenefitsAnswerQueryLazyQueryHookResult = ReturnType<typeof useBenefitsAnswerQueryLazyQuery>;
export type BenefitsAnswerQueryQueryResult = Apollo.QueryResult<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>;
export const SelectedBenefitsQueryDocument = gql`
    query SelectedBenefitsQuery($potentialUserId: ID!) {
  selectedBenefits(potentialUserId: $potentialUserId) {
    category
  }
}
    `;

/**
 * __useSelectedBenefitsQueryQuery__
 *
 * To run a query within a React component, call `useSelectedBenefitsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedBenefitsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedBenefitsQueryQuery({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useSelectedBenefitsQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectedBenefitsQueryQuery, SelectedBenefitsQueryQueryVariables>) {
        return Apollo.useQuery<SelectedBenefitsQueryQuery, SelectedBenefitsQueryQueryVariables>(SelectedBenefitsQueryDocument, baseOptions);
      }
export function useSelectedBenefitsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedBenefitsQueryQuery, SelectedBenefitsQueryQueryVariables>) {
          return Apollo.useLazyQuery<SelectedBenefitsQueryQuery, SelectedBenefitsQueryQueryVariables>(SelectedBenefitsQueryDocument, baseOptions);
        }
export type SelectedBenefitsQueryQueryHookResult = ReturnType<typeof useSelectedBenefitsQueryQuery>;
export type SelectedBenefitsQueryLazyQueryHookResult = ReturnType<typeof useSelectedBenefitsQueryLazyQuery>;
export type SelectedBenefitsQueryQueryResult = Apollo.QueryResult<SelectedBenefitsQueryQuery, SelectedBenefitsQueryQueryVariables>;
export const GetApplicationDataDocument = gql`
    query GetApplicationData($inviteCode: String, $verificationCode: String) {
  potentialUserApplication(inviteCode: $inviteCode, verificationCode: $verificationCode) {
    firstName
    lastName
    dob
    blindDisabled
    householdMembers {
      id
      name
      dob
      relation
      blindDisabled
    }
  }
}
    `;

/**
 * __useGetApplicationDataQuery__
 *
 * To run a query within a React component, call `useGetApplicationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationDataQuery({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useGetApplicationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationDataQuery, GetApplicationDataQueryVariables>) {
        return Apollo.useQuery<GetApplicationDataQuery, GetApplicationDataQueryVariables>(GetApplicationDataDocument, baseOptions);
      }
export function useGetApplicationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationDataQuery, GetApplicationDataQueryVariables>) {
          return Apollo.useLazyQuery<GetApplicationDataQuery, GetApplicationDataQueryVariables>(GetApplicationDataDocument, baseOptions);
        }
export type GetApplicationDataQueryHookResult = ReturnType<typeof useGetApplicationDataQuery>;
export type GetApplicationDataLazyQueryHookResult = ReturnType<typeof useGetApplicationDataLazyQuery>;
export type GetApplicationDataQueryResult = Apollo.QueryResult<GetApplicationDataQuery, GetApplicationDataQueryVariables>;
export const GetCalendlyScheduledEventDocument = gql`
    query GetCalendlyScheduledEvent($potentialUserId: ID!) {
  scheduledEvent(potentialUserId: $potentialUserId) {
    createdAt
    name
    status
    startTime
    endTime
  }
}
    `;

/**
 * __useGetCalendlyScheduledEventQuery__
 *
 * To run a query within a React component, call `useGetCalendlyScheduledEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendlyScheduledEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendlyScheduledEventQuery({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useGetCalendlyScheduledEventQuery(baseOptions?: Apollo.QueryHookOptions<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>) {
        return Apollo.useQuery<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>(GetCalendlyScheduledEventDocument, baseOptions);
      }
export function useGetCalendlyScheduledEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>) {
          return Apollo.useLazyQuery<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>(GetCalendlyScheduledEventDocument, baseOptions);
        }
export type GetCalendlyScheduledEventQueryHookResult = ReturnType<typeof useGetCalendlyScheduledEventQuery>;
export type GetCalendlyScheduledEventLazyQueryHookResult = ReturnType<typeof useGetCalendlyScheduledEventLazyQuery>;
export type GetCalendlyScheduledEventQueryResult = Apollo.QueryResult<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>;
export const RegisterDocument = gql`
    mutation Register($email: String!, $password1: String!, $password2: String!, $inviteCode: String!, $phoneNumber: String!, $dob: String!, $language: String!, $securityQuestionQuestion: String!, $securityQuestionAnswer: String!, $program: String!) {
  register(email: $email, password1: $password1, password2: $password2, inviteCode: $inviteCode, language: $language, phoneNumber: $phoneNumber, dob: $dob, securityQuestionQuestion: $securityQuestionQuestion, securityQuestionAnswer: $securityQuestionAnswer, program: $program) {
    success
    errors
    token
    refreshToken
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *      inviteCode: // value for 'inviteCode'
 *      phoneNumber: // value for 'phoneNumber'
 *      dob: // value for 'dob'
 *      language: // value for 'language'
 *      securityQuestionQuestion: // value for 'securityQuestionQuestion'
 *      securityQuestionAnswer: // value for 'securityQuestionAnswer'
 *      program: // value for 'program'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, baseOptions);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const SaveSixDigitVerificationCodeForPotentialUserDocument = gql`
    mutation SaveSixDigitVerificationCodeForPotentialUser($potentialUserId: String!, $phoneNumber: String!) {
  saveSixDigitVerificationCodeForPotentialUser(potentialUserId: $potentialUserId, phoneNumber: $phoneNumber) {
    success
  }
}
    `;
export type SaveSixDigitVerificationCodeForPotentialUserMutationFn = Apollo.MutationFunction<SaveSixDigitVerificationCodeForPotentialUserMutation, SaveSixDigitVerificationCodeForPotentialUserMutationVariables>;

/**
 * __useSaveSixDigitVerificationCodeForPotentialUserMutation__
 *
 * To run a mutation, you first call `useSaveSixDigitVerificationCodeForPotentialUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSixDigitVerificationCodeForPotentialUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSixDigitVerificationCodeForPotentialUserMutation, { data, loading, error }] = useSaveSixDigitVerificationCodeForPotentialUserMutation({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSaveSixDigitVerificationCodeForPotentialUserMutation(baseOptions?: Apollo.MutationHookOptions<SaveSixDigitVerificationCodeForPotentialUserMutation, SaveSixDigitVerificationCodeForPotentialUserMutationVariables>) {
        return Apollo.useMutation<SaveSixDigitVerificationCodeForPotentialUserMutation, SaveSixDigitVerificationCodeForPotentialUserMutationVariables>(SaveSixDigitVerificationCodeForPotentialUserDocument, baseOptions);
      }
export type SaveSixDigitVerificationCodeForPotentialUserMutationHookResult = ReturnType<typeof useSaveSixDigitVerificationCodeForPotentialUserMutation>;
export type SaveSixDigitVerificationCodeForPotentialUserMutationResult = Apollo.MutationResult<SaveSixDigitVerificationCodeForPotentialUserMutation>;
export type SaveSixDigitVerificationCodeForPotentialUserMutationOptions = Apollo.BaseMutationOptions<SaveSixDigitVerificationCodeForPotentialUserMutation, SaveSixDigitVerificationCodeForPotentialUserMutationVariables>;
export const CheckSixDigitVerificationCodeForPotentialUserDocument = gql`
    mutation CheckSixDigitVerificationCodeForPotentialUser($potentialUserId: String!, $verificationCode: String!) {
  checkSixDigitVerificationCodeForPotentialUser(potentialUserId: $potentialUserId, verificationCode: $verificationCode) {
    success
  }
}
    `;
export type CheckSixDigitVerificationCodeForPotentialUserMutationFn = Apollo.MutationFunction<CheckSixDigitVerificationCodeForPotentialUserMutation, CheckSixDigitVerificationCodeForPotentialUserMutationVariables>;

/**
 * __useCheckSixDigitVerificationCodeForPotentialUserMutation__
 *
 * To run a mutation, you first call `useCheckSixDigitVerificationCodeForPotentialUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckSixDigitVerificationCodeForPotentialUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkSixDigitVerificationCodeForPotentialUserMutation, { data, loading, error }] = useCheckSixDigitVerificationCodeForPotentialUserMutation({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useCheckSixDigitVerificationCodeForPotentialUserMutation(baseOptions?: Apollo.MutationHookOptions<CheckSixDigitVerificationCodeForPotentialUserMutation, CheckSixDigitVerificationCodeForPotentialUserMutationVariables>) {
        return Apollo.useMutation<CheckSixDigitVerificationCodeForPotentialUserMutation, CheckSixDigitVerificationCodeForPotentialUserMutationVariables>(CheckSixDigitVerificationCodeForPotentialUserDocument, baseOptions);
      }
export type CheckSixDigitVerificationCodeForPotentialUserMutationHookResult = ReturnType<typeof useCheckSixDigitVerificationCodeForPotentialUserMutation>;
export type CheckSixDigitVerificationCodeForPotentialUserMutationResult = Apollo.MutationResult<CheckSixDigitVerificationCodeForPotentialUserMutation>;
export type CheckSixDigitVerificationCodeForPotentialUserMutationOptions = Apollo.BaseMutationOptions<CheckSixDigitVerificationCodeForPotentialUserMutation, CheckSixDigitVerificationCodeForPotentialUserMutationVariables>;
export const OnboardingLogosDocument = gql`
    query OnboardingLogos($id: ID!) {
  onboardingLogos(id: $id) {
    position
    image
    url
  }
}
    `;

/**
 * __useOnboardingLogosQuery__
 *
 * To run a query within a React component, call `useOnboardingLogosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingLogosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingLogosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnboardingLogosQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingLogosQuery, OnboardingLogosQueryVariables>) {
        return Apollo.useQuery<OnboardingLogosQuery, OnboardingLogosQueryVariables>(OnboardingLogosDocument, baseOptions);
      }
export function useOnboardingLogosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingLogosQuery, OnboardingLogosQueryVariables>) {
          return Apollo.useLazyQuery<OnboardingLogosQuery, OnboardingLogosQueryVariables>(OnboardingLogosDocument, baseOptions);
        }
export type OnboardingLogosQueryHookResult = ReturnType<typeof useOnboardingLogosQuery>;
export type OnboardingLogosLazyQueryHookResult = ReturnType<typeof useOnboardingLogosLazyQuery>;
export type OnboardingLogosQueryResult = Apollo.QueryResult<OnboardingLogosQuery, OnboardingLogosQueryVariables>;
export const SpeakBenefitsCounselorDocument = gql`
    mutation SpeakBenefitsCounselor($firstName: String!, $language: String!, $phoneNumber: String!, $email: String!, $potentialUserId: ID!) {
  speakBenefitsCounselor(firstName: $firstName, language: $language, phoneNumber: $phoneNumber, email: $email, potentialUserId: $potentialUserId) {
    ok
  }
}
    `;
export type SpeakBenefitsCounselorMutationFn = Apollo.MutationFunction<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>;

/**
 * __useSpeakBenefitsCounselorMutation__
 *
 * To run a mutation, you first call `useSpeakBenefitsCounselorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpeakBenefitsCounselorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [speakBenefitsCounselorMutation, { data, loading, error }] = useSpeakBenefitsCounselorMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      language: // value for 'language'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useSpeakBenefitsCounselorMutation(baseOptions?: Apollo.MutationHookOptions<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>) {
        return Apollo.useMutation<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>(SpeakBenefitsCounselorDocument, baseOptions);
      }
export type SpeakBenefitsCounselorMutationHookResult = ReturnType<typeof useSpeakBenefitsCounselorMutation>;
export type SpeakBenefitsCounselorMutationResult = Apollo.MutationResult<SpeakBenefitsCounselorMutation>;
export type SpeakBenefitsCounselorMutationOptions = Apollo.BaseMutationOptions<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>;
export const CodeValidationDocument = gql`
    query CodeValidation($inviteCode: String, $resetToken: String, $verificationCode: String) {
  codeValidation(inviteCode: $inviteCode, resetToken: $resetToken, verificationCode: $verificationCode) {
    alreadySignedUp
    potentialUser {
      ...PotentialUser
    }
  }
}
    ${PotentialUserFragmentDoc}`;

/**
 * __useCodeValidationQuery__
 *
 * To run a query within a React component, call `useCodeValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeValidationQuery({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *      resetToken: // value for 'resetToken'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useCodeValidationQuery(baseOptions?: Apollo.QueryHookOptions<CodeValidationQuery, CodeValidationQueryVariables>) {
        return Apollo.useQuery<CodeValidationQuery, CodeValidationQueryVariables>(CodeValidationDocument, baseOptions);
      }
export function useCodeValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodeValidationQuery, CodeValidationQueryVariables>) {
          return Apollo.useLazyQuery<CodeValidationQuery, CodeValidationQueryVariables>(CodeValidationDocument, baseOptions);
        }
export type CodeValidationQueryHookResult = ReturnType<typeof useCodeValidationQuery>;
export type CodeValidationLazyQueryHookResult = ReturnType<typeof useCodeValidationLazyQuery>;
export type CodeValidationQueryResult = Apollo.QueryResult<CodeValidationQuery, CodeValidationQueryVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
    errors
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, baseOptions);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const MyRecentPaymentsDocument = gql`
    query MyRecentPayments {
  myRecentPayments {
    id
    destination {
      oneLiner
      halfLiner
      type
    }
    amount
    createdAt
    status
  }
}
    `;

/**
 * __useMyRecentPaymentsQuery__
 *
 * To run a query within a React component, call `useMyRecentPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRecentPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRecentPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRecentPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>) {
        return Apollo.useQuery<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>(MyRecentPaymentsDocument, baseOptions);
      }
export function useMyRecentPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>) {
          return Apollo.useLazyQuery<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>(MyRecentPaymentsDocument, baseOptions);
        }
export type MyRecentPaymentsQueryHookResult = ReturnType<typeof useMyRecentPaymentsQuery>;
export type MyRecentPaymentsLazyQueryHookResult = ReturnType<typeof useMyRecentPaymentsLazyQuery>;
export type MyRecentPaymentsQueryResult = Apollo.QueryResult<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>;
export const MyUpcomingPaymentDocument = gql`
    query MyUpcomingPayment {
  myUpcomingPayment {
    id
    scheduledDate
    amount
  }
}
    `;

/**
 * __useMyUpcomingPaymentQuery__
 *
 * To run a query within a React component, call `useMyUpcomingPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUpcomingPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUpcomingPaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyUpcomingPaymentQuery(baseOptions?: Apollo.QueryHookOptions<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>) {
        return Apollo.useQuery<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>(MyUpcomingPaymentDocument, baseOptions);
      }
export function useMyUpcomingPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>) {
          return Apollo.useLazyQuery<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>(MyUpcomingPaymentDocument, baseOptions);
        }
export type MyUpcomingPaymentQueryHookResult = ReturnType<typeof useMyUpcomingPaymentQuery>;
export type MyUpcomingPaymentLazyQueryHookResult = ReturnType<typeof useMyUpcomingPaymentLazyQuery>;
export type MyUpcomingPaymentQueryResult = Apollo.QueryResult<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>;
export const StylesDocument = gql`
    query Styles {
  styles {
    primaryColor
    secondaryColor
    tertiaryColor
    hoverColor
    backgroundColor
    sidebarLogo
    sidebarLogoMobile
    sidebarImage
  }
}
    `;

/**
 * __useStylesQuery__
 *
 * To run a query within a React component, call `useStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStylesQuery(baseOptions?: Apollo.QueryHookOptions<StylesQuery, StylesQueryVariables>) {
        return Apollo.useQuery<StylesQuery, StylesQueryVariables>(StylesDocument, baseOptions);
      }
export function useStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StylesQuery, StylesQueryVariables>) {
          return Apollo.useLazyQuery<StylesQuery, StylesQueryVariables>(StylesDocument, baseOptions);
        }
export type StylesQueryHookResult = ReturnType<typeof useStylesQuery>;
export type StylesLazyQueryHookResult = ReturnType<typeof useStylesLazyQuery>;
export type StylesQueryResult = Apollo.QueryResult<StylesQuery, StylesQueryVariables>;
export const CardBalanceDocument = gql`
    query CardBalance($id: ID) {
  cardBalance(id: $id)
}
    `;

/**
 * __useCardBalanceQuery__
 *
 * To run a query within a React component, call `useCardBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardBalanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCardBalanceQuery(baseOptions?: Apollo.QueryHookOptions<CardBalanceQuery, CardBalanceQueryVariables>) {
        return Apollo.useQuery<CardBalanceQuery, CardBalanceQueryVariables>(CardBalanceDocument, baseOptions);
      }
export function useCardBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardBalanceQuery, CardBalanceQueryVariables>) {
          return Apollo.useLazyQuery<CardBalanceQuery, CardBalanceQueryVariables>(CardBalanceDocument, baseOptions);
        }
export type CardBalanceQueryHookResult = ReturnType<typeof useCardBalanceQuery>;
export type CardBalanceLazyQueryHookResult = ReturnType<typeof useCardBalanceLazyQuery>;
export type CardBalanceQueryResult = Apollo.QueryResult<CardBalanceQuery, CardBalanceQueryVariables>;
export const GetInitialDataDocument = gql`
    query GetInitialData {
  program {
    name
    paymentFrequency
    paymentAmount
    programDuration
    numberOfMonths
    ssiBenefitsWizardEnabled
    id
    urlFragment
  }
  organizationConfigs {
    facebookLink
    instagramLink
    phoneNumber
    replyToEmail
    timezone
    twitterLink
    typeformId
    typeformSubdomain
    websiteLink
    isTypeformBound
    whatsappPhoneNumber
  }
  organization {
    version
    webAppUrl
    name
    id
  }
  translations
  documentRequirement {
    type
    required
  }
}
    `;

/**
 * __useGetInitialDataQuery__
 *
 * To run a query within a React component, call `useGetInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataQuery, GetInitialDataQueryVariables>) {
        return Apollo.useQuery<GetInitialDataQuery, GetInitialDataQueryVariables>(GetInitialDataDocument, baseOptions);
      }
export function useGetInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataQuery, GetInitialDataQueryVariables>) {
          return Apollo.useLazyQuery<GetInitialDataQuery, GetInitialDataQueryVariables>(GetInitialDataDocument, baseOptions);
        }
export type GetInitialDataQueryHookResult = ReturnType<typeof useGetInitialDataQuery>;
export type GetInitialDataLazyQueryHookResult = ReturnType<typeof useGetInitialDataLazyQuery>;
export type GetInitialDataQueryResult = Apollo.QueryResult<GetInitialDataQuery, GetInitialDataQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  tokenAuth(email: $email, password: $password) {
    success
    token
    refreshToken
    errors
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, baseOptions);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($token: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordReset(token: $token, newPassword1: $newPassword1, newPassword2: $newPassword2) {
    success
    errors
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, baseOptions);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($transferMethodId: ID!, $emailNotificationsEnabled: Boolean!, $smsNotificationsEnabled: Boolean!, $optedForWhatsapp: Boolean!, $email: String, $phoneNumber: String) {
  updateSettings(transferMethodId: $transferMethodId, emailNotificationsEnabled: $emailNotificationsEnabled, smsNotificationsEnabled: $smsNotificationsEnabled, optedForWhatsapp: $optedForWhatsapp, phoneNumber: $phoneNumber, email: $email) {
    user {
      ...SettingsPageUser
    }
    error {
      ...FieldError
    }
  }
}
    ${SettingsPageUserFragmentDoc}
${FieldErrorFragmentDoc}`;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      transferMethodId: // value for 'transferMethodId'
 *      emailNotificationsEnabled: // value for 'emailNotificationsEnabled'
 *      smsNotificationsEnabled: // value for 'smsNotificationsEnabled'
 *      optedForWhatsapp: // value for 'optedForWhatsapp'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, baseOptions);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const SettingsPageDocument = gql`
    query SettingsPage {
  me {
    ...SettingsPageUser
  }
}
    ${SettingsPageUserFragmentDoc}`;

/**
 * __useSettingsPageQuery__
 *
 * To run a query within a React component, call `useSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsPageQuery(baseOptions?: Apollo.QueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
        return Apollo.useQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, baseOptions);
      }
export function useSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
          return Apollo.useLazyQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, baseOptions);
        }
export type SettingsPageQueryHookResult = ReturnType<typeof useSettingsPageQuery>;
export type SettingsPageLazyQueryHookResult = ReturnType<typeof useSettingsPageLazyQuery>;
export type SettingsPageQueryResult = Apollo.QueryResult<SettingsPageQuery, SettingsPageQueryVariables>;
export const CheckReachedVerifyScreenDocument = gql`
    mutation CheckReachedVerifyScreen($potentialUserId: ID!) {
  checkReachedVerifyScreen(potentialUserId: $potentialUserId) {
    success
  }
}
    `;
export type CheckReachedVerifyScreenMutationFn = Apollo.MutationFunction<CheckReachedVerifyScreenMutation, CheckReachedVerifyScreenMutationVariables>;

/**
 * __useCheckReachedVerifyScreenMutation__
 *
 * To run a mutation, you first call `useCheckReachedVerifyScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckReachedVerifyScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkReachedVerifyScreenMutation, { data, loading, error }] = useCheckReachedVerifyScreenMutation({
 *   variables: {
 *      potentialUserId: // value for 'potentialUserId'
 *   },
 * });
 */
export function useCheckReachedVerifyScreenMutation(baseOptions?: Apollo.MutationHookOptions<CheckReachedVerifyScreenMutation, CheckReachedVerifyScreenMutationVariables>) {
        return Apollo.useMutation<CheckReachedVerifyScreenMutation, CheckReachedVerifyScreenMutationVariables>(CheckReachedVerifyScreenDocument, baseOptions);
      }
export type CheckReachedVerifyScreenMutationHookResult = ReturnType<typeof useCheckReachedVerifyScreenMutation>;
export type CheckReachedVerifyScreenMutationResult = Apollo.MutationResult<CheckReachedVerifyScreenMutation>;
export type CheckReachedVerifyScreenMutationOptions = Apollo.BaseMutationOptions<CheckReachedVerifyScreenMutation, CheckReachedVerifyScreenMutationVariables>;
export const GetPotentialUserWithHashedIdDocument = gql`
    query GetPotentialUserWithHashedId($hashedId: String!) {
  potentialUserWithHashedId(hashedId: $hashedId) {
    id
    firstName
    lastName
    phoneNumber
    paymentAmount
    email
    createdAt
    updatedAt
    isLocked
    addressLine1
    inviteCode
    dob
    addressLine2
    city
    state
    country
    applicationStatus
    postalCode
    medianHouseholdIncome
    language
    tractCode
    reachedVerifyScreen
    pk
    selectedFor
    ssiBenefitAnswers {
      edges {
        node {
          answer
          category
          householdMember {
            id
          }
        }
      }
    }
    blindDisabled
    documents {
      edges {
        node {
          id
          documentType
          name
          updatedAt
          createdAt
          verifiedBy {
            firstName
            lastName
            email
          }
          uploadedAt
          requestedAs
        }
      }
    }
    answers {
      edges {
        node {
          answerCategory
          response
        }
      }
    }
  }
}
    `;

/**
 * __useGetPotentialUserWithHashedIdQuery__
 *
 * To run a query within a React component, call `useGetPotentialUserWithHashedIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPotentialUserWithHashedIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPotentialUserWithHashedIdQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useGetPotentialUserWithHashedIdQuery(baseOptions?: Apollo.QueryHookOptions<GetPotentialUserWithHashedIdQuery, GetPotentialUserWithHashedIdQueryVariables>) {
        return Apollo.useQuery<GetPotentialUserWithHashedIdQuery, GetPotentialUserWithHashedIdQueryVariables>(GetPotentialUserWithHashedIdDocument, baseOptions);
      }
export function useGetPotentialUserWithHashedIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPotentialUserWithHashedIdQuery, GetPotentialUserWithHashedIdQueryVariables>) {
          return Apollo.useLazyQuery<GetPotentialUserWithHashedIdQuery, GetPotentialUserWithHashedIdQueryVariables>(GetPotentialUserWithHashedIdDocument, baseOptions);
        }
export type GetPotentialUserWithHashedIdQueryHookResult = ReturnType<typeof useGetPotentialUserWithHashedIdQuery>;
export type GetPotentialUserWithHashedIdLazyQueryHookResult = ReturnType<typeof useGetPotentialUserWithHashedIdLazyQuery>;
export type GetPotentialUserWithHashedIdQueryResult = Apollo.QueryResult<GetPotentialUserWithHashedIdQuery, GetPotentialUserWithHashedIdQueryVariables>;
export const GetUserAnswersDocument = gql`
    query GetUserAnswers($id: ID!, $forType: String!) {
  userAnswers(id: $id, forType: $forType) {
    response
  }
}
    `;

/**
 * __useGetUserAnswersQuery__
 *
 * To run a query within a React component, call `useGetUserAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAnswersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      forType: // value for 'forType'
 *   },
 * });
 */
export function useGetUserAnswersQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAnswersQuery, GetUserAnswersQueryVariables>) {
        return Apollo.useQuery<GetUserAnswersQuery, GetUserAnswersQueryVariables>(GetUserAnswersDocument, baseOptions);
      }
export function useGetUserAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAnswersQuery, GetUserAnswersQueryVariables>) {
          return Apollo.useLazyQuery<GetUserAnswersQuery, GetUserAnswersQueryVariables>(GetUserAnswersDocument, baseOptions);
        }
export type GetUserAnswersQueryHookResult = ReturnType<typeof useGetUserAnswersQuery>;
export type GetUserAnswersLazyQueryHookResult = ReturnType<typeof useGetUserAnswersLazyQuery>;
export type GetUserAnswersQueryResult = Apollo.QueryResult<GetUserAnswersQuery, GetUserAnswersQueryVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    token
    payload
    success
    errors
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, baseOptions);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const UpdateDetailsDocument = gql`
    mutation UpdateDetails($firstName: String, $lastName: String, $phoneNumber: String, $dob: String, $addressLine1: String, $addressLine2: String, $city: String, $state: String, $postalCode: String) {
  updateDetails(firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, dob: $dob, addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, postalCode: $postalCode) {
    success
  }
}
    `;
export type UpdateDetailsMutationFn = Apollo.MutationFunction<UpdateDetailsMutation, UpdateDetailsMutationVariables>;

/**
 * __useUpdateDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetailsMutation, { data, loading, error }] = useUpdateDetailsMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      dob: // value for 'dob'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useUpdateDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetailsMutation, UpdateDetailsMutationVariables>) {
        return Apollo.useMutation<UpdateDetailsMutation, UpdateDetailsMutationVariables>(UpdateDetailsDocument, baseOptions);
      }
export type UpdateDetailsMutationHookResult = ReturnType<typeof useUpdateDetailsMutation>;
export type UpdateDetailsMutationResult = Apollo.MutationResult<UpdateDetailsMutation>;
export type UpdateDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateDetailsMutation, UpdateDetailsMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    ok
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MakePaymentsDocument = gql`
    mutation MakePayments($scheduledPaymentIds: [ID]!) {
  makepayments(scheduledPaymentIds: $scheduledPaymentIds) {
    ok
  }
}
    `;
export type MakePaymentsMutationFn = Apollo.MutationFunction<MakePaymentsMutation, MakePaymentsMutationVariables>;

/**
 * __useMakePaymentsMutation__
 *
 * To run a mutation, you first call `useMakePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePaymentsMutation, { data, loading, error }] = useMakePaymentsMutation({
 *   variables: {
 *      scheduledPaymentIds: // value for 'scheduledPaymentIds'
 *   },
 * });
 */
export function useMakePaymentsMutation(baseOptions?: Apollo.MutationHookOptions<MakePaymentsMutation, MakePaymentsMutationVariables>) {
        return Apollo.useMutation<MakePaymentsMutation, MakePaymentsMutationVariables>(MakePaymentsDocument, baseOptions);
      }
export type MakePaymentsMutationHookResult = ReturnType<typeof useMakePaymentsMutation>;
export type MakePaymentsMutationResult = Apollo.MutationResult<MakePaymentsMutation>;
export type MakePaymentsMutationOptions = Apollo.BaseMutationOptions<MakePaymentsMutation, MakePaymentsMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    usioToken
    hyperwalletToken
    phoneNumber
    email
    createdAt
    pk
    isSuperuser
    organization {
      id
      name
    }
    dob
    smsNotificationsEnabled
    emailNotificationsEnabled
    optedForWhatsapp
    paymentAmount
    language
    paymentFrequencyType
    ...TransferMethods
    potentialUser {
      addressLine1
      addressLine2
      city
      postalCode
      state
      id
      intercomKey
      program {
        id
        urlFragment
      }
      numberOfMonths
      language
    }
  }
}
    ${TransferMethodsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const SurveyAvailableDocument = gql`
    query SurveyAvailable {
  surveyAvailable
}
    `;

/**
 * __useSurveyAvailableQuery__
 *
 * To run a query within a React component, call `useSurveyAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyAvailableQuery({
 *   variables: {
 *   },
 * });
 */
export function useSurveyAvailableQuery(baseOptions?: Apollo.QueryHookOptions<SurveyAvailableQuery, SurveyAvailableQueryVariables>) {
        return Apollo.useQuery<SurveyAvailableQuery, SurveyAvailableQueryVariables>(SurveyAvailableDocument, baseOptions);
      }
export function useSurveyAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyAvailableQuery, SurveyAvailableQueryVariables>) {
          return Apollo.useLazyQuery<SurveyAvailableQuery, SurveyAvailableQueryVariables>(SurveyAvailableDocument, baseOptions);
        }
export type SurveyAvailableQueryHookResult = ReturnType<typeof useSurveyAvailableQuery>;
export type SurveyAvailableLazyQueryHookResult = ReturnType<typeof useSurveyAvailableLazyQuery>;
export type SurveyAvailableQueryResult = Apollo.QueryResult<SurveyAvailableQuery, SurveyAvailableQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    firstName
    lastName
    pk
    phoneNumber
    paymentAmount
    paymentFrequencyType
    language
    startDate
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const OrganizationConfigsDocument = gql`
    query OrganizationConfigs {
  organizationConfigs {
    replyToEmail
    phoneNumber
    timezone
    isTypeformBound
    typeformId
    typeformSubdomain
    websiteLink
    instagramLink
    twitterLink
    facebookLink
  }
}
    `;

/**
 * __useOrganizationConfigsQuery__
 *
 * To run a query within a React component, call `useOrganizationConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationConfigsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationConfigsQuery, OrganizationConfigsQueryVariables>) {
        return Apollo.useQuery<OrganizationConfigsQuery, OrganizationConfigsQueryVariables>(OrganizationConfigsDocument, baseOptions);
      }
export function useOrganizationConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationConfigsQuery, OrganizationConfigsQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationConfigsQuery, OrganizationConfigsQueryVariables>(OrganizationConfigsDocument, baseOptions);
        }
export type OrganizationConfigsQueryHookResult = ReturnType<typeof useOrganizationConfigsQuery>;
export type OrganizationConfigsLazyQueryHookResult = ReturnType<typeof useOrganizationConfigsLazyQuery>;
export type OrganizationConfigsQueryResult = Apollo.QueryResult<OrganizationConfigsQuery, OrganizationConfigsQueryVariables>;
export const OrganizationDocument = gql`
    query Organization {
  organization {
    version
    name
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, baseOptions);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, baseOptions);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const ProgramDocument = gql`
    query Program {
  program {
    name
    paymentFrequency
    paymentAmount
    urlFragment
    programDuration
  }
}
    `;

/**
 * __useProgramQuery__
 *
 * To run a query within a React component, call `useProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramQuery(baseOptions?: Apollo.QueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
        return Apollo.useQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, baseOptions);
      }
export function useProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
          return Apollo.useLazyQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, baseOptions);
        }
export type ProgramQueryHookResult = ReturnType<typeof useProgramQuery>;
export type ProgramLazyQueryHookResult = ReturnType<typeof useProgramLazyQuery>;
export type ProgramQueryResult = Apollo.QueryResult<ProgramQuery, ProgramQueryVariables>;
export const TransferMethodRemoveDocument = gql`
    mutation transferMethodRemove($id: ID!) {
  transferMethodRemove(id: $id) {
    user {
      id
    }
  }
}
    `;
export type TransferMethodRemoveMutationFn = Apollo.MutationFunction<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>;

/**
 * __useTransferMethodRemoveMutation__
 *
 * To run a mutation, you first call `useTransferMethodRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodRemoveMutation, { data, loading, error }] = useTransferMethodRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransferMethodRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>) {
        return Apollo.useMutation<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>(TransferMethodRemoveDocument, baseOptions);
      }
export type TransferMethodRemoveMutationHookResult = ReturnType<typeof useTransferMethodRemoveMutation>;
export type TransferMethodRemoveMutationResult = Apollo.MutationResult<TransferMethodRemoveMutation>;
export type TransferMethodRemoveMutationOptions = Apollo.BaseMutationOptions<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>;
export const FaqNinjaWizardTypeDocument = gql`
    query FaqNinjaWizardType($language: String!) {
  ninjaWizardData(language: $language) {
    id
    ninjaCode
    language
    org {
      name
    }
  }
}
    `;

/**
 * __useFaqNinjaWizardTypeQuery__
 *
 * To run a query within a React component, call `useFaqNinjaWizardTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqNinjaWizardTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqNinjaWizardTypeQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useFaqNinjaWizardTypeQuery(baseOptions?: Apollo.QueryHookOptions<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>) {
        return Apollo.useQuery<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>(FaqNinjaWizardTypeDocument, baseOptions);
      }
export function useFaqNinjaWizardTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>) {
          return Apollo.useLazyQuery<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>(FaqNinjaWizardTypeDocument, baseOptions);
        }
export type FaqNinjaWizardTypeQueryHookResult = ReturnType<typeof useFaqNinjaWizardTypeQuery>;
export type FaqNinjaWizardTypeLazyQueryHookResult = ReturnType<typeof useFaqNinjaWizardTypeLazyQuery>;
export type FaqNinjaWizardTypeQueryResult = Apollo.QueryResult<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>;